var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DatePipe } from '@angular/common';
import { ElementRef, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { orderBy, sortBy } from 'lodash';
import * as moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal/bs-modal.service';
import { CookieService } from 'ngx-cookie-service';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { NgProgress } from 'ngx-progressbar';
import { error } from 'util';
import { environment } from '../../../environments/environment';
import { ContactTypeConstants } from '../../common/constants/contact-type.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { AccountRestrictionStatus } from '../../common/enums/account-restricted.enum';
import { ContactTypeValue } from '../../common/enums/contact-type.value.enum';
import { MemberPreferenceType } from '../../common/enums/member-preference.enum';
import { Permission } from '../../common/enums/permission.enum';
import { PreferenceValues } from '../../common/enums/preference-value.enum';
import { DistributorIdFormatPipe } from '../../common/pipes/distributor-id-format.pipe';
import { TranslateKey } from '../../common/pipes/translate-key.pipe';
import { MemberActivityLogType, RowStatus } from '../../shared/common/enumerations';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../shared/constants/common.constants';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { DataShareService } from '../../shared/services/data.service';
import { MessageService } from '../../shared/services/message.service';
import { CustomValidators } from '../../shared/Utils/custom-validator';
import { DuplicateGovernmentIdValidator } from '../../shared/Utils/duplicate-government-id-validator';
import { Utils } from '../../shared/Utils/utils';
import { EncryptionService } from '../../sso/encryption.service';
import { AllowDivElement, AllowIDAttribute } from '../ckeditor5/src/CustomCKEditor';
import { CommonMessage } from '../common/common-messages';
import { BusinessEntityType, Constants, DefaultProfileImage, GovernmentIDType, IsoCodeThree, PCSponsorConstants, MemberNoteType, MemberOrderType, MemberType, UserTitleType } from '../common/constants';
import { BusinessEntityIdType, MemberLevel, MemberStatusId } from '../common/enumerations';
import { ComposeEmailTicketConstants } from '../constants/compose-email.constants';
import { DateConstants } from '../constants/date.constants';
import { Flp360StatusConstants } from '../constants/flp360-status.constants';
import { IdentificationTypeConstant } from '../constants/identification-type.constant';
import { ImpersonateUserConstants } from '../constants/impersonate-user.constants';
import { PersonalInfoFormConstants } from '../constants/personal-info-form-property.constants';
import { ResponseStatus } from '../constants/response-status-constants';
import { StatusConstants } from '../constants/status.constants';
import { PhoneUpdateMessageConstants } from '../constants/update-phone-message.contants';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { Department } from '../enums/department-type.enum';
import { DisplaySectionId, Portal } from '../enums/document-library-member-id.enum';
import { Flp360Status } from '../enums/flp360-status.enum';
import { GovernmentIdentificationType } from '../enums/government-identification-type.enum';
import { MemberActivity } from '../enums/member-activity-type.enum';
import { MemberStatus } from '../enums/member-status.enum';
import { MemberTitleExtEnums } from '../enums/member-title.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { SubscriptionStatusEnum } from '../enums/subscription-status.enum';
import { NotificationType } from '../enums/notification-types.enum';
import { AddressType, PaymentType } from '../enums/order-source-type';
import { RetailSubscriptionErrorMessages, RetailSubscriptionMessages, StoreRetailSubscriptionEnum } from '../enums/retail-subscription.enum';
import { SelectEnum } from '../enums/selection.enum';
import { SponsorChangeType, SponsorType } from '../enums/sponsor-change-type.enum';
import { SponsorSearchOption } from '../enums/sponsor-search-option.enum';
import { Status } from '../enums/ticket-status.enum';
import { Priority, SourceType } from '../enums/ticket-type.enum';
import { VatPayerOption } from '../enums/vat_payer_option.enum';
import { AddressInformation } from '../interface/address-detail-info';
import { AutoshipMemberInfo } from '../interface/autoship-memberinfo';
import { CCSnapshot } from '../interface/cc-snapshot';
import { FBOBusinessEntity } from '../interface/fbo-business-entity';
import { MemberLevelInfo } from '../interface/member-level-info';
import { ProfileInformation } from '../interface/profile-info';
import { SnapshotDetails } from '../interface/snapshot-details';
import { SponsorInformation } from '../interface/sponsor-information';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { AccountModel } from '../models/account-model';
import { MemberLevelModel } from '../models/member-level-model';
import { memberWholesaleQualifiedRequestModel } from '../models/memberTypeorLevel-model';
import { PaymentComponentSettings } from '../models/payments/payment.model';
import { UnLockInfoModel } from '../models/unLock-info-model';
import { UnLockRequest } from '../models/unLock-Request';
import { AchService } from '../services/ach.service';
import { AppConfigService } from '../services/app-config.service';
import { CheckoutConfigService } from '../services/checkout-config.service';
import { ConfigurationService } from '../services/configuration.service';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from '../services/department.service';
import { DocumentService } from '../services/document.service';
import { EnrollService } from '../services/enrollment.service';
import { OrderService } from '../services/order.service';
import { RetailSubscriptionService } from '../services/retail-subscription.service';
import { SponsorService } from '../services/sponsor.service';
import { PersonalInfoConfigService } from './../services/personal-info-config.service';
import { PersonalMessageService } from './../services/personal-schema-form.service';
import { OpCoRetailSubscriptionEnum } from '../enums/op-co-retail-subscription.enum';
import { RetailSubscription } from '../interface/retail-subscription';
import { MemberRetailSubscriptionDetail } from '../interface/member-retail-subscription-detail';
import { MemberRetailProgramSubscriptionModel } from '../interface/member-retail-program-subscription-model';
import { CurrencyTransformPipe } from '../../common/pipes/currency-format.pipe';
import { BondedWarehouseProjectValue } from '../../common/enums/bonded-warehouse-project.enum';
import { MemberMetaDataEnum } from '../enums/member-meta-data.enum';
import { FBOProfileUpdateEnum } from '../../common/enums/fboprofile-update-enum';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import { SSO } from '../../sso/sso.constants';
import { CountryCodeConstant } from '../common/constants';
var FBOProfileComponent = /** @class */ (function () {
    function FBOProfileComponent(_customerservice, _commonService, _customerService, _cacheService, _dataServcie, _translatePipe, _translateKey, _datePipe, _maskPipe, ngProgress, _enrollService, _formbuilder, _checkoutConfigService, messageService, _appConfigService, _notificationService, _modalService, _configurationService, _achService, distributorFormatPipe, _sponsorService, _departmentService, _personalMessageService, _personalInfoConfigService, _messageService, _documentService, _orderService, _retailSubscriptionService, _currencyPipe) {
        var _this = this;
        this._customerservice = _customerservice;
        this._commonService = _commonService;
        this._customerService = _customerService;
        this._cacheService = _cacheService;
        this._dataServcie = _dataServcie;
        this._translatePipe = _translatePipe;
        this._translateKey = _translateKey;
        this._datePipe = _datePipe;
        this._maskPipe = _maskPipe;
        this.ngProgress = ngProgress;
        this._enrollService = _enrollService;
        this._formbuilder = _formbuilder;
        this._checkoutConfigService = _checkoutConfigService;
        this.messageService = messageService;
        this._appConfigService = _appConfigService;
        this._notificationService = _notificationService;
        this._modalService = _modalService;
        this._configurationService = _configurationService;
        this._achService = _achService;
        this.distributorFormatPipe = distributorFormatPipe;
        this._sponsorService = _sponsorService;
        this._departmentService = _departmentService;
        this._personalMessageService = _personalMessageService;
        this._personalInfoConfigService = _personalInfoConfigService;
        this._messageService = _messageService;
        this._documentService = _documentService;
        this._orderService = _orderService;
        this._retailSubscriptionService = _retailSubscriptionService;
        this._currencyPipe = _currencyPipe;
        this.isDesc = false;
        this.isCCSnapshot = false; // to check whether we are sorting ccSnapshot or autoship table
        this.isLoading = false;
        this.valueZero = 0;
        this.isSuspendedStatus = false;
        this.changeTab = new EventEmitter();
        this.paymentMethodTab = new EventEmitter();
        this.customerReportTab = new EventEmitter();
        this.distributorInfo = new EventEmitter();
        this.autoshipTabInfo = new EventEmitter();
        this.homeCountryInfo = new EventEmitter();
        this.operatingCountryInfo = new EventEmitter();
        this.FBODetailPermissions = [Permission.FBO_PROFILE_VIEW, Permission.FBO_ORDER_HISTORY_VIEW,
            Permission.FBO_AUTOSHIP_DETAILS_VIEW, Permission.FBO_PAYMENT_METHODS_VIEW,
            Permission.FBO_DOWNLINE_VIEW, Permission.FBO_REPORTS_VIEW, Permission.MANAGE_TICKETS_VIEW,
            Permission.RESET_PASSWORD, Permission.Unlock_Account,
            Permission.CHANGE_OPERATING_COMPANY_ALLOW, Permission.CHANGE_REGISTERED_ADDRESS_ALLOW,
            Permission.FBO_CHANGE_SPONSER, Permission.FBO_MEMBER_TYPE, Permission.FBO_OVERRIDE_MAXIMUM_CC_FBO,
            Permission.FBO_CHANGE_GOVERNMENT_ID, Permission.STORE_BUSINESS_ENTITY_MANAGE,
            Permission.STORE_BUSINESS_ENTITY_VIEW, Permission.MEMBER_STATUS_EDIT, Permission.MEMBER_STATUS_VIEW,
            Permission.MANAGE_FBO_DOB_CREATE, Permission.MANAGE_ACCOUNT_NOTIFICATION, Permission.UPDATE_EMAIL_ADDRESS, Permission.MANAGE_MEMBER_PREFERENCES,
            Permission.GENERAL_SPONSOR_CHANGE, Permission.FBO_VIEW_GOVERNMENT_ID, Permission.FBO_MANAGE_GOVERNMENT_ID];
        this.accountRestrictionPermission = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
        this.bondedWarehouseProjectPermission = [Permission.Bonded_Warehouse_Project_VIEW, Permission.Bonded_Warehouse_Project_MANAGE];
        this.cookieService = new CookieService(document);
        this.activeAutoShipInfo = [];
        this.inactiveAutoShipInfo = [];
        this.impersonationPermission = [Permission.IMPERSONATION];
        this.fboInfo = [];
        this.distributorDefaultCardPaymentInfo = [];
        this.distributorDefaultECheckPaymentInfo = [];
        this.memberTypeEnum = MemberTypeEnum;
        this.subscriptionStatusEnum = SubscriptionStatusEnum;
        this.isTitanEnabled = false;
        this.isGuestMemberType = false;
        this.isSubmitted = false;
        this.isRetailFormSubmitted = false;
        this.isUnLockSubmitted = false;
        this.isEditGovId = false;
        this.isAccountLocked = false;
        this.uploadResponse = [];
        this.isUpdateButtonClicked = false;
        this.isCancelButtonClicked = false;
        this.isDisplaySearchAddressSection = false;
        this.sponsorDetails = [];
        this.hasAllowEcheckPermission = false;
        this.ManagePersonalCheckPermission = [
            Permission.MANAGE_PERSONAL_CHECK
        ];
        this.isBetaEnabled = false;
        this.enableSponsorChange = environment.enableSponsorChange;
        this.editBlxBonusInfo = false;
        this.isCreditAssessmentEnabled = true;
        this.isDirectDebitEnabled = false;
        this.isSingleDebitEnabled = false;
        this.displayIBANAckError = false;
        this.disableBonusInfoChecks = false;
        this.emailSignatureResponse = [];
        this.creditAssessmentApproved = true;
        this.AmazonSubscriptionEnabledOperatingCountries = CommonConstant.AmazonSubscriptionEnabledOperatingCountries && CommonConstant.AmazonSubscriptionEnabledOperatingCountries.length > 0
            ? CommonConstant.AmazonSubscriptionEnabledOperatingCountries : [];
        this.enableAmazonSubscriptionFlag = false;
        this.monthAndYear = [
            { monthName: "January", value: 1 }, { monthName: "February", value: 2 }, { monthName: "March", value: 3 },
            { monthName: "April", value: 4 }, { monthName: "May", value: 5 }, { monthName: "June", value: 6 },
            { monthName: "July", value: 7 }, { monthName: "August", value: 8 }, { monthName: "September", value: 9 },
            { monthName: "October", value: 10 }, { monthName: "November", value: 11 }, { monthName: "December", value: 12 }
        ];
        this.commonConstants = CommonConstant;
        this.accountRestriction = false;
        this.updateHomeCountryVat = false;
        this.deleteHomeCountryVat = false;
        this.updateBusinessEntity = false;
        this.isEnrollmentDateExists = false;
        this.unLockData = [];
        this.enableHomeCountry = true;
        this.enableMemberTypeOrLevel = true;
        this.memberTypeName = [];
        this.memberLevelList = [];
        this.isDistributor = false;
        this.enableChangeStatus = false;
        this.fboBusinessEntity = new FBOBusinessEntity();
        this.businessFormSubmitButton = false;
        this.duplicateCheck = false;
        this.momentConstructor = moment.default || moment;
        this.PCSponsorshipStatus = ['Yes', 'No'];
        this.enableChangeDOB = false;
        this.updateDOBPermission = false;
        this.accountNotificationPermission = false;
        this.changeEmailPermission = false;
        this.emailMismatch = false;
        this.isNewEmail = false;
        this.selectEnum = SelectEnum;
        this.isFlp360Enabled = false;
        this.isFlp360Enrolled = 'No';
        this.flp360AccountAvailable = false;
        this.flp360TitanWebsiteEnabled = environment.flp360TitanWebsiteEnabled;
        this.flp360ImpersonationPermission = [Permission.FLP360_IMPERSONATION];
        this.flp360ResetPasswordPermission = [Permission.FLP360_RESET_PASSWORD];
        this.contactTypes = ContactTypeConstants.phoneTypes;
        this.isMemberRecordExistInTitan = false;
        this.shoppingCartCount = 0;
        this.customerServiceAccessLevelId = AccessLevel.Customer_Service;
        this.flp360Statuses = [];
        this.changeMemberPreferencesPermission = false;
        this.myMemberPreferences = [];
        this.disableBusinessEntityForFbo = false;
        this.phoneNumbers = [];
        this.ccSnapshot4CCActive = new SnapshotDetails();
        this.ccSnapshotLevel = new SnapshotDetails();
        this.enableFBOLogin = true;
        this.isDisplayMemberTitle = false;
        this.corporateSiteUrl = environment.corporateSiteUrl;
        this.corporateSiteName = this.corporateSiteUrl.replace("https://", "");
        this.deleteGovId = null;
        this.governmentIdValidationInProgress = false;
        this.governmentIdValueEditIndexes = [];
        this.duplicateGovIdErrorMessage = '';
        this.paymentComponentSettings = new PaymentComponentSettings();
        this.changeGeneralSponsorPermission = false;
        this.isAgentAllowedToChangeSponsor = false;
        this.sponsorChangeSuccess = false;
        this.sponsorChangeError = false;
        this.sponsorPollCount = 0;
        this.sponsorMaxPollCount = environment.longPollCount;
        this.sponsorNotFoundError = false;
        this.statusActive = StatusConstants.ACTIVE;
        this.governmentIdViewPermission = false;
        this.governmentIdManagePermission = false;
        this.emailValidators = [this.must_be_email.bind(this)];
        this.errorMessages = ComposeEmailTicketConstants.ERROR_MESSAGE;
        this.subjectMaxLength = { maxLength: 500 };
        this.showToAddressValidation = true;
        this.showMaxFileSizeValidation = false;
        this.composeEmailattachmentMaxSize = environment.draftEmailAttachmentsSize;
        this.statuses = [];
        this.uploadedImageUrlArr = [];
        this.uploadedImageLength = 0;
        this.submitCompleted = false;
        this.sourceTypesEnum = SourceType;
        this.showErrorMsg = false;
        this.isSendingEmail = false;
        this.hasFboBonusInfoViewPermission = false;
        this.hasFboBonusInfoDeletePermission = false;
        this.hasFboBonusInfoManagePermission = false;
        this.memberBonusInfo = null;
        this.bonusInfoSchemaUrl = null;
        this.editBonusInfo = false;
        this.isDeleteBonusInfo = false;
        this.showSingleAndDirectDebitMenu = false;
        this.agreeTAndC = false;
        this.bonusInfoAgreements = [];
        this.showSingleDebit = false;
        this.showDirectDebit = false;
        this.vatPayerOption = VatPayerOption;
        this.hasRetailSubscriptionAccess = false;
        this.isStoreRetailSubscriptionEnabled = false;
        this.isRetailSubscriptionLogin = false;
        this.languages = [];
        this.memberRetailSubscriptionDetails = [];
        this.memberRetailSubscriptionDetail = new MemberRetailSubscriptionDetail();
        this.isMemberTypeDistributor = false;
        this.showConfirmationMessage = false;
        this.showBillingHistoryLink = false;
        this.showSubscriptionHistoryLink = false;
        this.isResubscribe = false;
        this.retailSubscriptionHistoryResponse = [];
        this.loadRetailSubscriptionHistory = [];
        this.skipCount = 5;
        this.statusChanged = false;
        this.isAccountChecked = false;
        this.hideBusinessEntityName = false;
        this.isSubscriptionCreatedInChargebee = false;
        this.isPrefferedCustomer = false;
        this.isFpcEligibleForPcSponsor = false;
        this.updateAccessToTitanCounty = false;
        this.enableSubmit = false;
        this.isUserCreatedInKeycloak = false;
        this.enableFLP360ImpersonationForFPC = environment.enableFLP360ImpersonationForFPC;
        this.disableStatusButton = true;
        this.disableNameButton = false;
        this.disableEmailButton = true;
        this.disableBonusButton = true;
        this.disableBusinessEntityButton = false;
        this._editor = ClassicEditor;
        this._config = {
            extraPlugins: [AllowDivElement, AllowIDAttribute],
            removePlugins: ['MediaEmbed', 'Title', 'ImageCaption'],
            toolbar: {
                items: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'link',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    'imageUpload'
                ]
            },
            image: {
                toolbar: ['imageStyle:alignLeft'],
                styles: [
                    'alignLeft'
                ]
            }
        };
        /**
        * To Create or Update notification immediately
        */
        this.accountNotificationSubmit = function () {
            var payload;
            if (_this.accountNotification) {
                payload = Object.assign({}, _this.accountNotification);
                payload.enable = _this.accountNotificationForm.value.enable;
            }
            else {
                payload = {
                    enable: _this.accountNotificationForm.value.enable
                };
            }
            payload.subject = _this.accountNotificationForm.value.subject;
            payload.body = _this.accountNotificationForm.value.body;
            _this._customerService.AccountNotificationChange(payload, _this.fboProfileDetail.memberId).subscribe(function (response) {
                if (response.success) {
                    var logKey = void 0;
                    if (_this.accountNotification && _this.accountNotification.enable && !_this.accountNotificationForm.value.enable) {
                        logKey = MemberActivityLogType.Account_Notification_Disabled;
                    }
                    else if (!_this.accountNotification) {
                        logKey = MemberActivityLogType.Account_Notification_Created;
                    }
                    else {
                        logKey = MemberActivityLogType.Account_Notification_Updated;
                    }
                    var activityLogKeys = [{
                            key: logKey,
                            value: null
                        }];
                    _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                    var notification = _this._translatePipe.get('customer-service.Account Notification Updated Successfully');
                    _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    _this.accountNotificationChangePopup.close();
                    _this.getFBOProfileInfoFromTitan(true);
                }
                else if (response.validations && response.validations.length) {
                    var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].name);
                    _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                }
            }, function (error) {
                if (error && error.validations && error.validations.length) {
                    var addedNotification = _this._translatePipe.get('errorcodes.' + error.validations[0].name);
                    _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                }
                else {
                    var addedNotification = _this._translatePipe.get('errorcodes.Unable to Update Account Notification. Please try again later.');
                    _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                }
            });
        };
        /**
        * Tiggers when enable checkbox in Account notification popup is changed
        */
        this.enableAccountNotificationChange = function (event) {
            if (event.currentTarget.checked) {
                _this.accountNotificationForm.controls['subject'].setValidators(Validators.required);
                _this.accountNotificationForm.controls['subject'].updateValueAndValidity();
            }
            else {
                _this.accountNotificationForm.controls['subject'].clearValidators();
                _this.accountNotificationForm.controls['subject'].updateValueAndValidity();
            }
        };
        /**
         * To display Change Email Popup
         */
        this.openChangeEmailModal = function () {
            _this.errorCodes = [];
            _this.emailForm = _this._formbuilder.group({
                email: ['', [Validators.required, Utils.emailValidationRule]],
                confirmEmail: ['', [Validators.required, Utils.emailValidationRule]]
            });
            _this.changeEmailPopup.open();
        };
        /**
        * To display Account Notification Popup
        */
        this.openChangeAccountNotificationModal = function () {
            if (_this.accountNotification) {
                _this.accountNotificationForm = _this._formbuilder.group({
                    subject: [_this.accountNotification.subject ? _this.accountNotification.subject : '', _this.accountNotification.enable ? Validators.required : ''],
                    body: [_this.accountNotification.body ? _this.accountNotification.body : ''],
                    enable: _this.accountNotification.enable ? true : false
                });
            }
            else {
                _this.accountNotificationForm = _this._formbuilder.group({
                    subject: ['', Validators.required],
                    body: [''],
                    enable: true
                });
            }
            _this.accountNotificationChangePopup.open();
        };
        this.onStatusChange = function () {
            _this.statusForm.valueChanges.subscribe(function (formData) {
                if (formData.newstatus) {
                    if (formData.newstatus == MemberStatus.Suspended) {
                        if (!_this.isSuspendedStatus) {
                            _this.isSuspendedStatus = true;
                            _this.statusForm.controls['endDate'].setValidators([Validators.required, Utils.validateFutureDate]);
                        }
                    }
                    else {
                        if (_this.isSuspendedStatus) {
                            _this.isSuspendedStatus = false;
                            _this.statusForm.controls['endDate'].clearValidators();
                            _this.statusForm.controls['endDate'].setValue('');
                        }
                    }
                    _this.statusChanged = true;
                }
            });
        };
        this.ChangeStatusSubmit = function () {
            _this.disableStatusButton = false;
            _this.statusForm.value.endDate = Utils.convertToSpecificDateFormat(_this.statusForm.value.endDate, DateConstants.DOBConvertFormat);
            var payload = {
                'memberId': _this.fboProfileDetail.fboId,
                'newstatus': _this.statusForm.value.newstatus,
                'endDate': _this.statusForm.value.endDate,
                'isRetailSubscriber': _this.isRetailSubscriptionLogin
            };
            _this._customerService.updateMemberStatus(payload).subscribe(function (response) {
                if (response && response.success) {
                    var retailSubscriptionDetails_1 = {
                        isRetailSubscriptionCancelled: response.isRetailSubscriptionCancelled,
                        isretailSubscriptionMessage: response.retailSubscriptionMessage,
                        initialMsg: '',
                        msgType: NotificationType.SUCCESS
                    };
                    var activityLogKeys = [{
                            key: MemberActivityLogType.Change_Status,
                            value: MemberStatus[_this.statusForm.value.newstatus] + ' for ' + _this.fboProfileDetail.fboId
                        }];
                    _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                    var notesData = {
                        "noteTypeID": MemberNoteType.AccountStatusChangeTypeID,
                        "description": _this.statusForm.controls['notes'].value.trim(),
                        "summary": "Member Status is changed from " + MemberStatus[_this.memberStatus.id].toString() + " to " + MemberStatus[_this.statusForm.controls['newstatus'].value].toString(),
                        "createdByUserId": _this.userInfo.userId,
                        "createdByUserName": _this.userInfo.userName,
                        "createdDate": new Date(),
                        "memberId": _this.fboProfileDetail.id ? _this.fboProfileDetail.id : null,
                        "distributorId": _this._id,
                        "memberAccountStatusId": _this.statusForm.controls['newstatus'].value,
                    };
                    _this._customerservice.saveNoteAtMemberLevel(notesData).subscribe(function (response) {
                        if (response && response.isSuccess) {
                            retailSubscriptionDetails_1.msgType = NotificationType.SUCCESS;
                            retailSubscriptionDetails_1.initialMsg = Constants.STATUS_UPDATED;
                            var retailSubscriptionMsg = _this.showCancellationMsg(retailSubscriptionDetails_1);
                            var msg = _this._translatePipe.get('customer-service.' + retailSubscriptionMsg.initialMsg).value;
                            ;
                            _this._commonService.createNotification('', msg, retailSubscriptionMsg.msgType);
                        }
                        else {
                            _this.statusUpdateErrorMessage(retailSubscriptionDetails_1);
                        }
                    }, function () {
                        _this.statusUpdateErrorMessage(retailSubscriptionDetails_1);
                    });
                    _this.statusChanged = false;
                    _this.changeStatusPopup.close();
                    _this.getFBOProfileInfoFromTitan();
                }
                else if (response.validations && response.validations.length) {
                    var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].name);
                    _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                }
                _this.disableStatusButton = true;
            }, function (error) {
                if (error && error.validations && error.validations.length) {
                    var addedNotification = _this._translatePipe.get('errorcodes.' + error.validations[0].name);
                    _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                }
                else {
                    var addedNotification = _this._translatePipe.get('errorcodes.FAIL: SYSDWN. Valence API for Status Change');
                    _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                }
                _this.disableStatusButton = true;
            });
        };
        this.checkValidationForStatusEndDate = function () {
            _this.statusForm.controls['endDate'].updateValueAndValidity();
        };
        this.openChangeStatusModal = function () {
            _this._customerService.getMemberStatusesFromTitan().subscribe(function (response) {
                var memberStatuses = response;
                if (_this.memberStatus) {
                    _this.statusDropdownItems = memberStatuses.filter(function (status) { return status.id != _this.memberStatus.id; });
                    if (_this.memberStatus.id == MemberStatus.Active) {
                        _this.statusDropdownItems = _this.statusDropdownItems.filter(function (status) { return status.id != MemberStatus.Pending; });
                    }
                }
                else {
                    _this.statusDropdownItems = memberStatuses;
                }
                _this.statusDropdownItems.sort(function (a, b) { return a.value.toUpperCase() !== b.value.toUpperCase() ? (a.value.toUpperCase() < b.value.toUpperCase() ? -1 : 1) : 0; });
                _this.isSuspendedStatus = false;
                _this.statusChanged = false;
                _this.statusForm = _this._formbuilder.group({
                    newstatus: ['', [Validators.required]],
                    endDate: [''],
                    notes: ['', [Validators.required, CustomValidators.requiredNotEmpty, Validators.maxLength(2000)]]
                });
                _this.changeStatusPopup.open();
                _this.onStatusChange();
            });
        };
        this.openResetPasswordModal = function () {
            _this.resetPasswordForm.controls['resetPassword'].setValue(_this.selectEnum.firstOption.toString());
            _this.tempPassword = _this.randomPassword(12);
            _this.resetPasswordPopup.open();
        };
        this.openFlp360ResetPasswordModal = function () {
            _this.flp360ResetPasswordForm.controls['flp360ResetPassword'].setValue(_this.selectEnum.firstOption.toString());
            _this.tempPassword = _this.randomPassword(12);
            _this.flp360ResetPasswordPopup.open();
        };
        this.randomPassword = function (length) {
            var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@$#';
            var pass = '';
            for (var x = 0; x < length; x++) {
                pass += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return pass;
        };
        this.closePopUpforResetPassword = function () {
            _this.tempPassword = '';
            _this.resetPasswordPopup.close();
        };
        this.closeFlp360ResetPasswordModal = function () {
            _this.tempPassword = '';
            _this.flp360ResetPasswordPopup.close();
        };
        this.updateTemporaryPassword = function () {
            if (_this.resetPasswordForm.controls['resetPassword'].value === _this.selectEnum.secondOption.toString()) {
                _this.resetPassword();
            }
            else {
                _this._customerService.setTemporaryPassword(_this.fboProfileDetail.emailId, _this.tempPassword, _this.fboProfileDetail.fboId).subscribe(function (response) {
                    if (response.isSuccess) {
                        var activityLogKeys = [{
                                key: MemberActivityLogType.Change_Temporary_PWD,
                                value: _this.fboProfileDetail.fboId
                            }];
                        _this.logOutUserSessions();
                        _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                        var notification = _this._translatePipe.get('customer-service.Temporary Password Updated Successfully');
                        _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                        _this.resetPasswordPopup.close();
                    }
                    else if (response.validations && response.validations.length) {
                        var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].message);
                        _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                    }
                }, function (error) {
                    if (error && error.validations && error.validations.length) {
                        var addedNotification = _this._translatePipe.get('errorcodes.' + error.validations[0].message);
                        _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                    }
                });
            }
        };
        /**
        * Custom Email Validations.
        */
        this.emailCheck = function () {
            if (_this.emailForm && _this.emailForm.value) {
                var emailFrom = _this.emailForm.value.email.trim();
                var emailTo = _this.emailForm.value.confirmEmail.trim();
                if (emailFrom && emailTo) {
                    _this.emailMismatch = (emailFrom.toLowerCase() === emailTo.toLowerCase()) ? false : true;
                }
                if (_this.fboProfileDetail) {
                    if (_this.fboProfileDetail.emailId) {
                        _this.isNewEmail = (!_this.emailMismatch
                            && (_this.emailForm.value.email.toLowerCase() !== _this.fboProfileDetail.emailId.toLowerCase())) ? true : false;
                    }
                    else {
                        _this.isNewEmail = true;
                    }
                }
            }
        };
        /**
         * Email update on form submit
         */
        this.changeEmailSubmit = function () {
            _this.errorCodes = [];
            _this.disableEmailButton = false;
            _this._customerService.getMemberBasicInfoById(+_this.fboProfileDetail.memberId).subscribe(function (basicInfo) {
                if (_this.emailForm && _this.emailForm.value && basicInfo) {
                    var emailID = _this.emailForm.value.email.trim();
                    _this._customerService.updateMemberBasicInfo(_this.mapToBasicInfo(basicInfo, emailID.toLowerCase())).subscribe(function (response) {
                        if (response.success) {
                            var activityLogKeys = [{
                                    key: MemberActivityLogType.Email_New,
                                    value: _this.emailForm.value.email.toLowerCase()
                                }];
                            _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                            if (_this.fboProfileDetail.memberTypeId === _this.memberTypeEnum.GUEST) {
                                var msg = _this._translatePipe.get('customer-service.' + 'Email Has Been Updated SuccessFully');
                                _this._commonService.createNotification('', msg.value, NotificationType.SUCCESS);
                            }
                            else {
                                var msg = _this._translatePipe.get('customer-service.' + 'We emailed a confirmation link to ||email||. Click the link in the email to confirm your email address.');
                                var translateValue = _this.transform(msg.value, _this.emailForm.value.email.toLowerCase());
                                _this._commonService.createNotification('', translateValue, NotificationType.SUCCESS);
                            }
                            _this.changeEmailPopup.close();
                            _this.getFBOProfileInfoFromTitan();
                        }
                        else if (response.validations && response.validations.length) {
                            _this.errorCodes = response.validations;
                        }
                        _this.disableEmailButton = true;
                    }, function (error) {
                        if (error && error.validations && error.validations.length) {
                            _this.errorCodes = error.validations;
                            var addedNotification = _this._translatePipe.get('errorcodes.' + error.validations[0].message);
                            _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                        }
                        else {
                            var addedNotification = _this._translatePipe.get('errorcodes.Unable to Update Email. Please try again later');
                            _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                        }
                        _this.disableEmailButton = true;
                    });
                }
            }, function (error) {
                var addedNotification = _this._translatePipe.get('errorcodes.Unable to Update Email. Please try again later');
                _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                _this.disableEmailButton = true;
            });
        };
        /**
             * On Successful upload of file
             * @param item
             * @param response
             * @param status
             * @param headers
             */
        this.count = 0;
        this.handleError = function () {
            _this.showImpersonateUserErrorMessage();
        };
        this.reviewModel = new MemberLevelModel();
        this.updateGovIDForm = _formbuilder.group({ govermentIdentification: _formbuilder.array([]) });
    }
    FBOProfileComponent.prototype.must_be_email = function (control) {
        var EMAIL_REGEXP = ComposeEmailTicketConstants.EMAIL_REGEXP;
        if (control.value && control.value.length !== '' && !EMAIL_REGEXP.test(control.value)) {
            return { 'must_be_email': true };
        }
        return null;
    };
    FBOProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.attachmentsLength = 0;
        this.uploader = this._customerservice.getFileUploader();
        this.uploader.onErrorItem =
            function (item, response, status, headers) { return _this.onErrorItem(item, response, status, headers); };
        this.uploader.onSuccessItem =
            function (item, response, status, headers) { return _this.onSuccessItem(item, response, status, headers); };
        if (environment.dataLayer && environment.dataLayer.length > 0) {
            environment.dataLayer[0].pageCategory = 'fbo-detail-page';
        }
        this.dateNow = new Date();
        this.minDate = new Date(this.dateNow.getFullYear(), this.dateNow.getMonth(), 1);
        this.memberCCMinDate = new Date(this.dateNow.getFullYear(), this.dateNow.getMonth(), this.dateNow.getDate() + 1, 0, 0, 0);
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this._id = this.fboid;
        this.getAllCountriesInfo();
        this.getValidIbanInfoSubscription();
        this.getFlp360Status();
        this.getIdentificationTypes();
        this.getGovermentIdentificationPatterns();
        this.memberWholesaleQualifiedRequest = new memberWholesaleQualifiedRequestModel();
        this.unlockInfo = new UnLockInfoModel();
        this.unlockRequest = new UnLockRequest();
        this.fboProfileDetail = new ProfileInformation();
        this.fboProfileDetail.address = new AddressInformation();
        this.fboProfileDetail.autoShipItems = new Array();
        this.ccSnapshot = new CCSnapshot();
        this.fboProfileDetail.sponsorDetails = new SponsorInformation();
        this.fboProfileDetail.firstActiveUplineManager = new SponsorInformation();
        this.fboProfileDetail.retailSubscriptionModel = new RetailSubscription();
        this.fboProfileDetail.storeEligibility = '';
        this.userId = this._cacheService.get(CacheKey.UserId);
        this.getMemberLevels();
        this.distributorInfoObj = new DistributorInfo();
        this.autoshipMemberInfo = new AutoshipMemberInfo();
        this.viewMemberLevelAllowed = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_LEVEL_HISTORY + ']'), AccessLevel.Customer_Service);
        this.changeOperatingCountry = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.CHANGE_OPERATING_COMPANY_ALLOW + ']'), AccessLevel.Customer_Service);
        this.autoshipPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[2] + ']'), AccessLevel.Customer_Service);
        this.fboPaymentPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[3] + ']'), AccessLevel.Customer_Service);
        this.fboDownlinePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[4] + ']'), AccessLevel.Customer_Service);
        this.resetPasswordPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[7] + ']'), AccessLevel.Customer_Service);
        this.unlockPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[8] + ']'), AccessLevel.Customer_Service);
        this.homeCountryPermission = this._commonService.checkPermissionByAccessLevel([Permission.CHANGE_OPERATING_COMPANY_ALLOW, Permission.CHANGE_REGISTERED_ADDRESS_ALLOW], AccessLevel.Customer_Service);
        this.allowFullNamePermission = this._commonService.checkPermissionByAccessLevel([Permission.UPDATE_FULL_NAME_ALLOW], AccessLevel.Customer_Service);
        this.memberTypePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[12] + ']'), AccessLevel.Customer_Service);
        this.monthlyCCLimitPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[13] + ']'), AccessLevel.Customer_Service);
        this.statusEditPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[17] + ']'), AccessLevel.Customer_Service);
        this.updateDOBPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[19] + ']'), AccessLevel.Customer_Service);
        this.accountNotificationPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[20] + ']'), AccessLevel.Customer_Service);
        this.changeEmailPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[21] + ']'), AccessLevel.Customer_Service);
        this.changeMemberPreferencesPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[22] + ']'), AccessLevel.Customer_Service);
        this.updatePhoneNumberPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_UPDATE_PHONE_NUMBER + ']'), AccessLevel.Customer_Service);
        this.viewShoppingBagPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + Permission.VIEW_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.changeGeneralSponsorPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[23] + ']'), AccessLevel.Customer_Service);
        this.governmentIdViewPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[24] + ']'), AccessLevel.Customer_Service);
        this.governmentIdManagePermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[25] + ']'), AccessLevel.Customer_Service);
        this.hasAllowEcheckPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManagePersonalCheckPermission[0] + "]"), AccessLevel.Customer_Service);
        this.composeEmailPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_COMPOSE_EMAIL + ']'), AccessLevel.Customer_Service);
        this.hasRetailSubscriptionAccess = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_RETAIL_SUBSCRIPTION + ']'), AccessLevel.Customer_Service);
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
        this.accountManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[1] + ']'), AccessLevel.Customer_Service);
        this.getCustomBankTypeSelectOption();
        this.buildChangeMemberTypeandLevelForm();
        this.buildResetPasswordForm();
        this.getFlpAccessDetails();
        this.getFlpUserDetails();
        this.buildFlp360ResetPasswordForm();
        this.addressDetail = new AddressInformation();
        this.contactTypes.forEach(function (types) {
            if (types.value === ContactTypeValue.PHONE) {
                types.name = 'Home';
            }
        });
        this.getEmailSignature();
        this.getChargeBeeLanguages();
    };
    FBOProfileComponent.prototype.ngAfterContentChecked = function () {
        this.checkValidationForEndDate();
    };
    FBOProfileComponent.prototype.ngAfterViewInit = function () {
        window.scrollTo(0, 0);
    };
    FBOProfileComponent.prototype.buildResetPasswordForm = function () {
        this.resetPasswordForm = this._formbuilder.group({
            resetPassword: [this.selectEnum.firstOption.toString()],
        });
    };
    FBOProfileComponent.prototype.buildFlp360ResetPasswordForm = function () {
        this.flp360ResetPasswordForm = this._formbuilder.group({
            flp360ResetPassword: [this.selectEnum.firstOption.toString()],
        });
    };
    FBOProfileComponent.prototype.getMemberBonusInfo = function () {
        var _this = this;
        if (this.personalInfoSettings && this.personalInfoSettings.enableSingleAndDirectDebit) {
            if (this.fboProfileDetail && this.fboProfileDetail.memberId) {
                var operatingCompany = this.storeInfo && this.storeInfo.homeIsocodeThree ? this.storeInfo.homeIsocodeThree : null;
                var storeId = this.storeInfo && this.storeInfo.id ? this.storeInfo.id : null;
                this._customerService.getMemberBankDetails(this.fboProfileDetail.memberId, storeId, operatingCompany).subscribe(function (response) {
                    if (response) {
                        _this.memberBonusInfo = response;
                        _this.creditAssessmentApproved = _this.memberBonusInfo.creditAssessmentEnabled;
                        _this._personalMessageService.setPreviousBonusInfo(_this.memberBonusInfo);
                        _this.isBonusInfo = _this.memberBonusInfo ? true : false;
                        _this.preloadMemberBonusInfo = _this.memberBonusInfo;
                        // this.bonusInfoBankCode = this.memberBonusInfo.bankCode;
                        _this.bonusInfoAgreements.forEach(function (agreement) { return agreement.isSelected = true; });
                        _this.isCreditAssessmentEnabled = _this.memberBonusInfo.creditAssessmentEnabled;
                        _this.isSingleDebitEnabled = _this.memberBonusInfo.singleDebitEnabled;
                        _this.isDirectDebitEnabled = _this.memberBonusInfo.directDebitEnabled;
                        if (_this.appConfig.enableAccountNumberFormat && _this.memberBonusInfo && _this.memberBonusInfo.accountNumber) {
                            _this.memberBonusInfo.accountNumber = _this.memberBonusInfo.accountNumber.replace(/\s/g, '');
                        }
                    }
                });
            }
        }
    };
    FBOProfileComponent.prototype.getWholsesaleQualifiedDetails = function (fboId, memberHomeCountry) {
        var _this = this;
        this._commonService.getWholsesaleQualifiedDetails(fboId, memberHomeCountry)
            .subscribe(function (res) {
            try {
                if (res && res.wholesaleQualified != null) {
                    _this.fboProfileDetail.wholesaleQualifiedCheck = res.wholesaleQualified;
                    _this.fboProfileDetail.memberOptin = res.optIn;
                    _this.getDiscountPersentage(_this.fboProfileDetail.wholesaleQualifiedCheck, _this.fboProfileDetail.memberOptin);
                }
            }
            catch (error) {
                // this.getMemberDiscountPercentages(storeInfo);
                // this.wholesaleCheckErrorNotifications();
            }
        }, function (error) {
            // this.getMemberDiscountPercentages(storeInfo);
            // this.wholesaleCheckErrorNotifications();
        });
    };
    FBOProfileComponent.prototype.getDiscountPersentage = function (wholeSaleQualified, optin) {
        var _this = this;
        var memberTitleID = this.fboProfileDetail ? this._orderService.getMemberTitleId(this.fboProfileDetail) : MemberLevel.RETAIL;
        this._messageService.getStoreID().subscribe(function (res) {
            _this.storeInfo.id = res;
            if (_this.storeInfo.id) {
                _this._commonService.getDiscountPercentages(wholeSaleQualified, optin, memberTitleID, _this.storeInfo.id).
                    subscribe(function (response) {
                    _this.memberDiscountPercentage = response;
                });
            }
        });
    };
    FBOProfileComponent.prototype.prepareBonusInfoSchemaForm = function () {
        var _this = this;
        var bankCode = (this.memberBonusInfo && this.memberBonusInfo.bankCode) ? this.memberBonusInfo.bankCode : this.bonusInfoBankCode ? this.bonusInfoBankCode : null;
        if (this.personalInfoSettings && this.personalInfoSettings.enableSingleAndDirectDebit) {
            if (this.fboProfileDetail.homeCountryCode) {
                if (this.personalInfoSettings.countryCode.toLowerCase() === IsoCodeThree.SWE.toLowerCase() || this.personalInfoSettings.countryCode.toLowerCase() === IsoCodeThree.DEU.toLowerCase() || this.personalInfoSettings.countryCode.toLowerCase() === IsoCodeThree.AUT.toLowerCase()) {
                    if (bankCode) {
                        this.bonusInfoSchemaUrl = this.homeCountry.toLowerCase() + '-' + bankCode.toLowerCase() + '-bonus-info.json?templateVersion= '
                            + environment.templateVersion;
                    }
                    else {
                        this.bonusInfoSchemaUrl = this.homeCountry.toLowerCase() + '-bankgiro-bonus-info.json?templateVersion= '
                            + environment.templateVersion;
                    }
                }
                else {
                    this.bonusInfoSchemaUrl = this.fboProfileDetail.homeCountryCode.toLowerCase() + '-bonus-info.json?templateVersion= '
                        + environment.templateVersion;
                }
                this._configurationService.setBonusInfoSchemaUrl(this.bonusInfoSchemaUrl);
                this._personalMessageService.setRebindBonusinfoForm(true);
                setTimeout(function () {
                    _this._personalMessageService.setDisableBonusInfoForm(true);
                    _this.disableBonusInfoChecks = true;
                }, 1500);
            }
        }
    };
    FBOProfileComponent.prototype.getFlpAccessDetails = function () {
        var _this = this;
        if (this.fboid) {
            this._customerService.getFlp360AccessDetails(this.fboid)
                .subscribe(function (response) {
                if (response) {
                    _this.messageService.setFlp360AccessDetails(response);
                    if (response.userAvailable && response.flp360StatusId && response.flp360StatusId !== Flp360Status.NO_SUBSCRIPTION
                        && response.memberStatusId && response.memberStatusId === MemberStatusId.ACTIVE) {
                        _this.flp360AccountAvailable = true;
                        _this.isFlp360Enabled = true;
                    }
                    // check for the variable flp360Subscirbed flag. inside if condition only
                    //set the details over here for FLP360 meber about enrolment date and is flp360 enabled
                }
            });
        }
    };
    FBOProfileComponent.prototype.impersonateFlp360User = function () {
        var _this = this;
        if (this.fboid) {
            //Log FLP360 impersonation activity
            var activityLogKeys = [{
                    key: MemberActivityLogType.Flp360_Impersonation_Started,
                    value: this.fboProfileDetail.fboId
                }];
            this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
            this._customerService.getAdminToken().subscribe(function (response) {
                if (response && response.adminToken) {
                    debugger;
                    _this._customerService.impersonateFlp360User(response.adminToken, _this.fboid, null).subscribe(function (res) {
                        res.success = true;
                        debugger;
                        if (res && res.success) {
                            localStorage.setItem('appadmin.FLP360_SESSION_STATE', res.sessionState);
                            window.open(environment.flp360LoginUrl, '_blank');
                        }
                        else {
                            _this._commonService.createNotification('', 'Cannot Impersonate Flp360 User', NotificationType.ERROR);
                        }
                    }, function (error) { return _this.handleError(); });
                }
            }, function (error) { return _this.handleError(); });
        }
    };
    FBOProfileComponent.prototype.impersonateFlp360WebsiteUser = function () {
        var _this = this;
        if (this.fboid) {
            //Log FLP360 impersonation activity
            var activityLogKeys = [{
                    key: MemberActivityLogType.Flp360_Impersonation_Started,
                    value: this.fboProfileDetail.fboId
                }];
            this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
            this._customerService.getAdminToken(this.fboid, "FLP360").subscribe(function (response) {
                if (response && response.adminToken) {
                    _this.cookieService.set(SSO.AuthorizedUser_UAT, environment.disableVpnPin === true ? "true" : "false", null, environment.cookiePath, environment.cookieDomain);
                    _this._customerService.impersonateFlp360User(response.adminToken, _this.fboid, null).subscribe(function (res) {
                        res.success = true;
                        if (res && res.success) {
                            localStorage.setItem('appadmin.FLP360_SESSION_STATE', res.sessionState);
                            window.open(environment.flp360TitanWebsiteUrl + '&timestamp=' + Date.now(), '_blank');
                        }
                        else {
                            _this._commonService.createNotification('', 'Cannot Impersonate Flp360 User', NotificationType.ERROR);
                        }
                    }, function (error) { return _this.handleError(); });
                }
            }, function (error) { return _this.handleError(); });
        }
    };
    FBOProfileComponent.prototype.getFlpUserDetails = function () {
        var _this = this;
        if (this.fboid) {
            this.messageService.getFlp360AccessDetails()
                .subscribe(function (response) {
                if (response && response.fboId) {
                    _this.isFlp360Enrolled = 'Yes';
                    _this.flp360Status = _this.flp360Statuses.find(function (status) {
                        return status.value === response.flp360StatusId;
                    }).name;
                    _this.flp360EnrollmentDate = response.enrollmentDate;
                }
            });
        }
    };
    /**
   * This method used for getting flp360 status types
   * getFlp360Status()
   */
    FBOProfileComponent.prototype.getFlp360Status = function () {
        this.flp360Statuses = Flp360StatusConstants.statusConstants;
    };
    /** *  ************************* */
    /**
     * Navigating to autoship tab
     */
    FBOProfileComponent.prototype.autoShipTab = function () {
        // emit the event for autoship tab
        this.changeTab.emit(3);
    };
    FBOProfileComponent.prototype.buildUnlockForm = function () {
        this.unlockForm = this._formbuilder.group({
            unlockAccountMessage: ['', [Validators.required]]
        });
    };
    FBOProfileComponent.prototype.openUnlockModal = function (deafultfocus) {
        var _this = this;
        this.getAccountLockInfo();
        this.buildUnlockForm();
        this.unlockRequest.typeId = MemberActivity.AccountUnLock;
        this._customerservice.getUnLockInfo(this.fboProfileDetail.id, this.unlockRequest)
            .subscribe(function (response) {
            if (response && response.content.length > 0) {
                _this.unLockData = response.content;
                _this.unLockData.forEach(function (item) {
                    if (item.createdDate != 'null') {
                        item.createdDate = item.createdDate.replace(' ', 'T');
                    }
                });
            }
        });
        this.unlockPopup.open();
        setTimeout(function () {
            var element = document.getElementById('createNotesInput');
            if (element) {
                element.focus();
            }
        }, 200);
    };
    FBOProfileComponent.prototype.saveUnLockInfo = function () {
        var _this = this;
        this.isUnLockSubmitted = true;
        if (this.unlockForm.valid && this.unlockForm.value.unlockAccountMessage.trim().length > 0) {
            this.unlockInfo.message = this.unlockForm.value.unlockAccountMessage;
            this.unlockInfo.userId = this.userInfo.userId;
            this.unlockInfo.userName = this.userInfo.userName;
            this._customerservice.saveUnLockInfo(this.fboProfileDetail.fboId, this.unlockInfo)
                .subscribe(function (response) {
                if (response && response.isSuccess) {
                    var activityLogKeys = [{
                            key: MemberActivityLogType.Unlock_Account,
                            value: _this.fboProfileDetail.fboId
                        }];
                    _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                    _this._commonService.createNotification('', 'Member Account has been unlocked Successfully', NotificationType.SUCCESS);
                    _this.closePopUp();
                    _this.isUnLockSubmitted = false;
                }
            });
        }
        else {
            this._commonService.createNotification('', 'Please enter valid notes to Unlock', NotificationType.ERROR);
            this.isUnLockSubmitted = true;
        }
    };
    FBOProfileComponent.prototype.getAccountLockInfo = function () {
        var _this = this;
        this._customerservice.AccountLockInfo(this.fboProfileDetail.fboId).subscribe(function (response) {
            if (response) {
                _this.isAccountLocked = response.lock;
            }
        });
    };
    /**
     * @date 2020-09-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.openChangeHomeCountryModal = function (template) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var language, response, selectedCountry, config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.addressDetail = this.fboProfileDetail.address;
                        if (!(this.storeInfo && this.storeInfo.enableTransliteration)) return [3 /*break*/, 2];
                        language = this.storeInfo && this.storeInfo.enableTransliteration && this.storeInfo.languages ? this.storeInfo.languages.find(function (x) { return x.default; }) : null;
                        return [4 /*yield*/, this._customerService.getMemberBasicInfoById(this.fboProfileDetail.memberId, language ? language.languageId : 0).toPromise()];
                    case 1:
                        response = _a.sent();
                        if (response && response.isSuccess && response.address) {
                            this.addressDetail.addressLine1 = response.address.addressLine1;
                            this.addressDetail.addressLine2 = response.address.addressLine2;
                            this.addressDetail.addressLine3 = response.address.addressLine3;
                            this.addressDetail.addressLine4 = response.address.addressLine4;
                            this.addressDetail.city = response.address.city;
                        }
                        _a.label = 2;
                    case 2:
                        if (this.addressDetail) {
                            selectedCountry = this.countries.find(function (country) { return +country.countryId === _this.addressDetail.countryId; });
                            this.selectedCountry = this.checkoutConfig.loadParticipatingCountries ? (selectedCountry ? selectedCountry.isocodeThree : 'gbl') : this.homeCountry;
                            this.mailingSchemaUrl = this.selectedCountry.toLowerCase() +
                                '-mailing-schema-form.json?templateVersion=' + environment.templateVersion;
                        }
                        this.isDisplaySearchAddressSection = this.checkoutConfig ? this.checkoutConfig.displaySearchAddressSection : false;
                        config = {
                            keyboard: false,
                            ignoreBackdropClick: true,
                            class: 'change-address-modal'
                        };
                        this.bsModalRef = this._modalService.show(template, config);
                        return [2 /*return*/];
                }
            });
        });
    };
    FBOProfileComponent.prototype.openChangeSponsorModal = function () {
        this.changeSponsorForm = this._formbuilder.group({
            newSponsorId: ['', Validators.required],
            sponsorType: [0]
        });
        this.getSponsorDetails(this.fboProfileDetail.id);
        this.changeSponsorPopup.open();
        setTimeout(function () {
            var newSponsorElement = document.getElementById('newSponsorId');
            if (newSponsorElement) {
                newSponsorElement.focus();
            }
        }, 0);
    };
    /**
     * build Change member type form onload
     */
    FBOProfileComponent.prototype.buildChangeMemberTypeandLevelForm = function () {
        this.changeMemberTypeandLevelForm = this._formbuilder.group({
            memberTypeModal: [''],
            memberLevel: [''],
            enableStatus: [''],
            triggerNotification: ['']
        });
    };
    FBOProfileComponent.prototype.openChangeMemberTypeandLevelModal = function () {
        this.GetMemberTypeList();
        this.GetMemberLevelList();
        this.changeMemberTypeandLevelForm.patchValue({
            memberTypeModal: this.fboProfileDetail.memberTypeId,
            memberLevel: this.fboProfileDetail.memberTitleId,
            enableStatus: this.fboProfileDetail.wholesaleQualified,
            triggerNotification: false
        });
        this.changeMemberTypeandLevelForm.controls['triggerNotification'].disable();
        this.memberLevelDisable = true; // need to be removed when full functionality is in place
        if (this.fboProfileDetail.wholesaleQualified) {
            this.changeMemberTypeandLevelForm.controls['enableStatus'].disable();
        }
        if (+this.changeMemberTypeandLevelForm.controls['memberTypeModal'].value === this.memberTypeEnum.DISTRIBUTOR) {
            this.changeMemberTypeandLevelForm.controls['triggerNotification'].setValue(true);
        }
        this.changeMemberTypeandLevelPopup.open();
        // setTimeout(function(){
        //     document.getElementById("memberTypeModal").focus();
        //  }, 200);
    };
    FBOProfileComponent.prototype.memberTypeChange = function () {
        if (+this.changeMemberTypeandLevelForm.controls['memberTypeModal'].value === this.memberTypeEnum.DISTRIBUTOR) {
            this.changeMemberTypeandLevelForm.controls['triggerNotification'].setValue(true);
            this.memberLevelDisable = false;
            this.changeMemberTypeandLevelForm.controls['memberLevel'].setValidators([Validators.required]);
            this.changeMemberTypeandLevelForm.controls['memberLevel'].updateValueAndValidity();
            this.changeMemberTypeandLevelForm.controls['enableStatus'].disable();
        }
        if (+this.changeMemberTypeandLevelForm.controls['memberTypeModal'].value != this.memberTypeEnum.DISTRIBUTOR) {
            this.changeMemberTypeandLevelForm.controls['triggerNotification'].setValue(false);
            this.changeMemberTypeandLevelForm.controls['memberLevel'].setValidators([]);
            this.changeMemberTypeandLevelForm.controls['memberLevel'].updateValueAndValidity();
            this.memberLevelDisable = true;
            this.changeMemberTypeandLevelForm.controls['enableStatus'].enable();
        }
    };
    /**
     * @description Open Member cc override modal
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    FBOProfileComponent.prototype.openOverrideMonthlyCCLimitModal = function () {
        var _this = this;
        this.createMemberCCOverrideForm();
        if (this.titanEnabledCountries && this.titanEnabledCountries.length) {
            var homeCountry = this.titanEnabledCountries.find(function (item) { return item.countryId === _this.storeId; }) || this.titanEnabledCountries[0];
            if (homeCountry && homeCountry.isocodeThree) {
                this.overrideMonthlyCCLimitForm.controls['homeCountry'].setValue(homeCountry);
                this.getStoreInfoBasedOnCountry(homeCountry.isocodeThree.toUpperCase(), true);
            }
        }
    };
    /**
     * @description Create member cc override form
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    FBOProfileComponent.prototype.createMemberCCOverrideForm = function () {
        this.overrideMonthlyCCLimitForm = this._formbuilder.group({
            homeCountry: ['', Validators.required],
            applyOverride: [false],
            newCCLimit: [''],
            endDate: [''],
        });
    };
    /**
     * @description pre populate member cc override
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    FBOProfileComponent.prototype.prepopulateMemberCCOverride = function () {
        var value = this.getDate();
        if (this.memberCCOverrideResponse && this.memberCCOverrideResponse.id) {
            this.overrideMonthlyCCLimitForm.patchValue({
                applyOverride: this.memberCCOverrideResponse.overrideFlag,
                newCCLimit: this.memberCCOverrideResponse.cVLimit,
                endDate: moment(value, 'DD-MM-YYYY')
            });
        }
    };
    /**
     * @description get date only from effective end date
     * @date 2019-07-26
     * @memberof FBOProfileComponent
    */
    FBOProfileComponent.prototype.getDate = function () {
        return moment(this.memberCCOverrideResponse.effectiveEndDate.split('T')[0]).format('DD-MM-YYYY');
    };
    /**
     * @description On check of apply override checkbox
     * @date 2019-07-11
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.OnCheckApplyCCOverride = function () {
        var isChecked = this.overrideMonthlyCCLimitForm.controls['applyOverride'].value;
        this.overrideMonthlyCCLimitForm.controls['newCCLimit'].clearValidators();
        this.overrideMonthlyCCLimitForm.controls['endDate'].clearValidators();
        if (isChecked) {
            if (this.memberCCOverrideResponse && this.memberCCOverrideResponse.id) {
                var value = this.getDate();
                this.overrideMonthlyCCLimitForm.patchValue({
                    newCCLimit: this.memberCCOverrideResponse.cVLimit,
                    endDate: moment(value, 'DD-MM-YYYY')
                });
            }
            this.showNewCCBlock = true;
            this.overrideMonthlyCCLimitForm.controls['newCCLimit'].setValidators([Validators.required, Validators.min(1)]);
            this.overrideMonthlyCCLimitForm.controls['newCCLimit'].updateValueAndValidity();
            this.overrideMonthlyCCLimitForm.controls['endDate'].setValidators([Validators.required,
                Validators.min(this.memberCCMinDate.getTime()), Utils.validateFutureDate]);
            this.overrideMonthlyCCLimitForm.controls['endDate'].updateValueAndValidity();
        }
        else {
            this.showNewCCBlock = false;
            this.overrideMonthlyCCLimitForm.controls['newCCLimit'].clearValidators();
            this.overrideMonthlyCCLimitForm.controls['endDate'].clearValidators();
        }
    };
    /**
   * @description On submitting cc limit override
   * @date 2019-07-11
   * @memberof FBOProfileComponent
   */
    FBOProfileComponent.prototype.onSubmitCCLimitOverride = function (isValid) {
        if (isValid) {
            if (this.memberCCOverrideResponse && this.memberCCOverrideResponse.id) {
                var memberCCRequestModel = this.prepareMemberCCOverrideRequest();
                memberCCRequestModel.effectiveStartDate =
                    this._datePipe.transform(this.memberCCOverrideResponse.effectiveStartDate, 'yyyy-MM-dd');
                this.updateMemberCCOverride(memberCCRequestModel);
            }
            else if (this.overrideMonthlyCCLimitForm.controls['applyOverride'].value) {
                var memberCCRequestModel = this.prepareMemberCCOverrideRequest();
                this.createMemberCCOverride(memberCCRequestModel);
            }
        }
    };
    /**
     * @description Update Member cc limit override
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    FBOProfileComponent.prototype.updateMemberCCOverride = function (memberCCRequestModel) {
        var _this = this;
        var store = this.overrideMonthlyCCLimitForm.controls['homeCountry'].value;
        this._customerservice.updateMemberCCOverride(this.storeInfo.id, this.fboProfileDetail.memberId, memberCCRequestModel, this.memberCCOverrideResponse.id).subscribe(function (response) {
            if (response && response.isSuccess) {
                _this.saveMemberCCOverrideActivityLog(_this.memberCCOverrideResponse.cVLimit, _this.overrideMonthlyCCLimitForm.controls['newCCLimit'].value, store.isocodeThree);
                var notification = _this._translatePipe.get('customer-service.CC Limit Override Updated Successfully');
                _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                _this.overrideMonthlyCCLimitPopup.close();
            }
        }, function (err) {
        });
    };
    /**
     * @description Update Member cc limit override
     * @date 2019-07-11
     * @memberof FBOProfileComponent
   */
    FBOProfileComponent.prototype.createMemberCCOverride = function (memberCCRequestModel) {
        var _this = this;
        var store = this.overrideMonthlyCCLimitForm.controls['homeCountry'].value;
        this._customerservice.saveMemberCCOverride(this.storeInfo.id, this.fboProfileDetail.memberId, memberCCRequestModel).subscribe(function (response) {
            if (response && response.isSuccess) {
                _this.saveMemberCCOverrideActivityLog(0, _this.overrideMonthlyCCLimitForm.controls['newCCLimit'].value, store.isocodeThree);
                var notification = _this._translatePipe.get('customer-service.CC Limit Override Updated Successfully');
                _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                _this.overrideMonthlyCCLimitPopup.close();
            }
        }, function (err) { });
    };
    /**
     * @description save member activity log while updating/creating member cc limit override
     * @date 2019-07-11
     * @memberof FBOProfileComponent
   */
    FBOProfileComponent.prototype.saveMemberCCOverrideActivityLog = function (oldCCLimit, newCCLimit, countryCode) {
        var value = '';
        var key;
        if (this.overrideMonthlyCCLimitForm.controls['applyOverride'].value) {
            var endDate = moment(this.overrideMonthlyCCLimitForm.controls['endDate'].value, 'DD-MMM-YYYY')
                .format(DateConstants.DateFormat);
            value = 'Store = ' + countryCode + ', Old Limit = ' + oldCCLimit
                + ', New Limit =  ' + newCCLimit + ' End Date = ' + endDate;
            key = MemberActivityLogType.Member_CC_Limit_Override_Updated;
        }
        else {
            value = countryCode ? countryCode.toUpperCase() : '';
            key = MemberActivityLogType.Member_CC_Limit_Override_Disabled;
        }
        var activityLogKeys = [{
                key: key,
                value: value
            }];
        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
    };
    /**
   * @description preparing member cc override request data
   * @date 2019-07-11
   * @memberof FBOProfileComponent
   */
    FBOProfileComponent.prototype.prepareMemberCCOverrideRequest = function () {
        var endDate = this._datePipe.transform(this.overrideMonthlyCCLimitForm.controls['endDate'].value, 'yyyy-MM-dd');
        return {
            memberId: this.fboProfileDetail.memberId,
            storeId: this.storeInfo.id,
            effectiveEndDate: endDate,
            cVLimit: this.overrideMonthlyCCLimitForm.controls['newCCLimit'].value,
            overrideFlag: this.overrideMonthlyCCLimitForm.controls['applyOverride'].value
        };
    };
    /**
     * @description On submitting cc limit override
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    FBOProfileComponent.prototype.OnCountryChange = function () {
        if (this.overrideMonthlyCCLimitForm.controls['homeCountry'].value) {
            var country = this.overrideMonthlyCCLimitForm.controls['homeCountry'].value;
            if (country && country.isocodeThree) {
                this.getStoreInfoBasedOnCountry(country.isocodeThree.toUpperCase());
            }
        }
    };
    /**
     * Get Store Info
     * @param countryCode
     */
    FBOProfileComponent.prototype.getStoreInfoBasedOnCountry = function (countryCode, isOpenModal) {
        var _this = this;
        if (countryCode) {
            this._customerservice.getStoreInfoFromConfig(countryCode)
                .subscribe(function (response) {
                if (response) {
                    _this.storeInfo = response;
                    if (_this.storeInfo && _this.storeInfo.id && _this.fboProfileDetail && _this.fboProfileDetail.memberId) {
                        _this.getMemberCCOverrides(_this.storeInfo.id, isOpenModal);
                    }
                }
            });
        }
    };
    /**
     * Get member cc overrides
     * @param storeId
     */
    FBOProfileComponent.prototype.getMemberCCOverrides = function (storeId, isOpenModal) {
        var _this = this;
        this._customerservice.getMemberCCOverride(storeId, this.fboProfileDetail.memberId)
            .subscribe(function (response) {
            if (response && response.length) {
                _this.memberCCOverrideResponse = response[0];
                _this.prepopulateMemberCCOverride();
                _this.OnCheckApplyCCOverride();
            }
            else {
                _this.clearMemberCCOverrideData();
            }
            if (isOpenModal) {
                _this.overrideMonthlyCCLimitPopup.open();
            }
        }, function (err) {
        });
    };
    /**
     * @description Clear form data when getting no data
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    FBOProfileComponent.prototype.clearMemberCCOverrideData = function () {
        this.memberCCOverrideResponse = null;
        this.showNewCCBlock = false;
        this.overrideMonthlyCCLimitForm.controls['newCCLimit'].setValue('');
        this.overrideMonthlyCCLimitForm.controls['applyOverride'].setValue(false);
        this.overrideMonthlyCCLimitForm.controls['endDate'].setValue('');
    };
    /**
     * @description convert to Date Format
     * @date 2019-07-16
     * @param {string} date
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.convertMemberCCDateFormat = function (date) {
        var dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DOBConvertFormat);
        if (dateMomentObj) {
            this.overrideMonthlyCCLimitForm.controls['endDate'].setValue(moment(dateMomentObj, 'DD-MM-YYYY'));
        }
    };
    /**
   * @description
   * @date 2019-08-01
   * @memberof FBOProfileComponent
   */
    FBOProfileComponent.prototype.openChangeNameModal = function () {
        var _this = this;
        this.errorCodes = [];
        var language = this.storeInfo && this.storeInfo.enableTransliteration && this.storeInfo.languages ? this.storeInfo.languages.find(function (x) { return x.default; }) : null;
        this._customerService.getMemberBasicInfoById(+this.fboProfileDetail.memberId, language ? language.languageId : 0).subscribe(function (basicInfo) {
            if (basicInfo) {
                _this.basicInfo = basicInfo;
                _this.buildNameForm();
                _this.updateMemberNamePopup.open();
            }
        }, function (errorRes) {
            var addedNotification = _this._translatePipe.get('errorcodes.Unable to Update Name. Please try again later')['value'];
            _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
        });
    };
    /**
     * @description
     * @date 2019-08-01
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.buildNameForm = function () {
        this.changeMemberNameForm = this._formbuilder.group({
            firstName: ['', [Validators.required, Utils.noEmptyString]],
            lastName: ['', [Validators.required, Utils.noEmptyString]],
            middleName: ['', [Utils.noEmptyString]]
        });
        this.changeMemberNameForm.setValue({
            middleName: this.storeInfo && this.storeInfo.enableTransliteration ? this.basicInfo.middleName : (this.fboProfileDetail.middleName ? this.fboProfileDetail.middleName : ''),
            firstName: this.storeInfo && this.storeInfo.enableTransliteration ? this.basicInfo.firstName : this.fboProfileDetail.firstName,
            lastName: this.storeInfo && this.storeInfo.enableTransliteration ? this.basicInfo.lastName : this.fboProfileDetail.lastName
        });
        this.setValidationForMemberNameForm();
    };
    FBOProfileComponent.prototype.setValidationForMemberNameForm = function () {
        if (this.personalInfoFormValidations) {
            if (this.personalInfoFormValidations.firstName && this.personalInfoFormValidations.firstName.pattern) {
                this.changeMemberNameForm.get('firstName').setValidators([Validators.required, Utils.noEmptyString, Validators.pattern(this.personalInfoFormValidations.firstName.pattern)]);
            }
            if (this.personalInfoFormValidations.lastName && this.personalInfoFormValidations.lastName.pattern) {
                this.changeMemberNameForm.get('lastName').setValidators([Validators.required, Utils.noEmptyString, Validators.pattern(this.personalInfoFormValidations.lastName.pattern)]);
            }
            if (this.personalInfoFormValidations.middleName && this.personalInfoFormValidations.middleName.pattern && !this.personalInfoFormValidations.middleName.required) {
                this.changeMemberNameForm.get('middleName').setValidators([Utils.noEmptyString, Validators.pattern(this.personalInfoFormValidations.middleName.pattern)]);
            }
            else if (this.personalInfoFormValidations.middleName && this.personalInfoFormValidations.middleName.pattern && this.personalInfoFormValidations.middleName.required) {
                this.changeMemberNameForm.get('middleName').setValidators([Validators.required, Utils.noEmptyString, Validators.pattern(this.personalInfoFormValidations.middleName.pattern)]);
            }
        }
    };
    FBOProfileComponent.prototype.buildRetailSubscritionForm = function () {
        var entityObj = this.ValidateBusinessEntity();
        this.retailSubscriptionForm = this._formbuilder.group({
            firstName: ['', [Validators.required]],
            lastName: ['', [Validators.required]],
            fboId: ['', [Validators.required]],
            email: ['', [Validators.required, Utils.emailValidationRule]],
            homeCountryStore: ['', [Validators.required]],
            language: ['', [Validators.required]],
            taxId: [''],
            chargeBeeRetailPlanId: ['', [Validators.required]],
            annualSubscriptionFee: ['', [Validators.required]],
            subscriptionStatus: ['', [Validators.required]],
            businessEntityId: [''],
            addressId: [''],
            businessEntityName: [''],
            address: this._formbuilder.group({
                line1: [''],
                line2: [''],
                line3: [''],
                line4: [''],
                city: [''],
                state: [''],
                postalCode: [''],
                Country: ['']
            })
        });
        this.retailSubscriptionForm.get('address').patchValue(entityObj && entityObj.address ? entityObj.address : '');
        var obj = {
            firstName: this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.firstName,
            lastName: this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.lastName,
            fboId: this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.distributorId,
            email: this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.emailAddress,
            homeCountryStore: this.storeInfo && this.storeInfo.countryId ? this.getCountryById(+this.storeInfo.countryId) : "",
            language: this.retailSubscriptionLanguageId || '',
            taxId: entityObj && entityObj.vatId ? entityObj.vatId : '',
            chargeBeeRetailPlanId: this.chargeBeePlan ? this.chargeBeePlan.code : '',
            annualSubscriptionFee: this.prepareChargebeePlanPrice(),
            subscriptionStatus: SubscriptionStatusEnum[this.memberRetailSubscriptionDetail.subscriptionStatus],
            businessEntityName: entityObj && entityObj.name ? entityObj.name : '',
            businessEntityId: entityObj && entityObj.entityId ? (+entityObj.entityId) : '',
            addressId: entityObj && entityObj.address && entityObj.address.id ? (+entityObj.address.id) : ''
        };
        this.retailSubscriptionForm.patchValue(obj);
        this.setChargeBeeDetails();
        this.retailSubscriptionPopup.open();
    };
    /**
     * To Prepare Chargebee Plan Price
     */
    FBOProfileComponent.prototype.prepareChargebeePlanPrice = function () {
        var priceValue = '';
        var price = this.chargeBeePlan && this.chargeBeePlan.price ? this.chargeBeePlan.price.toFixed(Math.max(0, ~~2)) : '';
        if (price) {
            var currencyCode = this.chargeBeePlan && this.chargeBeePlan.currencyCode ? this.chargeBeePlan.currencyCode : '';
            if (currencyCode)
                priceValue = price + " " + currencyCode;
        }
        return priceValue;
    };
    FBOProfileComponent.prototype.ValidateBusinessEntity = function () {
        var _this = this;
        if (this.appConfig && !this.appConfig.disableBusinessEntityForFbo) {
            var isBusinessEntityExists = this.fboProfileDetail && this.fboProfileDetail.businessEntities && this.fboProfileDetail.businessEntities.length > 0 ? true : false;
            var isBusinessEntityMatchesCountry = isBusinessEntityExists ? this.fboProfileDetail.businessEntities.some(function (businessEntity) { return businessEntity.countryCodeId == _this.fboProfileDetail.homeCountryId; }) : false;
            if (isBusinessEntityExists && isBusinessEntityMatchesCountry) {
                var date = new Date();
                var businessEntityRecord = this.fboProfileDetail.businessEntities.find(function (businessEntity) { return businessEntity.countryCodeId == _this.fboProfileDetail.homeCountryId; });
                var isActiveByStatus = (businessEntityRecord.status == RowStatus.Active) ? true : false;
                var startDate = businessEntityRecord.startDate ? businessEntityRecord.startDate : '';
                var endDate = businessEntityRecord.endDate ? businessEntityRecord.endDate : '';
                var isStartDateActive = startDate && this.isValidDate(startDate) && (new Date(moment(date, 'DD-MMM-YYYY').format('YYYY-MM-DD')).toISOString() >= new Date(moment(startDate, 'DD-MMM-YYYY').format('YYYY-MM-DD')).toISOString()) ? true : false;
                var isEndDateActive = this.checkEndDate(endDate);
                return this.isActive(businessEntityRecord, isActiveByStatus, isStartDateActive, isEndDateActive);
            }
            if (!(isBusinessEntityExists && isBusinessEntityMatchesCountry)) {
                return this.populateBusinessEntityDetails(true);
            }
        }
        else {
            return this.populateBusinessEntityDetails(false);
        }
    };
    FBOProfileComponent.prototype.isActive = function (businessEntityRecord, isActiveByStatus, isStartDateActive, isEndDateActive) {
        if (isActiveByStatus && isStartDateActive && isEndDateActive) {
            var businessEntityName = businessEntityRecord.businessEntityName ? businessEntityRecord.businessEntityName : '';
            var vatId = businessEntityRecord.incomeTaxID ? businessEntityRecord.incomeTaxID : '';
            var countryName = !!this.countriesList.length && businessEntityRecord.countryCodeId ? this.countriesList.filter(function (item) { return item.countryId == businessEntityRecord.countryCodeId; })[0] : '';
            var state = !!this.states.length && businessEntityRecord.stateCodeId ? this.states.find(function (state) { return state.id === businessEntityRecord.stateCodeId; }) : '';
            var address = { line1: '', line2: '', line3: '', line4: '', city: '', state: '', postalCode: '', Country: '', countryCode: '' };
            address.line1 = businessEntityRecord.addressLine1 ? businessEntityRecord.addressLine1 : '';
            address.line2 = businessEntityRecord.addressLine2 ? businessEntityRecord.addressLine2 : '';
            address.line3 = '';
            address.line4 = '';
            address.city = businessEntityRecord.city ? businessEntityRecord.city : '';
            address.state = state && state.stateName ? state.stateName : '';
            address.postalCode = businessEntityRecord.postalCode ? businessEntityRecord.postalCode : '';
            address.Country = countryName && countryName.name ? countryName.name : '';
            address.countryCode = countryName && countryName.isocodeTwo ? countryName.isocodeTwo : '';
            var businessDetails = { name: '', vatId: '', address: {}, entityId: '' };
            businessDetails.name = businessEntityName;
            businessDetails.vatId = vatId;
            businessDetails.address = address;
            businessDetails.entityId = businessEntityRecord.id ? businessEntityRecord.id.toString() : '';
            return this.populateBusinessEntityDetails(true, businessDetails);
        }
        else {
            return this.populateBusinessEntityDetails(true);
        }
    };
    FBOProfileComponent.prototype.isValidDate = function (date) {
        return (new Date(date).toString() !== DateConstants.InvalidDate) ? true : false;
    };
    FBOProfileComponent.prototype.populateBusinessEntityDetails = function (hideName, businessEntities) {
        var businessDetailsObj = { name: '', vatId: '', address: {} };
        this.hideBusinessEntityName = false;
        if (hideName) {
            this.hideBusinessEntityName = hideName;
        }
        if (businessEntities) {
            return businessEntities;
        }
        businessDetailsObj.vatId = this.getVatIdfromMember();
        businessDetailsObj.address = this.populateAddress();
        return businessDetailsObj;
    };
    FBOProfileComponent.prototype.checkEndDate = function (date) {
        var currDate = new Date();
        if (!date || (new Date(date).toString() == DateConstants.InvalidDate))
            return true;
        return (new Date(moment(currDate, 'DD-MM-YYYY').format('YYYY-MM-DD')).toISOString() <= new Date(moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD')).toISOString()) ? true : false;
    };
    FBOProfileComponent.prototype.getVatIdfromMember = function () {
        var _this = this;
        var vatID = '';
        if (!this.memberGovernmentIdentifiations && !this.memberGovernmentIdentifiations.length && this.fboProfileDetail && this.fboProfileDetail.memberId) {
            this.getMembergovernmentIdentificationsInfo(this.fboProfileDetail.memberId);
        }
        if (this.fboProfileDetail && this.memberGovernmentIdentifiations && !!this.memberGovernmentIdentifiations.length && this.fboProfileDetail.homeCountryId) {
            var memberGovernmentIdentifiation = this.memberGovernmentIdentifiations.find(function (x) { return (x.governmentIdentificationType).toUpperCase() === GovernmentIdentificationType.VAT_ID && x.countryID === _this.fboProfileDetail.homeCountryId; });
            vatID = memberGovernmentIdentifiation && memberGovernmentIdentifiation.value ? memberGovernmentIdentifiation.value : '';
        }
        return vatID;
    };
    FBOProfileComponent.prototype.populateAddress = function () {
        var address = { line1: '', line2: '', line3: '', line4: '', city: '', state: '', postalCode: '', Country: '', countryCode: '' };
        if (this.fboProfileDetail && this.fboProfileDetail.address) {
            var memberAddress_1 = this.fboProfileDetail.address;
            var countryIsoCodeTwo = !!this.countriesList.length && memberAddress_1.countryId ? this.countriesList.filter(function (item) { return item.countryId == memberAddress_1.countryId; })[0] : '';
            address.id = memberAddress_1.id ? memberAddress_1.id.toString() : '';
            address.line1 = memberAddress_1.addressLine1 ? memberAddress_1.addressLine1 : '';
            address.line2 = memberAddress_1.addressLine2 ? memberAddress_1.addressLine2 : '';
            address.line3 = memberAddress_1.addressLine3 ? memberAddress_1.addressLine3 : '';
            address.line4 = memberAddress_1.addressLine4 ? memberAddress_1.addressLine4 : '';
            address.city = memberAddress_1.city ? memberAddress_1.city : '';
            address.state = memberAddress_1.state ? memberAddress_1.state : '';
            address.postalCode = memberAddress_1.zipCode ? memberAddress_1.zipCode : '';
            address.Country = memberAddress_1.country ? memberAddress_1.country : '';
            address.countryCode = countryIsoCodeTwo ? countryIsoCodeTwo.isocodeTwo : '';
        }
        return address;
    };
    /**
     * @description
     * @date 2019-08-13
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.onMemberNameChange = function () {
        if (this.changeMemberNameForm.value && this.changeMemberNameForm.value.firstName === this.basicInfo.firstName &&
            this.changeMemberNameForm.value.middleName === this.basicInfo.middleName &&
            this.changeMemberNameForm.value.lastName === this.basicInfo.lastName) {
            this.nameUpdate = true;
        }
        else {
            this.nameUpdate = false;
        }
    };
    /**
     * @description
     * @date 2019-08-02
     * @param {boolean} isValid
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.onSubmitMemberName = function (isValid) {
        var _this = this;
        this.disableNameButton = true;
        this.errorCodes = [];
        if (isValid) {
            if (this.changeMemberNameForm && this.changeMemberNameForm.value && this.basicInfo) {
                var updateBasicInfo_1 = Object.assign({}, this.basicInfo);
                updateBasicInfo_1.firstName = this.changeMemberNameForm.value.firstName;
                updateBasicInfo_1.middleName = this.changeMemberNameForm.value.middleName;
                updateBasicInfo_1.lastName = this.changeMemberNameForm.value.lastName;
                if (this.basicInfo.firstName !== this.changeMemberNameForm.value.firstName
                    || this.basicInfo.lastName !== this.changeMemberNameForm.value.lastName) {
                    var verifyAccountModel = this.prepareMemberVerifyAccountRequest(updateBasicInfo_1);
                    this._customerService.validateMemberUniqueFieldsWithAddress(verifyAccountModel)
                        .subscribe(function (response) {
                        if (response && !response.accountExists) {
                            _this.updateNameForMemberBasicInfo(updateBasicInfo_1);
                        }
                        else if (response && response.accountExists) {
                            var msg = _this._translatePipe.get('customer-service.User details exists')['value'];
                            _this._commonService.createNotification('', msg, NotificationType.ERROR);
                        }
                    }, function (err) { });
                }
                else {
                    this.updateNameForMemberBasicInfo(updateBasicInfo_1);
                }
            }
        }
    };
    /**
     * @description
     * @date 2019-08-09
     * @private
     * @param {MemberBasicInfo} updateBasicInfo
     * @returns {VerifyAccountModel}
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.prepareMemberVerifyAccountRequest = function (updateBasicInfo) {
        var verifyAccountModel = {
            includeMemberTypeToVerify: true,
            firstName: updateBasicInfo.firstName,
            lastName: updateBasicInfo.lastName,
            memberTypeId: this.fboProfileDetail.memberTypeId,
            addressTypeId: this.fboProfileDetail.address.addressTypeId,
            addressLine1: this.fboProfileDetail.address.addressLine1,
            addressLine2: this.fboProfileDetail.address.addressLine2 ? this.fboProfileDetail.address.addressLine2 : '',
            city: this.fboProfileDetail.address.city,
            stateId: this.fboProfileDetail.address.stateId,
            postalCode: this.fboProfileDetail.address.zipCode,
            countryId: this.fboProfileDetail.address.countryId,
            memberId: this.fboProfileDetail.memberId
        };
        return verifyAccountModel;
    };
    /**
     * @description
     * @date 2019-08-09
     * @param {MemberBasicInfo} updateBasicInfo
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.updateNameForMemberBasicInfo = function (updateBasicInfo) {
        var _this = this;
        if (this.basicInfo.firstName !== this.changeMemberNameForm.value.firstName
            || this.basicInfo.lastName !== this.changeMemberNameForm.value.lastName
            || this.basicInfo.middleName !== this.changeMemberNameForm.value.middleName) {
            updateBasicInfo.changedValueType = [FBOProfileUpdateEnum.MEMBER_NAME_CHANGE];
        }
        var transliterateProp = this.populateTransliterateObj();
        this._customerService.updateMemberBasicInfo(updateBasicInfo, transliterateProp).subscribe(function (response) {
            if (response.success) {
                _this.saveMemberNameActiveLog(_this.basicInfo, updateBasicInfo);
                var msg = _this._translatePipe.get('customer-service.Update completed Successful.')['value'];
                _this._commonService.createNotification('', msg, NotificationType.SUCCESS);
                _this.updateMemberNamePopup.close();
                _this.disableNameButton = false;
                _this.getFBOProfileInfoFromTitan();
            }
            else if (response.validations && response.validations.length) {
                _this.errorCodes = response.validations;
                _this.disableNameButton = false;
            }
        }, function (err) { });
    };
    /**
     * @description
     * @date 2019-08-09
     * @param {MemberBasicInfo} basicInfo
     * @param {MemberBasicInfo} updateBasicInfo
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.saveMemberNameActiveLog = function (basicInfo, updateBasicInfo) {
        var activityLogKeys = [];
        if (basicInfo.firstName !== updateBasicInfo.firstName) {
            activityLogKeys.push({
                key: MemberActivityLogType.Member_First_Name_Updated,
                value: updateBasicInfo.firstName
            });
        }
        if (basicInfo.middleName !== updateBasicInfo.middleName) {
            activityLogKeys.push({
                key: MemberActivityLogType.Member_Middle_Name_Updated,
                value: updateBasicInfo.middleName
            });
        }
        if (basicInfo.lastName !== updateBasicInfo.lastName) {
            activityLogKeys.push({
                key: MemberActivityLogType.Member_Last_Name_Updated,
                value: updateBasicInfo.lastName
            });
        }
        if (activityLogKeys && activityLogKeys.length) {
            this._commonService.saveMemberActivity(basicInfo.memberId, activityLogKeys)
                .subscribe(function (res) { }, function (error) { });
        }
    };
    /**
     * @description open phone number update modal
     * @date 2019-07-29
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.openUpdatePhoneNumberModal = function () {
        var _this = this;
        this.errorCodes = [];
        this.closePhoneNumberPopup();
        this._customerService.getMemberBasicInfoById(+this.fboProfileDetail.memberId).subscribe(function (basicInfo) {
            if (basicInfo) {
                _this.showUpdatePhoneModal = true;
                _this.basicInfo = basicInfo;
                _this.mapBasicInfoResponse();
                _this.updatePhoneNumberForm = _this._formbuilder.group({
                    phoneType: [_this.basicInfo.phoneType, [Validators.required]],
                    phoneNumber: [_this.basicInfo.phone, _this.addValidationsForForm()]
                });
                _this.updatePhoneNumberPopup.open();
            }
        }, function (errorRes) {
            var addedNotification = _this._translatePipe.get('errorcodes.Unable to Update Phone Number. Please try again later')['value'];
            _this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
        });
    };
    FBOProfileComponent.prototype.addValidationsForForm = function (isPhoneNotRequired) {
        var fieldValidations = [];
        var formControlName = this.personalInfoFormValidations
            ? this.personalInfoFormValidations[PersonalInfoFormConstants.PHONENUMBER]
            : {};
        if (formControlName) {
            if (formControlName[PersonalInfoFormConstants.MINLENGTH]) {
                fieldValidations.push(Validators.minLength(formControlName[PersonalInfoFormConstants.MINLENGTH]));
            }
            if (formControlName[PersonalInfoFormConstants.MAXLENGTH]) {
                fieldValidations.push(Validators.maxLength(formControlName[PersonalInfoFormConstants.MAXLENGTH]));
            }
            if (formControlName[PersonalInfoFormConstants.PATTERN]) {
                fieldValidations.push(Validators.pattern(formControlName[PersonalInfoFormConstants.PATTERN]));
            }
            if (formControlName[PersonalInfoFormConstants.Required]) {
                if (!(this.phoneNumbers && this.phoneNumbers.length > 1)) {
                    if (!isPhoneNotRequired) {
                        fieldValidations.push(Validators.required);
                    }
                }
            }
        }
        return fieldValidations;
    };
    /**
     * @description map phone number while changing phone type
     * @date 2019-07-29
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.onChangePhoneType = function (value) {
        var phoneNumber = this.basicInfo.memberContacts.find(function (x) {
            return (x.contactTypeID === +value);
        });
        var phone;
        if (phoneNumber) {
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(phoneNumber.value, this.phoneNumberFormat);
            }
            else {
                phone = phoneNumber.value;
            }
            this.updatePhoneNumberForm.controls['phoneNumber'].setValue(phone);
            this.updatePhoneNumberForm.controls['phoneNumber'].setValidators(this.addValidationsForForm(false));
            this.updatePhoneNumberForm.controls['phoneNumber'].updateValueAndValidity();
        }
        else {
            this.updatePhoneNumberForm.controls['phoneNumber'].setValue('');
            this.updatePhoneNumberForm.controls['phoneNumber'].setValidators(this.addValidationsForForm(true));
            this.updatePhoneNumberForm.controls['phoneNumber'].updateValueAndValidity();
        }
    };
    /**
     * @description map basic info response
     * @date 2019-07-29
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.mapBasicInfoResponse = function () {
        var _this = this;
        var phoneNumber = this.basicInfo.memberContacts.find(function (x) { return (x.contactTypeID === ContactTypeValue.MOBILE
            || x.contactTypeID === ContactTypeValue.PHONE); });
        if (phoneNumber) {
            this.phoneNumberFormat = this.phoneNumberFormat || '';
            if (this.phoneNumberFormat) {
                this.basicInfo.phone = this._maskPipe.transform(phoneNumber.value, this.phoneNumberFormat);
            }
            else {
                this.basicInfo.phone = phoneNumber.value;
            }
            this.basicInfo.phoneType = phoneNumber.contactTypeID;
        }
        this.basicInfo.memberContacts.forEach(function (info) {
            if (info.contactTypeID === ContactTypeValue.MOBILE || info.contactTypeID === ContactTypeValue.PHONE) {
                _this.phoneNumbers.push(info);
            }
        });
    };
    /**
     * @description close phone number popup
     * @date 2019-07-29
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.closePhoneNumberPopup = function () {
        this.updatePhoneNumberPopup.close();
        this.showUpdatePhoneModal = false;
        this.phoneNumbers = [];
    };
    /**
     * @description Update phone number
     * @date 2019-07-29
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.onSubmitPhoneNumber = function (isValid) {
        var _this = this;
        this.errorCodes = [];
        if (isValid) {
            if (this.updatePhoneNumberForm && this.updatePhoneNumberForm.value && this.basicInfo) {
                var phone_1 = this.updatePhoneNumberForm.value.phoneNumber.trim().replace(/[^a-zA-Z0-9]/g, '');
                this._customerService.updateMemberBasicInfo(this.mapPhoneNumberToBasicInfo(this.basicInfo, phone_1, +this.updatePhoneNumberForm.value.phoneType)).subscribe(function (response) {
                    if (response.success) {
                        _this.saveMemberPhoneActivityLog(phone_1, +_this.updatePhoneNumberForm.value.phoneType);
                        var msg = _this._translatePipe.get('customer-service.Update completed Successful.')['value'];
                        _this._commonService.createNotification('', msg, NotificationType.SUCCESS);
                        _this.closePhoneNumberPopup();
                        _this.getFBOProfileInfoFromTitan();
                    }
                    else if (response.validations && response.validations.length) {
                        _this.errorCodes = response.validations;
                    }
                }, function (err) { });
            }
        }
    };
    /** Save member activity log while updating phone number
     *saveMemberPhoneActivityLog()
    */
    FBOProfileComponent.prototype.saveMemberPhoneActivityLog = function (phone, phoneType) {
        var _this = this;
        var activityLogKeys = [];
        if (this.basicInfo.phone !== phone) {
            var value = this.contactTypes.find(function (x) { return x.value === phoneType; }).name;
            var translateValue = this.getMessageTemplate(false, ContactTypeValue.PHONE === phoneType ? PhoneUpdateMessageConstants.HOME : value, '', phone);
            activityLogKeys.push({
                key: MemberActivityLogType.Phone_Updated,
                value: translateValue
            });
        }
        if (this.basicInfo.phoneType !== phoneType) {
            var value = this.contactTypes.find(function (x) { return x.value === phoneType; }).name;
            var oldType = this.contactTypes.find(function (x) { return x.value === _this.basicInfo.phoneType; }).name;
            var translateValue = this.getMessageTemplate(true, ContactTypeValue.PHONE === phoneType ? PhoneUpdateMessageConstants.HOME : value, ContactTypeValue.PHONE === this.basicInfo.phoneType ? PhoneUpdateMessageConstants.HOME : oldType);
            activityLogKeys.push({
                key: MemberActivityLogType.Phone_Type_Updated,
                value: translateValue
            });
        }
        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
    };
    /** get message while updating phone number and type.
     * getMessageTemplate()
    */
    FBOProfileComponent.prototype.getMessageTemplate = function (isUpdatePhoneType, phoneType, oldType, phoneNumber) {
        var value = '';
        if (isUpdatePhoneType) {
            var translatedValues = {
                phoneType: phoneType,
                oldType: oldType
            };
            value = this._translateKey.transform(PhoneUpdateMessageConstants.PHONE_TYPE_UPDATE_TEMPLATE, translatedValues);
        }
        else {
            var translatedValues = {
                phoneType: phoneType,
                phoneNumber: phoneNumber
            };
            value = this._translateKey.transform(PhoneUpdateMessageConstants.PHONE_UPDATE_TEMPLATE, translatedValues);
        }
        return value;
    };
    /**
    * Mapping member basic info request
    */
    FBOProfileComponent.prototype.mapPhoneNumberToBasicInfo = function (profileInfo, phone, phoneType) {
        var phoneNumber = profileInfo.memberContacts.find(function (x) { return (x.contactTypeID === phoneType); });
        if (phoneNumber) {
            profileInfo.memberContacts.forEach(function (item) {
                if (item.contactTypeID === phoneType) {
                    item.value = phone;
                }
            });
        }
        else {
            var phoneContact = {
                contactTypeID: phoneType,
                value: phone
            };
            profileInfo.memberContacts.push(phoneContact);
        }
        var memberBasicInfo = {
            firstName: profileInfo.firstName,
            displayName: profileInfo.displayName,
            lastName: profileInfo.lastName,
            middleName: profileInfo.middleName,
            memberId: profileInfo.memberId,
            userId: profileInfo.userId,
            email: profileInfo.email,
            primaryEmailId: profileInfo.email,
            phoneNumber: phone,
            memberPreferences: profileInfo.memberPreferences,
            memberContacts: profileInfo.memberContacts,
            phone: phone,
            phoneType: phoneType,
            storeId: this.storeId,
            memberGovernmentIdentifications: profileInfo.memberGovernmentIdentifications,
            changedValueType: [FBOProfileUpdateEnum.MEMBER_PHONE_CHANGE]
        };
        return memberBasicInfo;
    };
    FBOProfileComponent.prototype.openUpdateDOBModal = function () {
        this.changeDOBForm = this._formbuilder.group({
            birthDate: ['', Validators.required]
        });
        document.documentElement.classList.add('dob-popup');
        this.changeDOBPopup.open();
        setTimeout(function () {
            var element = document.getElementById('birthDate');
            if (element) {
                element.focus();
            }
        }, 200);
        if (this.fboProfileDetail.birthDate) {
            this.changeDOBForm.controls['birthDate'].setValue(moment(this.fboProfileDetail.birthDate, 'dd-MMM-yyyy'));
        }
        this.changeDOBForm.controls['birthDate'].setValidators([Validators.required, Utils.validateDateOfBirth]);
    };
    FBOProfileComponent.prototype.checkValidationForMonthlyLimitEndDate = function () {
        this.overrideMonthlyCCLimitForm.controls['endDate'].updateValueAndValidity();
    };
    FBOProfileComponent.prototype.showCancellationMsg = function (retailSubscriptionDetails) {
        var notification = __assign({}, retailSubscriptionDetails);
        if (this.isRetailSubscriptionLogin) {
            if (retailSubscriptionDetails.isRetailSubscriptionCancelled && retailSubscriptionDetails.isretailSubscriptionMessage) {
                notification.initialMsg = notification.initialMsg + ',' + Constants.SUBSCRIPTION_CANCELLED;
                notification.msgType = NotificationType.SUCCESS;
            }
            if (!retailSubscriptionDetails.isRetailSubscriptionCancelled && retailSubscriptionDetails.isretailSubscriptionMessage) {
                notification.initialMsg = notification.initialMsg + ',' + Constants.SUBSCRIPTION_CANCELLED_ERROR;
                notification.msgType = NotificationType.ERROR;
            }
        }
        return notification;
    };
    FBOProfileComponent.prototype.statusUpdateErrorMessage = function (isretailSubscriptionMessage) {
        isretailSubscriptionMessage.initialMsg = Constants.STATUS_UPDATED_NOTE_FAILED;
        var retailSubscriptionMsg = this.showCancellationMsg(isretailSubscriptionMessage);
        var msg = this._translatePipe.get('customer-service.' + retailSubscriptionMsg.initialMsg).value;
        this._commonService.createNotification('', msg, NotificationType.ERROR);
    };
    FBOProfileComponent.prototype.businessEnitiySubmit = function () {
        this.disableBusinessEntityButton = true;
        this.businessEntityForm.value.startDate = moment(new Date(), 'DD-MMM-YYYY');
        this.businessEntityForm.controls['startDate'].setValue(this.businessEntityForm.value.startDate);
        this.businessEntityBWP = true;
        this.vatIdBWP = false;
        this.checkBondedWarehouseProject();
    };
    FBOProfileComponent.prototype.checkBusinessEntitySubmit = function () {
        var _this = this;
        if (this.appConfig && this.appConfig.businessEntityConfig && this.appConfig.businessEntityConfig.hideStateCode
            && !this.businessEntityForm.value.stateCodeId) {
            var state = this.states.filter(function (item) { return item.countryId == _this.businessEntityForm.value.countryCodeId; })[0];
            this.businessEntityForm.controls['stateCodeId'].setValue(state.id);
        }
        this.businessEntityForm.value.startDate = moment(new Date(), 'DD-MMM-YYYY');
        if (this.appConfig && this.appConfig.businessEntityConfig && this.appConfig.businessEntityConfig.showVatPayer) {
            if (VatPayerOption.Y === +this.businessEntityForm.value.vatPayer) {
                this.businessEntityForm.value.vatPayer = 'Y';
            }
            else {
                this.businessEntityForm.value.vatPayer = 'N';
            }
        }
        this.businessEntityForm.value.endDate = Utils.convertToSpecificDateFormat(this.businessEntityForm.value.endDate, DateConstants.DOBConvertFormat);
        this.businessEntityForm.value.startDate = Utils.convertToSpecificDateFormat(this.businessEntityForm.value.startDate, DateConstants.DOBConvertFormat);
        var transliterateProp = this.populateTransliterateObj();
        if (this.fboBusinessEntity && this.businessEntityForm && this.businessEntityForm.value) {
            var formattedStartDate = moment(this.fboBusinessEntity.startDate, "DD-MMM-YYYY").format("DD-MM-YYYY");
            if (this.fboBusinessEntity.businessEntityName != this.businessEntityForm.value.businessEntityName
                || this.fboBusinessEntity.businessEntityIdType != this.businessEntityForm.value.businessEntityIdType
                || this.fboBusinessEntity.businessEntityId != this.businessEntityForm.value.businessEntityId
                || this.fboBusinessEntity.incomeTaxID != this.businessEntityForm.value.incomeTaxID
                || this.fboBusinessEntity.addressLine1 != this.businessEntityForm.value.addressLine1
                || this.fboBusinessEntity.addressLine2 != this.businessEntityForm.value.addressLine2
                || this.fboBusinessEntity.city != this.businessEntityForm.value.city
                || this.fboBusinessEntity.countryCodeId != this.businessEntityForm.value.countryCodeId
                || formattedStartDate != this.businessEntityForm.value.startDate
                || this.fboBusinessEntity.endDate != this.businessEntityForm.value.endDate
                || this.fboBusinessEntity.status != this.businessEntityForm.value.status) {
                this.updateBusinessEntity = true;
            }
        }
        if (this.businessEntityForm.value.endDate && (this.businessEntityForm.value.endDate < this.businessEntityForm.value.startDate)) {
            var notification = this._translatePipe.get('order.Unable to Update Business Entity');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
        else {
            this._customerService.updateBusinessEntity(this.fboProfileDetail.memberId, this.businessEntityForm.value, transliterateProp, this.updateBusinessEntity).subscribe(function (response) {
                if (response.isSuccess) {
                    var activityLogKeys = [{
                            key: MemberActivityLogType.Change_Business_Entity,
                            value: _this.prepareBussinessEntityLogMessage(_this.businessEntityForm.value)
                        }];
                    _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                    _this.changeBusinessEntityPopup.close();
                    _this.bwpConfirmationModal.close();
                    _this.disableBusinessEntityButton = false;
                    _this.updateBusinessEntity = false;
                    if (_this.businessEntityInfo && _this.businessEntityInfo.length > 0) {
                        var notification = _this._translatePipe.get('order.Business Entity Updated Sucessfully.Today’s Date will be the New Start Date.');
                        _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    }
                    else {
                        var notification = _this._translatePipe.get('order.Business Entity Updated Sucessfully');
                        _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    }
                    _this.getMemberBusinessEntityInfo(_this.fboProfileDetail.memberId, _this.fboProfileDetail.homeCountryCode, _this.fboProfileDetail.preferenceValue);
                }
                else {
                    _this.updateBusinessEntity = false;
                    _this.disableBusinessEntityButton = false;
                    var notification = _this._translatePipe.get('order.Unable to Update Business Entity');
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
            });
        }
    };
    FBOProfileComponent.prototype.prepareBussinessEntityLogMessage = function (businessEntity) {
        var businessEntityLogMessage = businessEntity.businessEntityName;
        if (businessEntity.businessEntityId && businessEntity.businessEntityId !== '') {
            businessEntityLogMessage += ', ' + businessEntity.businessEntityId.substr(-4);
        }
        if (businessEntity.incomeTaxID && businessEntity.incomeTaxID !== '') {
            businessEntityLogMessage += ', ' + businessEntity.incomeTaxID.substr(-4);
        }
        if (businessEntity.businessEntityIdType && businessEntity.businessEntityIdType !== '') {
            if (businessEntity.businessEntityIdType == BusinessEntityIdType.CORPORATION) {
                businessEntityLogMessage += ', ' + BusinessEntityType.CORPORATION;
            }
            else if (businessEntity.businessEntityIdType == BusinessEntityIdType.LIABILITY) {
                businessEntityLogMessage += ', ' + BusinessEntityType.LIABILITY;
            }
            else if (businessEntity.businessEntityIdType == BusinessEntityIdType.OTHER_BUSINESS_ENTITY) {
                businessEntityLogMessage += ', ' + BusinessEntityType.OTHER_BUSINESS_ENTITY;
            }
            else if (businessEntity.businessEntityIdType == BusinessEntityIdType.TRUST) {
                businessEntityLogMessage += ', ' + BusinessEntityType.TRUST;
            }
        }
        businessEntityLogMessage += ', ' + businessEntity.addressLine1;
        if (businessEntity.addressLine2 && businessEntity.addressLine2 !== '') {
            businessEntityLogMessage += ', ' + businessEntity.addressLine2;
        }
        if (businessEntity.city && businessEntity.city !== '') {
            businessEntityLogMessage += ', ' + businessEntity.city;
        }
        if (businessEntity.stateCodeId && businessEntity.stateCodeId !== '') {
            var statesModal = this.states.filter(function (item) { return item.id == businessEntity.stateCodeId; })[0];
            businessEntityLogMessage += ', ' + statesModal.stateCode;
        }
        if (businessEntity.countryCodeId && businessEntity.countryCodeId !== '') {
            var countriesModal = this.countriesList.filter(function (item) { return item.countryId === businessEntity.countryCodeId; })[0];
            businessEntityLogMessage += ', ' + countriesModal.isocodeThree;
        }
        businessEntityLogMessage += ', ' + businessEntity.postalCode + '.';
        if (businessEntity.status && businessEntity.status !== '') {
            businessEntityLogMessage += ' Status is ' + (businessEntity.status == 1 ? 'Active' : 'In-Active');
        }
        if (businessEntity.startDate && businessEntity.startDate !== '') {
            businessEntityLogMessage += ', Start Date ' + this.convertTODateFormat(moment(this.convertToSpecificDateFormat(businessEntity.startDate), 'DD-MMM-YYYY'));
        }
        if (businessEntity.endDate && businessEntity.endDate !== '') {
            businessEntityLogMessage += ', End Date ' + this.convertTODateFormat(moment(this.convertToSpecificDateFormat(businessEntity.endDate), 'DD-MMM-YYYY'));
        }
        return businessEntityLogMessage;
    };
    FBOProfileComponent.prototype.statusChangeTransformDate = function (date) {
        var dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DateFormat);
        if (dateMomentObj) {
            if (!(this.statusForm.controls['endDate'].hasError('Required') || this.statusForm.controls['endDate'].hasError('dateValidation'))) {
                this.statusForm.controls['endDate'].setValue(moment(dateMomentObj, 'DD-MMM-YYYY'));
            }
        }
    };
    FBOProfileComponent.prototype.convertTODateFormat = function (dateMomentObj) {
        var characterCheck = /[a-zA-z]/;
        if (typeof dateMomentObj._i === 'object') {
            dateMomentObj = dateMomentObj._d;
            dateMomentObj = this.momentConstructor(new Date(dateMomentObj))
                .format('DD-MMM-YYYY');
        }
        if (typeof dateMomentObj._i === 'string') {
            dateMomentObj = dateMomentObj._i;
            var dateParts = dateMomentObj.split('-');
            if (!characterCheck.test(dateParts[1])) {
                dateMomentObj = this.momentConstructor(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                    .format('DD-MMM-YYYY');
            }
        }
        return dateMomentObj;
    };
    /**
* @description convert date to specific format
* @date 2019-01-03
* @param {*} dateMomentObj
* @returns
* @memberof CreateWorkTicket
*/
    FBOProfileComponent.prototype.convertToSpecificDateFormat = function (dateMomentObj) {
        if (dateMomentObj) {
            var characterCheck = /[a-zA-z]/;
            if (dateMomentObj && typeof dateMomentObj._i === 'object') {
                dateMomentObj = dateMomentObj._d;
                dateMomentObj = this.momentConstructor(new Date(dateMomentObj))
                    .format('DD-MM-YYYY');
            }
            if (dateMomentObj && typeof dateMomentObj._i === 'string') {
                dateMomentObj = dateMomentObj._i;
                var dateParts = dateMomentObj.split('-');
                if (characterCheck.test(dateParts[1])) {
                    dateMomentObj = moment(dateMomentObj, 'DD-MMM-YYYY').format('DD-MM-YYYY');
                }
                else {
                    dateMomentObj = this.momentConstructor(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0])).format('DD-MM-YYYY');
                }
            }
        }
        return dateMomentObj;
    };
    FBOProfileComponent.prototype.businessEntityTransformDate = function (date, isStartDate) {
        var dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DOBConvertFormat);
        if (dateMomentObj) {
            if (isStartDate) {
                if (this.businessEntityForm.controls['startDate'].valid) {
                    this.businessEntityForm.controls['startDate'].setValue(moment(dateMomentObj, 'DD-MM-YYYY'));
                }
            }
            else if (this.businessEntityForm.controls['endDate'].valid) {
                this.businessEntityForm.controls['endDate'].setValue(moment(dateMomentObj, 'DD-MM-YYYY'));
            }
        }
    };
    /**
     * @description convert to Date Format
     * @date 2019-06-12
     * @param {string} date
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.convertDateFormat = function (date) {
        this.businessEntityForm.controls['startDate'].setValue(moment(date, 'DD-MMM-YYYY'));
    };
    FBOProfileComponent.prototype.birthdatetransformDate = function (date) {
        var dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DOBConvertFormat);
        if (dateMomentObj) {
            if (this.changeDOBForm.controls['birthDate'].valid) {
                this.changeDOBForm.controls['birthDate'].setValue(moment(dateMomentObj, 'DD-MM-YYYY'));
            }
        }
    };
    FBOProfileComponent.prototype.checkValidationForStartDate = function () {
        this.businessEntityForm.controls['startDate'].updateValueAndValidity();
    };
    FBOProfileComponent.prototype.checkValidationForEndDate = function () {
        if (this.businessEntityForm) {
            this.businessEntityForm.controls['endDate'].updateValueAndValidity();
        }
    };
    /**
     * @description Fetch PC Sponsor participation details of Store
     * @param store
     */
    FBOProfileComponent.prototype.fetchPCSponsorEligiblityForStore = function (store) {
        var _this = this;
        if (store && store.businessEntityId) {
            this._configurationService.getBusinessEntityDetails(store.businessEntityId).subscribe(function (businessEntityDetails) {
                if (businessEntityDetails && businessEntityDetails.pCSponsorshipParticipationType == PCSponsorConstants.PCSPONSORSHIP_PARITICIPATION_TYPE
                    && !environment.hidePCSponsorshipCountries.split(',').includes(_this.storeInfo.operatingCountry)) {
                    _this.enableUpdatePCSponsor = true;
                }
                else {
                    _this.enableUpdatePCSponsor = false;
                }
            });
        }
    };
    FBOProfileComponent.prototype.updatePCSponsorEligibility = function () {
        if (this.isFpcEligibleForPcSponsor) {
            this.pcSponsorEligibleStatus = 'Yes';
        }
        else {
            this.pcSponsorEligibleStatus = 'No';
        }
        this.selectedStatus = this.pcSponsorEligibleStatus;
        this.enableSubmit = false;
        this.updatePCSponsorStatusPopup.open();
    };
    /* To enable Submit button only if the selected value differs */
    FBOProfileComponent.prototype.onPCSponsorValueChange = function (event) {
        if (this.selectedStatus == this.pcSponsorEligibleStatus) {
            this.enableSubmit = false;
        }
        else {
            this.enableSubmit = true;
        }
    };
    FBOProfileComponent.prototype.onPCSponsorEligibilityChange = function () {
        var _this = this;
        var requestArray = {
            storeISOCodeThree: this.homeCountry,
            operatingCountryCode: this.fboProfileDetail.operatingCountryCode,
            pcSponsorEligibility: this.selectedStatus == 'No' ? false : true,
            memberId: this.fboProfileDetail.memberId
        };
        this._sponsorService.updatePCSponsorElgibility(this.fboProfileDetail.memberId, requestArray).subscribe(function (response) {
            if (response.isSuccess === true) {
                var activityLogKeys = [{
                        key: MemberActivityLogType.PCSponsor_Eligibility_Updated,
                        value: (_this.isFpcEligibleForPcSponsor == false ? "Not Eligible" : "Eligible") + ' to ' + (_this.selectedStatus == 'No' ? "Eligible" : "Not Eligible")
                    }];
                _this._commonService.saveMemberActivity(_this.fboProfileDetail.memberId, activityLogKeys).subscribe(function (res) { }, function (error) { });
                _this._commonService.createNotification('', 'PC Sponsor eligibility status updated successfully', NotificationType.SUCCESS);
            }
            else {
                _this._commonService.createNotification('', 'PC Sponsor eligibility status update failed', NotificationType.ERROR);
            }
        });
        this.getDistributorWithPaymentDetails();
        this.selectedStatus = this.pcSponsorEligibleStatus;
        this.updatePCSponsorStatusPopup.close();
    };
    /**
     * @description will logout all sessions of the user
     * @date 2020-09-17
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.logOutUserSessions = function () {
        this._customerService.logOutUserSessions(this.fboProfileDetail.fboId)
            .subscribe(function (response) { }, function (error) { });
    };
    /**
     * Send mail to reset FLP360 password
     */
    FBOProfileComponent.prototype.sendMailForFlp360ResetPassword = function () {
        var _this = this;
        //Send mail for flp360 reset password
        this._customerService.sendFlp360PasswordResetLink(this.fboProfileDetail.fboId)
            .subscribe(function (response) {
            if (response) {
                if (response.isSuccess) {
                    //Add activity log for flp360 email for password change
                    var activityLogKeys = [{
                            key: MemberActivityLogType.Flp360_Password_Reset_Emailed,
                            value: _this.fboProfileDetail.fboId
                        }];
                    if (_this.fboProfileDetail.id) {
                        _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                    }
                    _this._commonService.createNotification('', 'Password reset link has been sent to Email', NotificationType.SUCCESS);
                    _this.flp360ResetPasswordPopup.close();
                }
                else {
                    _this._commonService.createNotification('', 'Password Reset failed', NotificationType.ERROR);
                    _this.flp360ResetPasswordPopup.close();
                }
            }
        }, function (error) {
            _this._commonService.createNotification('', 'Password Reset failed', NotificationType.ERROR);
            _this.flp360ResetPasswordPopup.close();
        });
    };
    /**
     * Update the FLP360 password
     */
    FBOProfileComponent.prototype.updateFlp360TemporaryPassword = function () {
        var _this = this;
        if (this.flp360ResetPasswordForm.controls['flp360ResetPassword'].value === this.selectEnum.secondOption.toString()) {
            this.sendMailForFlp360ResetPassword();
        }
        else {
            //construct temporary password format
            var tempPasskey = this.fboProfileDetail.fboId + '||' + btoa(this.tempPassword);
            tempPasskey = EncryptionService.encryptText(tempPasskey);
            //Set temporary password
            this._customerService.setFlp360TemporaryPassword(tempPasskey)
                .subscribe(function (response) {
                if (response.isSuccess) {
                    //Add activity log for flp360 password change
                    var activityLogKeys = [{
                            key: MemberActivityLogType.Flp360_Change_Temporary_Password,
                            value: _this.fboProfileDetail.fboId
                        }];
                    if (_this.fboProfileDetail.id) {
                        _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                    }
                    var notification = _this._translatePipe.get('customer-service.Temporary Password Updated Successfully');
                    _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    _this.flp360ResetPasswordPopup.close();
                }
                else if (response.validations && response.validations.length) {
                    var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].message);
                    _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                    _this.flp360ResetPasswordPopup.close();
                }
            }, function (error) {
                if (error && error.validations && error.validations.length) {
                    var addedNotification = _this._translatePipe.get('errorcodes.' + error.validations[0].message);
                    _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                    _this.flp360ResetPasswordPopup.close();
                }
            });
        }
    };
    FBOProfileComponent.prototype.openChangeBusinessEntityModal = function () {
        var _this = this;
        this.statesModal = [];
        var startDateValue;
        var endDateValue;
        if (!(this.fboBusinessEntity.countryCodeId >= 0)) {
            this.fboBusinessEntity.countryCodeId = this.fboProfileDetail.homeCountryId;
        }
        if (this.fboBusinessEntity && this.fboBusinessEntity.startDate) {
            startDateValue = moment(this.fboBusinessEntity.startDate, 'DD-MMM-YYYY');
        }
        else {
            startDateValue = moment(new Date(), 'DD-MMM-YYYY');
        }
        if (this.fboBusinessEntity && this.fboBusinessEntity.endDate) {
            endDateValue = moment(this.fboBusinessEntity.endDate, 'DD-MM-YYYY');
        }
        var taxIDValidation = [this.fboBusinessEntity.incomeTaxID, [Validators.required, Validators.maxLength(20), Utils.alphaNumericIphenCharacterValidation]];
        var stateCodeValidation = [this.fboBusinessEntity.stateCodeId || '', Validators.required];
        if (this.appConfig && this.appConfig.businessEntityConfig) {
            if (this.appConfig.businessEntityConfig.displayVATID) {
                taxIDValidation = [this.fboBusinessEntity.incomeTaxID, [Validators.required, Validators.minLength(2), Validators.maxLength(20), Utils.alphaNumericIphenCharacterValidation]];
            }
            if (this.appConfig.businessEntityConfig.hideStateCode) {
                stateCodeValidation = [this.fboBusinessEntity.stateCodeId || ''];
            }
        }
        var fbovatpayer;
        if (this.appConfig && this.appConfig.businessEntityConfig && this.appConfig.businessEntityConfig.showVatPayer) {
            if (this.fboBusinessEntity.vatPayer == 'Y') {
                fbovatpayer = this.vatPayerOption.Y;
            }
            else {
                fbovatpayer = this.vatPayerOption.N;
            }
        }
        this.businessEntityForm = this._formbuilder.group({
            businessEntityName: [this.fboBusinessEntity.businessEntityName, [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
            businessEntityId: [this.fboBusinessEntity.businessEntityId || '', this.getBusinessEntityValidators('businessEntityId')],
            incomeTaxID: taxIDValidation,
            businessEntityIdType: [this.fboBusinessEntity.businessEntityIdType || '', [Validators.required]],
            addressLine1: [this.fboBusinessEntity.addressLine1, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
            addressLine2: [this.fboBusinessEntity.addressLine2, [Validators.minLength(3), Validators.maxLength(50)]],
            city: [this.fboBusinessEntity.city, [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
            stateCodeId: stateCodeValidation,
            countryCodeId: [this.fboBusinessEntity.countryCodeId],
            postalCode: [this.fboBusinessEntity.postalCode, [Validators.required, Validators.minLength(4), Validators.maxLength(10)]],
            status: [this.fboBusinessEntity.status || '', Validators.required],
            startDate: [startDateValue],
            endDate: [endDateValue],
            vatPayer: [fbovatpayer]
        });
        if (this.personalInfoSettings.removeVatId) {
            this.businessEntityForm.removeControl('incomeTaxID');
        }
        this.businessEntityForm.controls['startDate'].disable();
        this.businessEntityForm.controls['endDate'].setValidators([Utils.validateEndDate]);
        this.statesModal = this.states.filter(function (item) { return item.countryId === _this.businessEntityForm.controls['countryCodeId'].value; });
        this.changeBusinessEntityPopup.open();
    };
    FBOProfileComponent.prototype.closeMemberlevelUpdatePopup = function () {
        this.changeMemberTypeandLevelPopup.close();
    };
    /**
    * To close Account Notification PopUp
    */
    FBOProfileComponent.prototype.closePopUpforAccountNotificationChange = function () {
        this.accountNotificationChangePopup.close();
    };
    /**
     * @description To close Update Name PopUp
     * @date 2019-08-01
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.closePopUpforNameChange = function () {
        this.updateMemberNamePopup.close();
    };
    /**
    * To close change Email PopUp
    */
    FBOProfileComponent.prototype.closePopUpforEmailChange = function () {
        this.changeEmailPopup.close();
    };
    /**
    * converts input to Member Basic Info
    */
    FBOProfileComponent.prototype.mapToBasicInfo = function (profileInfo, email) {
        var memberBasicInfo = {
            firstName: '',
            lastName: '',
            middleName: '',
            memberId: 0,
            userId: 0,
            storeId: 0,
            primaryEmailId: '',
            phoneNumber: '',
            memberContacts: [],
            memberPreferences: [],
            memberGovernmentIdentifications: [],
            changedValueType: []
        };
        memberBasicInfo.firstName = profileInfo.firstName;
        memberBasicInfo.displayName = profileInfo.displayName;
        memberBasicInfo.lastName = profileInfo.lastName;
        memberBasicInfo.middleName = profileInfo.middleName;
        memberBasicInfo.memberId = profileInfo.memberId;
        memberBasicInfo.userId = profileInfo.userId;
        memberBasicInfo.primaryEmailId = email;
        memberBasicInfo.phoneNumber = profileInfo.phone ? profileInfo.phone.replace(/[^a-zA-Z0-9]/g, '') : '';
        memberBasicInfo.memberPreferences = profileInfo.memberPreferences;
        memberBasicInfo.memberContacts = profileInfo.memberContacts;
        if (this.fboProfileDetail.emailId && memberBasicInfo.primaryEmailId !== this.fboProfileDetail.emailId) {
            memberBasicInfo.changedValueType = [FBOProfileUpdateEnum.MEMBER_EMAIL_CHANGE];
        }
        return memberBasicInfo;
    };
    /**
   * @param  {Array<any>} items
   * @param  {predicate} filterOptions
   * @returns Array<any>
   */
    FBOProfileComponent.prototype.transform = function (translateText, param) {
        if (translateText) {
            if (param) {
                translateText.match(/(\|\|{1}\w+\|\|{1})/g)
                    .map(function (x, y) {
                    translateText = translateText.replace(x, param);
                });
            }
            return translateText;
        }
    };
    FBOProfileComponent.prototype.closePopUp = function () {
        this.unlockPopup.close();
        if (this.bsModalRef) {
            this.bsModalRef.hide();
        }
        this.changeSponsorPopup.close();
        this.overrideMonthlyCCLimitPopup.close();
        this.changeStatusPopup.close();
        this.updatePCSponsorStatusPopup.close();
        this.resetPasswordPopup.close();
        this.changeMemberPreference.close();
        document.documentElement.classList.remove('dob-popup');
        this.changeDOBPopup.close();
    };
    FBOProfileComponent.prototype.closeGovtIDPopUp = function () {
        var control = this.updateGovIDForm.controls['govermentIdentification'];
        for (var i = control.length - 1; i >= 0; i--) {
            control.removeAt(i);
        }
        this.updateGovIDForm.markAsPristine();
        this.updateGovIDForm.markAsUntouched();
        this.isCancelButtonClicked = false;
        this.isUpdateButtonClicked = false;
        this.deleteHomeCountryVat = false;
        this.changeGovtIDPopup.close();
        this.governmentIdValueEditIndexes = [];
        this.duplicateGovIdErrorMessage = null;
        this.duplicateCheck = false;
    };
    FBOProfileComponent.prototype.closePopUpforBusinessEntity = function () {
        this.businessEntityForm.controls['startDate'].setValue(this.fboBusinessEntity.startDate);
        this.businessEntityForm.controls['endDate'].setValue(this.fboBusinessEntity.endDate);
        this.changeBusinessEntityPopup.close();
    };
    //  Filters States based on Country Selected in Business Entity.
    FBOProfileComponent.prototype.onChangeOfBusinessEntityCountry = function () {
        if (this.businessEntityForm.controls['countryCodeId'].value && this.statesModal) {
            this.statesModal = [];
            var countryId_1 = this.businessEntityForm.controls['countryCodeId'].value;
            this.statesModal = this.states.filter(function (item) { return item.countryId === +countryId_1; });
            this.businessEntityForm.controls['stateCodeId'].setValue('');
        }
        else {
            this.statesModal = [];
            this.businessEntityForm.controls['stateCodeId'].setValue('');
        }
    };
    FBOProfileComponent.prototype.NavigatetoPaymentMethod = function () {
        this.paymentMethodTab.emit(4);
    };
    FBOProfileComponent.prototype.customerReportMethod = function () {
        this.customerReportTab.emit(6);
    };
    FBOProfileComponent.prototype.getParticipatingCountriesByCountryCode = function (countryCode) {
        var _this = this;
        this._customerservice.getParticipatingCountriesByCountryCode(countryCode).subscribe(function (response) {
            if (response.success) {
                var countryIds_1 = response.countriesUnderOperatingCountry.filter(function (x) { return x.countryId; }).map(function (a) { return a.countryId; });
                if (countryIds_1 && countryIds_1.length > 0) {
                    _this.countriesList = _this.countriesList.filter(function (x) { return countryIds_1.some(function (y) { return y === x.countryId; }); });
                }
            }
        });
    };
    /** * HITS SERVICES   ----- BEGIN ----- ************************* */
    /**
     * Get Member information from titan
     */
    FBOProfileComponent.prototype.getFBOProfileInfoFromTitan = function (displayNotification, updateBWP) {
        var _this = this;
        this._customerservice.getMemberInformationFromTitan(this._id).subscribe(function (response) {
            if (response && response.isSuccess) {
                _this.isMemberRecordExistInTitan = true;
                _this.prevBondedWarehouseProjectSelected = false;
                // this._cacheService.setSessionValue(CacheKey.UserDetails,response);
                var bwpMetaData = response.memberMetaData.find(function (element) { return (element.customKey === MemberMetaDataEnum.BWPENABLED) && (element.customValue === "1"); });
                if (bwpMetaData) {
                    _this.prevBondedWarehouseProjectSelected = true;
                }
                if (!_this.changeOperatingCountry) {
                    _this.getParticipatingCountriesByCountryCode(response.homeCountryCode);
                }
                _this.getWholsesaleQualifiedDetails(_this.fboid, response.homeCountryCode);
                _this.isTitanEnabled = true;
                _this.isBetaEnabled = _this.isBetaEnabledCountry(response.homeCountryCode);
                _this.fboProfileDetail = response;
                //this.memberGovernmentIdentifiations = response.memberGovernmentIdentifications;
                if (response && response.memberId) {
                    _this.getMembergovernmentIdentificationsInfo(response.memberId);
                    _this.fboProfileDetail.businessEntities = _this.getMemberBusinessEntityInfo(response.memberId, response.homeCountryCode, response.preferenceValue);
                }
                if (response.memberAllowedCountries && response.memberAllowedCountries.length > 0) {
                    _this.memberAllowedCountries = response.memberAllowedCountries;
                }
                _this.fboProfileDetail.optinDate = _this.getFormattedOptinDate(response.optinDate);
                _this.fboProfileDetail.id = response.memberId;
                _this.homeCountryInfo.emit(response.homeCountryCode);
                _this.operatingCountryInfo.emit(response.operatingCountryCode);
                _this.distributorInfoObj.memberId = response.memberId;
                _this.distributorInfoObj.memberTypeId = response.memberTypeId;
                _this.distributorInfoObj.memberType = response.memberType;
                _this.distributorInfoObj.middleName = response.middleName;
                _this.distributorInfoObj.homeCountryCode = response.homeCountryCode;
                _this.distributorInfoObj.privacyRequested = _this._commonService.isPrivacyRequested(response.memberPreferences);
                _this.distributorInfo.emit(_this.distributorInfoObj);
                _this.fboProfileDetail.fboId = _this._id;
                _this.fboProfileDetail.spouseFullName = null;
                _this.homeCountry = response.homeCountryCode;
                _this.operatingCountry = response.operatingCountryCode;
                if (response && response.memberStatus) {
                    _this.memberStatus = { id: MemberStatus[response.memberStatus], name: response.memberStatus };
                }
                _this._configurationService.setEnrollCountry(_this.homeCountry);
                _this.personalInfoSettings = _this._personalInfoConfigService.getSettings(_this.homeCountry);
                _this.isCreditAssessmentEnabled = _this.personalInfoSettings && _this.personalInfoSettings.enableCreditAssessment ? false : true;
                _this.showSingleAndDirectDebitMenu = _this.personalInfoSettings.showBonusDebitInforMenu ? _this.personalInfoSettings.showBonusDebitInforMenu : false;
                _this.appConfig = _this._appConfigService.getSettings(response.homeCountryCode, null); //storeConfiguration
                _this.checkoutConfig = _this._checkoutConfigService.getSettings(_this.homeCountry, null);
                // this.getMemberBonusInfo();
                _this.isDisplaySearchAddressSection = _this.checkoutConfig ? _this.checkoutConfig.displaySearchAddressSection : false;
                if (_this.fboProfileDetail.businessEntities && _this.fboProfileDetail.businessEntities.length) {
                    _this.fboBusinessEntity = _this.fboProfileDetail.businessEntities.find(function (entity) { return entity.status !== RowStatus.Delete; });
                    if (_this.fboBusinessEntity && _this.fboBusinessEntity.startDate) {
                        _this.fboBusinessEntity.startDate =
                            moment(_this.fboBusinessEntity.startDate, 'DD-MM-YYYY').format('DD-MMM-YYYY');
                    }
                    var country = _this.countries.find(function (country) { return +country.countryId === +_this.fboBusinessEntity.countryCodeId; });
                    _this.businessEntityCountry = country.name;
                    var state = _this.statesModal.find(function (state) { return +state.id === +_this.fboBusinessEntity.stateCodeId; });
                    _this.businessEntityState = state && state.stateName ? state.stateName : '';
                }
                if (+_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.DISTRIBUTOR && _this.appConfig.disableBusinessEntityForFbo) {
                    _this.disableBusinessEntityForFbo = true;
                }
                else {
                    _this.disableBusinessEntityForFbo = false;
                }
                if (+_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.DISTRIBUTOR) {
                    _this.isDistributor = true;
                    _this.enableGovernmentID = true;
                }
                if (_this.allowFullNamePermission) {
                    if ((+_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.RETAIL) ||
                        (+_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.GUEST)) {
                        _this.allowFullNamePermission = false;
                    }
                    if ((+_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.DISTRIBUTOR) ||
                        (+_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.FPC)) {
                        _this.allowFullNamePermission = true;
                        if (_this.appConfig.showBonusInfoForFPC) {
                            _this.isDistributor = true;
                        }
                    }
                }
                if ((+_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.DISTRIBUTOR) ||
                    (+_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.FPC)) {
                    _this.enableChangeStatus = true;
                    _this.enableMemberCCOverride = true;
                    if (_this.appConfig.showBonusInfoForFPC) {
                        _this.isDistributor = true;
                    }
                }
                if (+_this.fboProfileDetail.memberTypeId != _this.memberTypeEnum.GUEST) {
                    _this.enableChangeHomeCountry = true;
                }
                if ((+_this.fboProfileDetail.memberTypeId != _this.memberTypeEnum.DISTRIBUTOR) &&
                    (+_this.fboProfileDetail.memberTypeId != _this.memberTypeEnum.FPC)) {
                    _this.enableMemberTypeOrLevel = false;
                }
                _this.enableChangeDOB = (_this.fboProfileDetail.memberTypeId === _this.memberTypeEnum.GUEST ||
                    _this.fboProfileDetail.memberTypeId === _this.memberTypeEnum.RETAIL) ? false : true;
                if (!_this.fboProfileDetail.firstActiveUplineManager) {
                    _this.fboProfileDetail.firstActiveUplineManager = new SponsorInformation();
                }
                _this.fboProfileDetail.sponsorDetails = new SponsorInformation();
                var sponsorResults = void 0;
                sponsorResults = response.memberSponsorResults;
                if (sponsorResults !== undefined) {
                    _this.fboProfileDetail.sponsorDetails.fboId = sponsorResults.sponsorFBOID ? sponsorResults.sponsorFBOID : '';
                    _this.fboProfileDetail.sponsorDetails.firstName = sponsorResults.sponsorName ? sponsorResults.sponsorName : '';
                    _this.fboProfileDetail.sponsorDetails.lastName = '';
                    _this.fboProfileDetail.sponsorDetails.emailId = sponsorResults.email ? sponsorResults.email : '';
                    _this.fboProfileDetail.sponsorDetails.mobile = sponsorResults.contactPhone ? sponsorResults.contactPhone : '';
                    _this.fboProfileDetail.sponsorDetails.memberLevelID = sponsorResults.memberLevelID ? sponsorResults.memberLevelID : '';
                }
                _this.fboProfileDetail.wholesaleQualified = response.wholeSaleQualified;
                _this.fboProfileDetail.emailId = response.email;
                var mobileTypeInformation = [];
                mobileTypeInformation = response.memberContacts; // contactTypeID, value
                if (mobileTypeInformation && mobileTypeInformation.length > 0) {
                    var mobileNumber = mobileTypeInformation.find(function (item) { return item.contactTypeID === ContactTypeValue.MOBILE; });
                    if (mobileNumber != undefined) {
                        _this.fboProfileDetail.mobile = mobileNumber.value;
                    }
                    var phone = mobileTypeInformation.find(function (item) { return item.contactTypeID === ContactTypeValue.PHONE; });
                    if (phone !== undefined) {
                        _this.fboProfileDetail.homePhoneNumber = phone.value;
                    }
                }
                var memberPreferenceInformation = [];
                memberPreferenceInformation = response.memberPreferences;
                if (memberPreferenceInformation && memberPreferenceInformation.length) {
                    var byMail = memberPreferenceInformation.
                        find(function (item) { return (item.preferenceId === MemberPreferenceType.Email) && +item.preferenceValue === PreferenceValues.no; });
                    _this.fboProfileDetail.memberPreference = byMail ? 'Yes' : 'No';
                    var subscription = memberPreferenceInformation.
                        find(function (item) { return item.preferenceId === MemberPreferenceType.AmazonSubscription && +item.preferenceValue === PreferenceValues.yes; });
                    _this.fboProfileDetail.amazonSubscription = subscription ? CommonConstant.YES : CommonConstant.NO;
                }
                if (response.profileImageURL === null || response.profileImageURL === '' || response.profileImageURL === undefined) {
                    _this.profileImage = _this.getStaticImageUrl();
                }
                else {
                    _this.downloadImageFromUrl(response.profileImageURL);
                }
                _this.getMemberLevelInfo(false, response, displayNotification);
                _this.getChangeSponsorPermission();
                if (response.memberTypeId === _this.memberTypeEnum.DISTRIBUTOR && response.memberTitleId !== MemberTitleExtEnums.Novus_Customer) {
                    _this.isMemberTypeDistributor = true;
                }
                if (_this.operatingCountry && _this.AmazonSubscriptionEnabledOperatingCountries && _this.AmazonSubscriptionEnabledOperatingCountries.length > 0 && _this.AmazonSubscriptionEnabledOperatingCountries.includes(_this.operatingCountry.toUpperCase())) {
                    _this.enableAmazonSubscriptionFlag = true;
                }
                //this.isRetailSubscriptionLogin = TODO set flag here based on member retail subscription
                if (_this.fboProfileDetail && (+_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.FPC)) {
                    _this.isPrefferedCustomer = true;
                }
                _this.checkMemberHomeCountryTitanEnabledcountry(_this.homeCountry);
                if (_this.enableFLP360ImpersonationForFPC && (_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.DISTRIBUTOR || _this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.FPC) && !_this.isUserCreatedInKeycloak) {
                    _this.createUserDetailsInFlp360Realm();
                }
            }
            else {
                _this.getProfileInfo();
            }
        }, function (error) {
            _this.getProfileInfo();
        });
        this.distributorInfo.emit(this.distributorInfoObj);
    };
    FBOProfileComponent.prototype.isStateCountriesDisable = function (countryCode) {
        var stateCountry = environment.disableStateCountries.split(',');
        if (stateCountry && stateCountry.length) {
            return stateCountry.some(function (code) { return code === countryCode; });
        }
    };
    FBOProfileComponent.prototype.getMemberLanguageInformationFromTitan = function (country) {
        var _this = this;
        this._customerservice.getMemberLanguageInformationFromTitan(country).subscribe(function (response) {
            if (response.success) {
                var langauge = response.languages.find(function (language) { return language.languageId === +_this.languageId; });
                _this.fboProfileDetail.preferredLanguage = (langauge && langauge.languageCode) ? langauge.languageCode.toUpperCase() : 'EN';
                _this.languagecode = langauge && langauge.cultureName ? langauge.cultureName : 'en-us';
            }
        });
    };
    /**
     * @description create the formatted date of birth
     * @date 2019-10-10
     * @param {string} dateString
     * @returns {Date}
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.getFormattedDOB = function (dateString) {
        var birthDate = null;
        if (dateString) {
            var dob = new Date(dateString);
            birthDate = new Date(dob.getTime() + dob.getTimezoneOffset() * 60000);
        }
        return birthDate;
    };
    /**
     * @description create the formatted date of birth
     * @date 2019-10-10
     * @param {string} dateString
     * @returns {Date}
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.getFormattedOptinDate = function (dateString) {
        var optinDate = null;
        if (dateString) {
            var optin = new Date(dateString);
            optinDate = new Date(optin.getTime() + optin.getTimezoneOffset() * 60000);
        }
        return optinDate;
    };
    /**
     * Gets fbo / retail profile detail from AS400
     */
    FBOProfileComponent.prototype.getProfileInfo = function () {
        var _this = this;
        this.isFpcUser();
        var memberLevel;
        if (this.memberType === MemberType.GUEST || this.memberType === 'G') {
            memberLevel = 'G';
        }
        else if (this.memberType === MemberType.RETAIL || this.orderType === MemberOrderType.RETAIL || this.memberType === 'R') {
            memberLevel = 'R';
        }
        if (this.memberType === MemberType.GUEST || this.memberType === MemberType.RETAIL
            || this.memberType === 'G' || this.memberType === 'R') {
            this.memberType = 'R';
        }
        else if (this.memberType === MemberType.FPC) {
            this.memberType = MemberType.FPC;
        }
        else {
            this.memberType = MemberType.FOB;
            this.isDistributor = true;
        }
        this.isTitanEnabled = false;
        this.enableHomeCountry = false;
        this._customerservice.getFBOProfileInformation(this._id, this.memberType).subscribe(function (response) {
            if (response.success) {
                _this.fboProfileDetail = response;
                _this.fboProfileDetail.optinDate = _this.getFormattedOptinDate(response.optinDate);
                _this.homeCountryInfo.emit(_this.fboProfileDetail.operatingCountry);
                _this.fboProfileDetail.birthDate = _this.getFormattedDOB(response.birthDate);
                _this.fboProfileDetail.spouseFullName = response.spouse ? response.spouse : '';
                _this.externalMemberStatus = response.status ? response.status.toLowerCase() : null;
                _this.fboProfileDetail.fboId = _this._id;
                if (_this.fboProfileDetail.profileImageURL === null || _this.fboProfileDetail.profileImageURL === '' || _this.fboProfileDetail.profileImageURL === undefined) {
                    // this.fboProfileDetail.profileImageURL = this.getStaticImageUrl();
                    _this.profileImage = _this.getStaticImageUrl();
                }
                else {
                    _this.downloadImageFromUrl(_this.fboProfileDetail.profileImageURL);
                }
                if (!_this.fboProfileDetail.accountLevelId) {
                    _this.fboProfileDetail.accountLevelId = null;
                }
                if (memberLevel === 'G') {
                    _this.isGuestMemberType = true;
                    _this.fboProfileDetail.memberLevel = MemberType.GUEST;
                }
                if (memberLevel === 'R') {
                    _this.fboProfileDetail.memberLevel = MemberType.RETAIL;
                }
                if (_this.fboProfileDetail.memberLevel === MemberType.GUEST || _this.fboProfileDetail.memberLevel === MemberType.RETAIL
                    || _this.fboProfileDetail.memberLevel === MemberOrderType.RETAIL || _this.fboProfileDetail.memberLevel === MemberType.RETAILCUSTOMER) {
                    _this.showCCSnapshotSection = false;
                    _this.enableChangeDOB = false;
                }
                else {
                    _this.enableChangeDOB = true;
                    _this.showCCSnapshotSection = true;
                    _this.getSnapshotInfo();
                }
                if (!_this.fboProfileDetail.address) {
                    _this.fboProfileDetail.address = new AddressInformation();
                }
                else {
                    _this.homeCountry = _this.fboProfileDetail.address.country;
                    _this.fboProfileCountry = _this.fboProfileDetail.address.country;
                    _this.getFormValidationsJSON();
                    _this.fboInfo.push({ fboId: _this._id, homeCountryCode: _this.homeCountry });
                    if (_this.fboProfileDetail.address.country !== null) {
                        _this.phoneNumberFormat = _this._commonService.getPhoneNumberFormatByCountryCode(_this.fboProfileDetail.address.country);
                    }
                    _this._dataServcie.setCustomerFBOInfoServiceMessage(_this.fboInfo);
                    _this.addressFirstLine = (_this.fboProfileDetail.address.addressFirstLine && _this.fboProfileDetail.address.addressFirstLine !== '') ?
                        _this.fboProfileDetail.address.addressFirstLine.trim() : '';
                    if (_this.fboProfileDetail.address.addressSecondLine && _this.fboProfileDetail.address.addressSecondLine !== '') {
                        _this.addressFirstLine += ', ' + _this.fboProfileDetail.address.addressSecondLine.trim();
                    }
                    if (_this.fboProfileDetail.address.addressThirdLine && _this.fboProfileDetail.address.addressThirdLine !== '') {
                        _this.addressFirstLine += ', ' + _this.fboProfileDetail.address.addressThirdLine;
                    }
                    _this.fboProfileDetail.address.addressFirstLine = _this.addressFirstLine;
                    _this.addressSecondLine = (_this.fboProfileDetail.address.city && _this.fboProfileDetail.address.city !== '') ? _this.fboProfileDetail.address.city.trim() : '';
                    if (_this.fboProfileDetail.address.state && !_this.isStateCountriesDisable(_this.homeCountry)) {
                        _this.addressSecondLine += ', ' + _this.fboProfileDetail.address.state;
                    }
                }
                if (!_this.fboProfileDetail.autoShipItems) {
                    _this.fboProfileDetail.autoShipItems = new Array();
                }
                if (!_this.fboProfileDetail.sponsorDetails) {
                    _this.fboProfileDetail.sponsorDetails = new SponsorInformation();
                }
                if (!_this.fboProfileDetail.firstActiveUplineManager) {
                    _this.fboProfileDetail.firstActiveUplineManager = new SponsorInformation();
                }
                if (response.enrollmentDate !== null) {
                    _this.isEnrollmentDateExists = true;
                    _this.fboProfileDetail.enrollmentDate = _this.getFormattedEnrollmentDate(response.enrollmentDate);
                }
                _this.isfirstPurchaseDateEmpty = response.firstPurchaseDate === null || response.firstPurchaseDate === '0-0-' ? true : false;
                _this.fboProfileDetail.firstPurchaseDate = new Date(response.firstPurchaseDate);
                _this.distributorInfoObj.memberId = _this.fboProfileDetail.id;
                _this.distributorInfoObj.name = _this.fboProfileDetail.firstName + ' ' + (_this.fboProfileDetail.lastName ? _this.fboProfileDetail.lastName : '');
                _this.distributorInfoObj.contactNumber = response.mobile ? response.mobile : '';
                _this.distributorInfoObj.email = _this.fboProfileDetail.emailId ? _this.fboProfileDetail.emailId : '';
                _this.distributorInfoObj.distributorId = _this.fboProfileDetail.fboId;
                _this.distributorInfoObj.firstName = _this.fboProfileDetail.firstName;
                _this.distributorInfoObj.lastName = _this.fboProfileDetail.lastName;
                _this.distributorInfoObj.displayName = _this.fboProfileDetail.displayName;
                _this.distributorInfoObj.privacyRequested = _this._commonService.isPrivacyRequested(response.memberPreferences);
                _this.getMemberLevelInfo(true);
                _this.fboProfileDetail.operatingCountry = response.operatingCountry;
                if (!_this.changeOperatingCountry) {
                    _this.getParticipatingCountriesByCountryCode(response.operatingCountry);
                }
                if (_this.enableFLP360ImpersonationForFPC && (_this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.DISTRIBUTOR || _this.fboProfileDetail.memberTypeId == _this.memberTypeEnum.FPC) && !_this.isUserCreatedInKeycloak) {
                    _this.createUserDetailsInFlp360Realm();
                }
            }
            else {
                if (response.validations && response.validations.length > 0) {
                    _this.displayErrorMessage(_this._id);
                }
            }
        }, function (error) {
            if (error.validations && error.validations.length > 0) {
                _this.displayErrorMessage(_this._id);
            }
        });
        this.distributorInfo.emit(this.distributorInfoObj);
    };
    FBOProfileComponent.prototype.getMemberLevelInfo = function (isAS400, titanResponse, displayNotification) {
        this.isDisplayMemberTitle = true;
        if (this.fboProfileDetail.memberTitle != null && this.fboProfileDetail.memberTitle != undefined) {
            this.fboProfileDetail.memberLevel = this.fboProfileDetail.memberTitle;
        }
        else {
            isAS400 = true;
        }
        if (isAS400) {
            this.getAS400UserRelatedInfo();
        }
        else {
            this.getTitanUserRelatedInfo(titanResponse, displayNotification);
        }
        // this._commonService.getMemberLevelDetails(this.fboProfileDetail.fboId).subscribe((response) => {
        //     if (response) {
        //         this.fboProfileDetail.memberLevel = response.memberLevel;
        //         this.isDisplayMemberTitle = true;
        //         if (isAS400) {
        //             this.getAS400UserRelatedInfo();
        //         } else {
        //             if (!response.memberLevel) {
        //                 this.fboProfileDetail.memberLevel = response.memberType;
        //             }
        //             this.getTitanUserRelatedInfo(titanResponse, displayNotification);
        //         }
        //     }
        // }, (error) => {
        //     this.isDisplayMemberTitle = true;
        //     if (isAS400) {
        //         this.getAS400UserRelatedInfo();
        //     } else {
        //         this.getTitanUserRelatedInfo(titanResponse, displayNotification);
        //     }
        // });
    };
    FBOProfileComponent.prototype.getTitanUserRelatedInfo = function (response, displayNotification) {
        var _this = this;
        if (this.fboProfileDetail.memberLevel === MemberType.GUEST || this.fboProfileDetail.memberLevel === MemberType.RETAIL
            || this.fboProfileDetail.memberLevel === MemberOrderType.RETAIL ||
            this.fboProfileDetail.memberLevel === MemberType.RETAILCUSTOMER) {
            this.showCCSnapshotSection = false;
        }
        else {
            this.showCCSnapshotSection = true;
            this.getSnapshotInfo();
        }
        if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.GUEST) {
            this.fboProfileDetail.memberLevel = MemberType.GUEST;
        }
        if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC || this.fboProfileDetail.memberTitleId === MemberLevel.PREFERREDCUSTOMER || (this.fboProfileDetail.memberTypeId === MemberLevel.ASSISTANTMANAGER && this.fboProfileDetail.memberTitleId === MemberLevel.NOVICCUSTOMER)) {
            this.fboProfileDetail.memberLevel = MemberType.PREFERREDCUSTOMER;
        }
        if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC || this.fboProfileDetail.accountLevelId === MemberLevel.PREFERREDCUSTOMER || (this.fboProfileDetail.memberTypeId === MemberLevel.ASSISTANTMANAGER && this.fboProfileDetail.accountLevelId === MemberLevel.NOVICCUSTOMER)) {
            this.fboProfileDetail.accountLevelTitle = MemberType.PREFERREDCUSTOMER;
        }
        this.fboProfileDetail.memberType = response.memberType;
        this.languageId = response.preferenceValue;
        if (response.memberGovernmentIdentifications.length > 0 && response.homeCountryCode !== null) {
            this.governmentIdentification = response.memberGovernmentIdentifications.find(function (x) { return x.governmentIdentificationType === 'SSN'; });
            if (this.governmentIdentification) {
                this.fboProfileDetail.governmentIdentificationType = this.governmentIdentification.governmentIdentificationType;
                this.fboProfileDetail.governmentIDType = this.governmentIdentification.governmentIDType;
                this.fboProfileDetail.governmentId = this.governmentIdentification.value;
                var regexp = /^\d{3}-\d{2}-\d{4}$/;
                var regexpr = /^\d{2}-\d{7}$/;
                if (this.governmentIdentification.value != null && regexp.test(this.governmentIdentification.value)) {
                    this.fboProfileDetail.governmentId = this.governmentIdentification.value !== null ?
                        ('XXX-XX-' + this.governmentIdentification.value.substr(-4)) : null;
                }
                else if (this.governmentIdentification.value != null && regexpr.test(this.governmentIdentification.value)) {
                    this.fboProfileDetail.governmentId = this.governmentIdentification.value !== null ?
                        ('XX-XXX' + this.governmentIdentification.value.substr(-4)) : null;
                }
                else if (this.governmentIdentification.value != null) {
                    this.fboProfileDetail.governmentId = this.governmentIdentification.value !== null ?
                        ('XXX-XX-' + this.governmentIdentification.value.substr(-4)) : null;
                }
            }
        }
        if (response.createdDate !== null) {
            this.isEnrollmentDateExists = true;
            this.fboProfileDetail.enrollmentDate = this.getFormattedEnrollmentDate(response.createdDate);
        }
        if (response.homeCountryCode !== null) {
            this.homeCountry = response.homeCountryCode;
            this.getFormValidationsJSON();
            this.fboProfileDetail.operatingCountry = response.homeCountryCode;
            this.getMemberLanguageInformationFromTitan(this.fboProfileDetail.operatingCountry);
            this.fboInfo.push({ fboId: this._id, homeCountryCode: this.homeCountry });
            this._dataServcie.setCustomerFBOInfoServiceMessage(this.fboInfo);
            this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(response.homeCountryCode);
        }
        // if (response.memberMetaData.length > 0) {
        //     let memberMetaData: any;
        //     let customKeyValue: any;
        //     memberMetaData = response.memberMetaData.find((metaData: any) => metaData.customKey === this.metaDataKey);
        //     if (memberMetaData != undefined) {
        //         customKeyValue = memberMetaData.customValue.split(":");
        //         this.fboProfileDetail.spouseFullName = customKeyValue.length === 2 ?
        //             customKeyValue[1].replace(/[^a-zA-Z ]/g, "") : "NA";
        //     }
        // }
        if (response.memberRankLevels.length > 0) {
            this.memberRankLevels = response.memberRankLevels;
        }
        if (response.memberAllowedCountries.length > 0) {
            var operatingCountries = response.memberAllowedCountries.filter(function (country) { return country.homeCountry === true; });
            if (operatingCountries !== undefined && operatingCountries !== null && operatingCountries.length > 0) {
                var isTitanMember_1 = false;
                operatingCountries.forEach(function (operatingCountry) {
                    var operatingCountryResult = _this.countriesList.filter(function (country) {
                        return country.isocodeThree == operatingCountry.isoCodeThree && country.titanPlatformEnabled === true;
                    });
                    if (operatingCountryResult && operatingCountryResult.length > 0) {
                        isTitanMember_1 = true;
                    }
                });
                this.isTitanEnabled = isTitanMember_1;
            }
            var authorizedCountries = response.memberAllowedCountries.filter(function (country) { return country.authorized === true; });
            if (authorizedCountries !== undefined && authorizedCountries !== null && authorizedCountries.length > 0) {
                this.fboProfileDetail.storeEligibility = this.getCountryNames(authorizedCountries, 'countryName');
            }
        }
        else {
            this.fboProfileDetail.storeEligibility = '';
        }
        if (this.fboProfileDetail && this.fboProfileDetail.storeEligibility) {
            this.showPayByAccountCheck = this.fboProfileDetail.storeEligibility.includes('United States');
        }
        this.isfirstPurchaseDateEmpty = true;
        // this.fboProfileDetail.firstPurchaseDate = new Date(response.firstPurchaseDate);
        this.distributorInfoObj.memberId = this.fboProfileDetail.id;
        this.distributorInfoObj.name = this.fboProfileDetail.firstName + ' ' +
            (this.fboProfileDetail.lastName ? this.fboProfileDetail.lastName : '');
        this.distributorInfoObj.firstName = this.fboProfileDetail.firstName;
        this.distributorInfoObj.lastName = this.fboProfileDetail.lastName;
        this.distributorInfoObj.displayName = this.fboProfileDetail.displayName;
        this.distributorInfoObj.contactNumber = response.phone ? response.phone : '';
        this.distributorInfoObj.email = this.fboProfileDetail.emailId ? this.fboProfileDetail.emailId : '';
        this.distributorInfoObj.distributorId = this.fboProfileDetail.fboId;
        this.distributorInfoObj.level = this.fboProfileDetail.memberLevel;
        this.distributorInfoObj.privacyRequested = this._commonService.isPrivacyRequested(response.memberPreferences);
        if (+this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC) {
            this.distributorInfoObj.memberType = MemberType.FPC;
        }
        else {
            this.distributorInfoObj.memberType = this.fboProfileDetail.memberType;
        }
        if (this.fboProfileDetail.memberLevel === MemberType.RETAIL) {
            this.enableHomeCountry = false;
        }
        if (this.fboProfileDetail.memberType === MemberType.GUEST) {
            this.isGuestMemberType = true;
        }
        this.distributorInfo.emit(this.distributorInfoObj);
        var autoShipItems = new Array();
        this.fboProfileDetail.autoShipItems = autoShipItems;
        this.saveRecentlyViewedAccount();
        if (!this.fboProfileDetail.storeEligibility || this.fboProfileDetail.storeEligibility.length === 0) {
            this.getFBOStoreEligibleInfo();
        }
        this.fboProfileDetail.address = new AddressInformation();
        this.countryId = response.homeCountryId ? response.homeCountryId : null;
        this.homeCountryId = response.homeCountryId ? response.homeCountryId : null;
        if (this.countryId && this.countries && this.countries.length && this.fboProfileDetail &&
            this.fboProfileDetail.address) {
            var countryInfo = this.countries.find(function (country) { return country.countryId === _this.countryId; });
            this.fboProfileDetail.address.country = countryInfo && countryInfo.name ? countryInfo.name : '';
            this.fboProfileCountry = this.fboProfileDetail.address.country;
        }
        this.getAccountLockInfo();
        this.getDistributorWithPaymentDetails(displayNotification);
    };
    FBOProfileComponent.prototype.getAS400UserRelatedInfo = function () {
        this.distributorInfoObj.level = this.fboProfileDetail.memberLevel;
        if (this.fboProfileDetail.memberLevel === StatusConstants.Novus
            || this.fboProfileDetail.memberLevelId === MemberLevel.PREFERREDCUSTOMER) {
            this.distributorInfoObj.memberType = MemberType.FPC;
            this.fboProfileDetail.memberLevel = MemberType.PREFERREDCUSTOMER;
        }
        else {
            this.distributorInfoObj.memberType = this.memberType;
        }
        this.distributorInfoObj.level = this.fboProfileDetail.memberLevel;
        var language = this.fboProfileDetail.preferredLanguage.replace(/[ ]/gi, '');
        this.fboProfileDetail.preferredLanguage = language;
        this.fboProfileDetail.preferredLanguage = this.fboProfileDetail.preferredLanguage
            && this.fboProfileDetail.preferredLanguage.length > 0 ? this.fboProfileDetail.preferredLanguage : null;
        this.distributorInfo.emit(this.distributorInfoObj);
        this.saveRecentlyViewedAccount();
        this.getFBOStoreEligibleInfo();
    };
    FBOProfileComponent.prototype.getFBOStoreEligibleInfo = function () {
        var _this = this;
        this._customerservice.getFBOStoreEligibleInfo(this._id).subscribe(function (response) {
            if (response) {
                var storeList = response.fboAuthorizedCountryList;
                if (_this.homeCountry) {
                    var homeCountryInfo = storeList.find(function (country) { return country.iSOCode === _this.homeCountry; });
                    if (homeCountryInfo) {
                        storeList.splice(storeList.indexOf(homeCountryInfo), 1);
                        storeList.splice(0, 0, homeCountryInfo);
                    }
                }
                if (storeList.length > 0) {
                    _this.authorizedCountries = storeList.filter(function (country) { return country.isAuthorizedToShop === true || country.isAuthorizedSponsor === true; });
                    if (_this.authorizedCountries !== null && _this.authorizedCountries.length > 0 && _this.authorizedCountries !== undefined) {
                        _this.fboProfileDetail.storeEligibility = _this.getCountryNames(_this.authorizedCountries, 'countryName');
                    }
                    else {
                        _this.fboProfileDetail.storeEligibility = '';
                    }
                }
                else {
                    _this.fboProfileDetail.storeEligibility = '';
                }
            }
        });
    };
    /**
     * @description to get countrynames
     * @date 2019-09-17
     * @param {any[]} countries
     * @param {string} key
     * @returns {*}
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.getCountryNames = function (countries, key) {
        var countryNames = '';
        if (countries && countries.length) {
            countryNames = orderBy(countries, key).map(function (country) {
                return country[key];
            }).join(', ');
        }
        return countryNames;
    };
    FBOProfileComponent.prototype.getSnapshotInfo = function () {
        var _this = this;
        this.isLoading = true;
        var date = new Date();
        var curMonth = date.getMonth() + 1;
        var lastYear = curMonth === 1 ? date.getFullYear() - 1 : date.getFullYear();
        var lastMonth = curMonth === 1 ? 12 : curMonth - 1;
        var snapObj = {
            distributorID: this._id,
            country: this.operatingCountry ? this.operatingCountry.toUpperCase() : '',
            currentYear: date.getFullYear(),
            month: curMonth
        };
        this._commonService.getCCSnapDetails(snapObj)
            .subscribe(function (res) {
            var currentMonthData = res && !!res.length ? res.find(function (x) { return (x.processingYear == date.getFullYear() && x.valueType.toLowerCase() == CommonConstant.Monthly && (x.processingMonth == +curMonth)); }) : {};
            var previousMonthData = res && !!res.length ? res.find(function (x) { return ((x.processingYear == lastYear && x.valueType.toLowerCase() == CommonConstant.Monthly && x.processingMonth == +lastMonth)); }) : {};
            var currentYear = res && !!res.length ? res.find(function (x) { return (x.processingYear == date.getFullYear() && x.valueType.toLowerCase() == CommonConstant.Yearly && (+x.processingMonth == _this.valueZero)); }) : {};
            _this.ccSnapshot.list = _this.iterateCCsnapShotValues(currentMonthData, previousMonthData, curMonth, lastMonth);
            _this.ccSnapshot.globalCC = currentYear && currentYear.globalTotalCC ? currentYear.globalTotalCC : 0;
            _this.ccSnapshot.totMgrCount = currentYear && currentYear.recognizedManagerCount ? currentYear.recognizedManagerCount : 0;
            _this.ccSnapshot.currentMonthTotal = currentMonthData && currentMonthData.totalCC ? currentMonthData.totalCC : 0;
            _this.ccSnapshot.recognizedManagers = "";
        }, function (err) {
            _this.ccSnapshot.list = [];
            _this.ccSnapshot.globalCC = 0;
            _this.ccSnapshot.totMgrCount = 0;
            _this.ccSnapshot.currentMonthTotal = 0;
            _this.isLoading = false;
        }, function () {
            _this.isLoading = false;
        });
    };
    FBOProfileComponent.prototype.iterateCCsnapShotValues = function (currentMonth, previousMonth, curMonth, lastMonth) {
        currentMonth = currentMonth ? currentMonth : {};
        previousMonth = previousMonth ? previousMonth : {};
        var snapData = [];
        snapData.push({ ccKey: '', currentMonthValue: this.monthAndYear.find(function (x) { return x.value == curMonth; }).monthName, previousMonthValue: this.monthAndYear.find(function (x) { return x.value == lastMonth; }).monthName }, { ccKey: this._translatePipe.get('customer-service.Personal').value, currentMonthValue: currentMonth.personalCC ? currentMonth.personalCC : 0, previousMonthValue: previousMonth.personalCC ? previousMonth.personalCC : 0 }, { ccKey: this._translatePipe.get('customer-service.New FBO').value, currentMonthValue: currentMonth.preferredCustomerCC ? currentMonth.preferredCustomerCC : 0, previousMonthValue: previousMonth.preferredCustomerCC ? previousMonth.preferredCustomerCC : 0 }, { ccKey: this._translatePipe.get('customer-service.Total Active').value, currentMonthValue: currentMonth.activeCC ? currentMonth.activeCC : 0, previousMonthValue: previousMonth.activeCC ? previousMonth.activeCC : 0 }, { ccKey: this._translatePipe.get('customer-service.Non Manager').value, currentMonthValue: currentMonth.nonManagerCC ? currentMonth.nonManagerCC : 0, previousMonthValue: previousMonth.nonManagerCC ? previousMonth.nonManagerCC : 0 }, { ccKey: this._translatePipe.get('customer-service.Leadership').value, currentMonthValue: currentMonth.leadershipCC ? currentMonth.leadershipCC : 0, previousMonthValue: previousMonth.leadershipCC ? previousMonth.leadershipCC : 0 }, { ccKey: this._translatePipe.get('customer-service.Monthly Total').value, currentMonthValue: currentMonth.totalCC ? currentMonth.totalCC : 0, previousMonthValue: previousMonth.totalCC ? previousMonth.totalCC : 0 }, {
            ccKey: this._translatePipe.get('customer-service.Level').value, currentMonthValue: currentMonth.endinglevel ? currentMonth.endinglevel : '-', previousMonthValue: previousMonth.endinglevel ? previousMonth.endinglevel : '-',
            currentMonthTitle: currentMonth.endinglevel ? this.getMemberLevel(+currentMonth.endinglevel) : '', previousMonthTitle: previousMonth.endinglevel ? this.getMemberLevel(+previousMonth.endinglevel) : ''
        }, { ccKey: this._translatePipe.get('customer-service.4CC Active').value, currentMonthValue: currentMonth.currentMonthActive, previousMonthValue: previousMonth.currentMonthActive });
        return snapData.slice();
    };
    /**
  * sorting of columns // not hits service...
  * @param sortColumn
  */
    FBOProfileComponent.prototype.sortColumnInformation = function (sortColumn, tableName) {
        var snapshotDetails = new Array();
        var autoshipDetails = new Array();
        if (tableName == 'CCSnapshot') {
            if (!this.isCCSnapshot) {
                this.isDesc = false;
                this.sortColumn = '';
            }
            this.isCCSnapshot = true;
            snapshotDetails = this.ccSnapshot.list;
            this.sortItems(snapshotDetails, sortColumn);
        }
        else {
            if (this.isCCSnapshot) {
                this.isDesc = false;
                this.sortColumn = '';
            }
            this.isCCSnapshot = false;
            autoshipDetails = this.fboProfileDetail.autoShipItems;
            this.sortItems(autoshipDetails, sortColumn);
        }
    };
    /**
        * sorting of columns  based on list type
        * @param sortColumn
    */
    FBOProfileComponent.prototype.sortItems = function (list, sortColumn) {
        var _this = this;
        this.isDesc = (this.sortColumn == sortColumn || sortColumn == '') ? !this.isDesc : this.isDesc;
        list.sort(function (a, b) {
            if (a[sortColumn] > b[sortColumn]) {
                return _this.isDesc ? -1 : 1;
            }
            if (a[sortColumn] < b[sortColumn]) {
                return _this.isDesc ? 1 : -1;
            }
        });
        this.sortColumn = sortColumn;
    };
    FBOProfileComponent.prototype.saveRecentlyViewedAccount = function () {
        var accountModel = new AccountModel();
        accountModel.id = 0;
        if (this.isTitanEnabled) {
            if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.DISTRIBUTOR || this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC) {
                accountModel.memberType = MemberType.FOB;
            }
            else if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.GUEST || this.fboProfileDetail.memberTypeId === this.memberTypeEnum.RETAIL) {
                accountModel.memberType = MemberType.RETAIL;
            }
        }
        else {
            accountModel.memberType = this.memberType === 'R' ? MemberType.RETAIL : MemberType.FOB;
        }
        accountModel.memberAccountId = this.fboProfileDetail.fboId;
        accountModel.memberAccountName = this.fboProfileDetail.displayName || (this.fboProfileDetail.firstName + (this.fboProfileDetail.lastName != null ? (' ' + this.fboProfileDetail.lastName) : ''));
        accountModel.customerAgentId = this.userId;
        accountModel.memberLevelId = this.fboProfileDetail.accountLevelId;
        this._customerservice.saveRecentlyViewedAccount(accountModel)
            .subscribe(function (response) {
        }, function (error) {
        });
    };
    /**
    To get the member level and display that in a popup
    **/
    FBOProfileComponent.prototype.viewMemberLevel = function () {
        var _this = this;
        this._customerService.getOperatingCountriesByCountryCode(this.fboProfileDetail.operatingCountry).subscribe(function (res) {
            _this.reviewModel.memberDetail = {
                'firstName': _this.fboProfileDetail.firstName,
                'lastName': _this.fboProfileDetail.lastName,
                'fboId': _this.fboProfileDetail.fboId,
                'memberLevel': _this.fboProfileDetail.memberLevel,
                'operatingCountry': res.operatingCountryCode
            };
            _this.showMemberLevel = false;
            _this._customerservice.getMemberLevelsInfo(res.operatingCountryCode, _this.fboid).subscribe(function (response) {
                if (response && response.fboMemberLevelHistoryResponse && response.fboMemberLevelHistoryResponse.length > 0) {
                    if (response.fboMemberLevelHistoryResponse && response.fboMemberLevelHistoryResponse.length > 0) {
                        _this.reviewModel.memberLeveldata = response.fboMemberLevelHistoryResponse;
                        //this.reviewModel.memberLeveldata = this.reviewModel.memberLeveldata.filter(item => item.levelId != 'null');
                        _this.reviewModel.dataAvailable = _this.reviewModel.memberLeveldata.length > 0 ? true : false;
                        _this.reviewModel.memberLeveldata.forEach(function (item) {
                            if (item.levelId === 'null') {
                                item.level = _this.fboProfileDetail.memberLevel;
                            }
                            else {
                                var level = _this.memberLevels.find(function (memberlevel) { return memberlevel.customId === (+item.levelId); });
                                if (level && level.id === MemberLevel.PREFERREDCUSTOMER) {
                                    item.level = MemberType.PREFERREDCUSTOMER;
                                }
                                else if (level && level.name) {
                                    item.level = level.name;
                                }
                            }
                        });
                    }
                    else {
                        _this.reviewModel.dataAvailable = false;
                    }
                    _this.showMemberLevel = true;
                    _this.reviewModel.toggle = true;
                }
                else {
                    var memberLeveldata_1 = [];
                    var memberLevel_1 = new MemberLevelInfo();
                    _this.reviewModel.dataAvailable = true;
                    if (_this.memberRankLevels.length > 0) {
                        _this.memberRankLevels.forEach(function (level) {
                            memberLevel_1.date = new Date(level.achievedOn).toString();
                            memberLevel_1.level = level.memberTitle.toUpperCase() === UserTitleType.PREFERREDCUSTOMER
                                ? MemberType.PREFERREDCUSTOMER : level.memberTitle;
                            memberLevel_1.levelId = level.memberTitleId.toString();
                            memberLeveldata_1.push(memberLevel_1);
                        });
                    }
                    _this.reviewModel.memberLeveldata = memberLeveldata_1;
                    _this.reviewModel.dataAvailable = _this.reviewModel.memberLeveldata.length > 0 ? true : false;
                    _this.showMemberLevel = true;
                    _this.reviewModel.toggle = true;
                }
            });
        });
    };
    FBOProfileComponent.prototype.openTab = function (tabName) {
        var tab = { tabName: tabName, fboId: this.fboid };
        this.messageService.setTabs(tab);
    };
    FBOProfileComponent.prototype.resetPassword = function () {
        this.SendPasswordResetLink();
    };
    FBOProfileComponent.prototype.SendPasswordResetLink = function () {
        var _this = this;
        this._customerservice.SendPasswordResetLink(this.fboProfileDetail.userName)
            .subscribe(function (response) {
            if (response) {
                if (response.isSuccess) {
                    var activityLogKeys = [{
                            key: MemberActivityLogType.PasswordReset_Emailed,
                            value: _this.fboProfileDetail.fboId
                        }];
                    _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                    _this._commonService.createNotification('', 'Password reset link has been sent to Email', NotificationType.SUCCESS);
                    _this.resetPasswordPopup.close();
                }
                else {
                    _this._commonService.createNotification('', 'Please verify the Customer\'s Email ID', NotificationType.ERROR);
                }
            }
        }, function (error) {
            _this._commonService.createNotification('', 'Password Reset failed', NotificationType.ERROR);
        });
    };
    FBOProfileComponent.prototype.getDistributorWithPaymentDetails = function (displayNotification) {
        var _this = this;
        this._customerservice.getMemberDetails(this.fboid).subscribe(function (response) {
            if (response && response.memberId) {
                if (response.address !== null) {
                    var stateInfo = void 0;
                    var countryInfo = void 0;
                    var mobileTypeInformation = [];
                    _this.businessEntityInfo = response.businessEntities;
                    mobileTypeInformation = response.memberContacts;
                    if (mobileTypeInformation && mobileTypeInformation.length > 0) {
                        var mobileNumber = mobileTypeInformation.find(function (item) { return item.contactTypeID === ContactTypeValue.MOBILE; });
                        if (mobileNumber != undefined) {
                            _this.fboProfileDetail.mobile = mobileNumber.value;
                            _this.distributorInfoObj.contactNumber = mobileNumber.value;
                        }
                        var phone = mobileTypeInformation.find(function (item) { return item.contactTypeID === ContactTypeValue.PHONE; });
                        if (phone !== undefined) {
                            _this.fboProfileDetail.homePhoneNumber = phone.value;
                            _this.distributorInfoObj.contactNumber = phone.value;
                        }
                    }
                    if (response.memberAccountNotifications && response.memberAccountNotifications.length) {
                        _this.accountNotification = response.memberAccountNotifications[0];
                        _this.notification = {
                            id: _this.fboProfileDetail.fboId,
                            firstName: _this.fboProfileDetail.firstName,
                            middleName: _this.fboProfileDetail.middleName ? _this.fboProfileDetail.middleName : '',
                            lastName: _this.fboProfileDetail.lastName,
                            displayName: _this.fboProfileDetail.displayName,
                            memberLevel: _this.fboProfileDetail.memberLevel,
                            memberTypeId: _this.fboProfileDetail.memberTypeId,
                            subject: response.memberAccountNotifications[0].subject ? response.memberAccountNotifications[0].subject : '',
                            body: response.memberAccountNotifications[0].body ? response.memberAccountNotifications[0].body : '',
                            enable: response.memberAccountNotifications[0].enable ? true : false,
                        };
                        if (displayNotification) {
                            _this.displayNotification = displayNotification;
                        }
                    }
                    _this.memberStatus = response.memberStatus;
                    _this.fboProfileDetail.address = new AddressInformation();
                    _this.fboProfileDetail.birthDate = _this.getFormattedDOB(response.dateOfBirth);
                    _this.addressFirstLine = (response.address.addressLine1 && response.address.addressLine1 !== '') ? response.address.addressLine1 : '';
                    _this.fboProfileDetail.address.addressFirstLine = _this.addressFirstLine;
                    if (response.address.addressLine2 && response.address.addressLine2 !== '') {
                        _this.fboProfileDetail.address.addressSecondLine = response.address.addressLine2;
                        _this.addressFirstLine += ', ' + response.address.addressLine2;
                    }
                    if (response.address.addressLine3 && response.address.addressLine3 !== '') {
                        _this.fboProfileDetail.address.addressThirdLine = response.address.addressLine3;
                        _this.addressFirstLine += ',' + response.address.addressLine3;
                    }
                    if (response.address.addressLine4 && response.address.addressLine4 !== '') {
                        _this.fboProfileDetail.address.addressFourthLine = response.address.addressLine4;
                        _this.addressFirstLine += ',' + response.address.addressLine4;
                    }
                    _this.fboProfileDetail.address.id = response.address.id;
                    _this.fboProfileDetail.address.addressTypeId = response.address.addressTypeId;
                    _this.fboProfileDetail.address.countryId = response.address.countryId;
                    _this.fboProfileDetail.address.addressLine1 = response.address.addressLine1;
                    _this.fboProfileDetail.address.stateId = response.address.stateId;
                    _this.fboProfileDetail.address.addressLine2 = response.address.addressLine2;
                    _this.fboProfileDetail.address.addressLine3 = response.address.addressLine3;
                    _this.fboProfileDetail.address.addressLine4 = response.address.addressLine4;
                    var stateValue = _this.states.find(function (state) { return state.id === _this.fboProfileDetail.address.stateId; });
                    _this.fboProfileDetail.address.stateCode = stateValue ? stateValue.stateCode : null;
                    _this.addressDetailId = response.address.id;
                    _this.memberAddressDetailId = response.address.memberAddressDetailId;
                    _this.stateId = response.address.stateId ? response.address.stateId : null;
                    _this.countryId = response.address.countryId ? response.address.countryId : null;
                    if (_this.stateId !== null || _this.stateId !== undefined) {
                        if (_this.states !== undefined) {
                            stateInfo = _this.states.find(function (state) { return state.id === _this.stateId; });
                        }
                    }
                    if (_this.countryId !== null || _this.countryId !== undefined) {
                        if (_this.countries !== undefined) {
                            countryInfo = _this.countries.find(function (country) { return country.countryId === _this.countryId; });
                        }
                    }
                    _this.fboProfileDetail.address.state = stateInfo !== null && stateInfo !== undefined ? stateInfo.stateName : '';
                    _this.addressSecondLine = (response.address.city && response.address.city !== '') ? response.address.city : '';
                    _this.fboProfileDetail.address.city = response.address.city;
                    if (_this.fboProfileDetail.address.state && !_this.isStateCountriesDisable(_this.homeCountry)) {
                        _this.addressSecondLine += ', ' + _this.fboProfileDetail.address.state;
                    }
                    if (response.address.postalCode && response.address.postalCode !== '') {
                        _this.fboProfileDetail.address.zipCode = response.address.postalCode;
                    }
                    _this.fboProfileDetail.address.country = countryInfo !== null && countryInfo !== undefined ? countryInfo.name : '';
                    _this.fboProfileCountry = _this.fboProfileDetail.address.country;
                }
                _this.fboProfileDetail.spouseFullName = response.spouseName;
                var memberId = response.memberId;
                _this.autoshipMemberInfo.memberId = memberId;
                _this.autoshipMemberInfo.homeCountry = _this.homeCountry;
                _this.autoshipMemberInfo.memberLevel = _this.fboProfileDetail.memberLevel;
                _this.autoshipMemberInfo.wholesaleQualified = response.wholeSaleQualified;
                _this.fboProfileDetail.wholesaleQualified = response.wholeSaleQualified;
                if (_this.memberLevels && _this.memberLevels.length > 0) {
                    var level = _this.memberLevels.find(function (item) { return item.name === _this.autoshipMemberInfo.memberLevel; });
                    _this.autoshipMemberInfo.memberLevelId = level ? level.id : 0;
                }
                if (response.memberRetailSubscriptionId != null && response.memberRetailSubscriptionId > 0) {
                    _this.isRetailSubscriptionLogin = true;
                    _this.memberRetailSubscriptionId = response.memberRetailSubscriptionId;
                    _this.getRetailSubscriptionDetail(_this.memberRetailSubscriptionId);
                }
                _this.getAllAutoships(memberId, _this.homeCountry);
                _this.getMemberPaymentDetails(memberId);
                // if(memberId){
                //     this.getSavedAchs();
                // }
                //this.getDistributorECheckPayments(memberId, this.homeCountry);
                if (_this.homeCountry !== '' && _this.homeCountry !== undefined) {
                    _this.getStoreInfo();
                }
            }
            _this.isFpcEligibleForPcSponsor = response && response.pcSponsorEligible ? true : false;
        });
    };
    /*
    get member levels lookup
    */
    FBOProfileComponent.prototype.getMemberLevels = function () {
        var _this = this;
        this._customerservice.getMemberLevelsLookup()
            .subscribe(function (response) {
            if (response) {
                _this.memberLevels = response;
            }
        });
    };
    /*
    get store Info
    */
    FBOProfileComponent.prototype.getStoreInfo = function () {
        var _this = this;
        var countryCodes = [this.homeCountry];
        this._customerservice.getStoreInfoFromConfig(countryCodes)
            .subscribe(function (response) {
            if (response) {
                _this.storeId = response.countryId;
                _this.storeInfo = response;
                if (_this.fboProfileDetail) {
                    _this.fboProfileDetail = __assign({}, _this.fboProfileDetail, { displayMiddleName: _this.storeInfo.displayMiddleName });
                }
                if (_this.displayNotification && _this.notification) {
                    _this.notification.displayMiddleName = _this.storeInfo.displayMiddleName;
                    _this._messageService.setAccountNotification(_this.notification);
                }
                _this._messageService.setStoreID(response.id);
                _this.setFboBonusInformationPermissions(response.id);
                _this.setSingleAndDirectDebitPermissions(response.id);
                _this.fetchPCSponsorEligiblityForStore(_this.storeInfo);
                _this.autoshipMemberInfo.currencySymbol = response.currencySymbol.trim();
                _this.autoshipTabInfo.emit(_this.autoshipMemberInfo);
                _this.homeStoreId = response.id;
                _this.getStoreLevelPermissions();
                _this.bondedWarehouseProjectViewPermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + _this.bondedWarehouseProjectPermission[0] + ']'), AccessLevel.Store, _this.homeStoreId);
                _this.bondedWarehouseProjectManagePermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + _this.bondedWarehouseProjectPermission[1] + ']'), AccessLevel.Store, _this.homeStoreId);
                if (_this.showSingleAndDirectDebitMenu) {
                    _this.getStorePaymentMethods(response.id);
                }
                if (response.retailSubscriptionModel ? true : false) {
                    _this.fboProfileDetail.retailSubscriptionModel = new RetailSubscription();
                    _this.fboProfileDetail.retailSubscriptionModel.chargeBeePlanId = response.retailSubscriptionModel.chargeBeePlanId;
                    _this.fboProfileDetail.retailSubscriptionModel.storeSubscriptionType = response.retailSubscriptionModel.storeSubscriptionType;
                    _this.fboProfileDetail.retailSubscriptionModel.designateStoreId = response.retailSubscriptionModel.designateStoreId;
                    _this.fboProfileDetail.retailSubscriptionModel.opCoSubscriptionType = response.retailSubscriptionModel.opCoSubscriptionType;
                    if (_this.fboProfileDetail.retailSubscriptionModel.opCoSubscriptionType === OpCoRetailSubscriptionEnum.OperatingCountryLevel &&
                        _this.fboProfileDetail.retailSubscriptionModel.designateStoreId) {
                        _this._customerservice.getRetailParticipationTypeByStore(_this.fboProfileDetail.retailSubscriptionModel.designateStoreId).subscribe(function (retailParticipationResponse) {
                            if (retailParticipationResponse) {
                                if (retailParticipationResponse && retailParticipationResponse.chargebeePlanID && retailParticipationResponse.subscriptionParticipationType) {
                                    if (retailParticipationResponse.subscriptionParticipationType === StoreRetailSubscriptionEnum.Participating) {
                                        _this.isStoreRetailSubscriptionEnabled = true;
                                        _this.fboProfileDetail.retailSubscriptionModel.chargeBeePlanId = retailParticipationResponse.chargebeePlanID;
                                    }
                                }
                            }
                        });
                    }
                    else if ((_this.fboProfileDetail.retailSubscriptionModel.opCoSubscriptionType === OpCoRetailSubscriptionEnum.StoreLevel &&
                        _this.fboProfileDetail.retailSubscriptionModel.storeSubscriptionType === StoreRetailSubscriptionEnum.Participating)) {
                        _this.isStoreRetailSubscriptionEnabled = true;
                    }
                }
                if (_this.storeId) {
                    _this.getMemberBonusInfo();
                }
            }
        });
    };
    FBOProfileComponent.prototype.getStorePaymentMethods = function (storeid) {
        var _this = this;
        var fpc5PercentEnabled = this.appConfig && this.appConfig.fpc5PercentEnabled ? this.appConfig.fpc5PercentEnabled : false;
        if (this.showSingleAndDirectDebitMenu) {
            this._orderService.getPaymentMethodsByStore(storeid, this.fboProfileDetail.homeCountryCode, this.languagecode, this.fboProfileDetail.memberTypeId, this.fboProfileDetail.wholesaleQualified, fpc5PercentEnabled, false, false, this.fboProfileDetail.memberId).subscribe(function (response) {
                if (response) {
                    var storeInfoPayment = response;
                    storeInfoPayment.forEach(function (payment) {
                        if (payment.paymentMethodId === PaymentType.Single_Debit) {
                            _this.showSingleDebit = true;
                        }
                        if (payment.paymentMethodId === PaymentType.Direct_Debit) {
                            _this.showDirectDebit = true;
                        }
                    });
                }
            });
        }
    };
    FBOProfileComponent.prototype.setFboBonusInformationPermissions = function (storeId) {
        this.hasFboBonusInfoViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_VIEW + ']'), AccessLevel.Store, storeId);
        this.hasFboBonusInfoDeletePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_DELETE + ']'), AccessLevel.Store, storeId);
        this.hasFboBonusInfoManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_MANAGE + ']'), AccessLevel.Store, storeId);
    };
    FBOProfileComponent.prototype.setSingleAndDirectDebitPermissions = function (storeId) {
        this.singleAndDirectDebitViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.SINGLE_AND_DIRECT_DEBIT_VIEW + ']'), AccessLevel.Store, storeId);
        this.singleAndDirectDebitManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.SINGLE_AND_DIRECT_DEBIT_MANAGE + ']'), AccessLevel.Store, storeId);
    };
    /*
   get Echeck payment methods of the distributor
   */
    FBOProfileComponent.prototype.getDistributorECheckPayments = function (distributorMemberId, countryCode) {
        var _this = this;
        this._customerservice.getPersonalChecks(distributorMemberId, countryCode).subscribe(function (response) {
            if (response && response.length > 0) {
                _this.distributorDefaultECheckPaymentInfo = response;
                _this.distributorDefaultECheckPaymentInfo.forEach(function (eCheque) {
                    eCheque.notes = eCheque.defaultECheck ? 'Default' : '';
                });
            }
        });
    };
    /*
    get autoship details
    */
    FBOProfileComponent.prototype.getAllAutoships = function (memberId, countryCode) {
        var _this = this;
        this._customerservice.getAllAutoships(memberId, countryCode)
            .subscribe(function (response) {
            if (response && response.length > 0) {
                var autoShipInfo = response[0].body;
                _this.activeAutoShipInfo = autoShipInfo.filter(function (autoship) { return autoship.autoshipStatusId === RowStatus.Active; });
                if (_this.activeAutoShipInfo && _this.activeAutoShipInfo.length > 0) {
                    if (_this.activeAutoShipInfo[0].autoShipDisplayDate) {
                        _this.activeAutoShipInfo[0].autoShipDisplayDate = _this.getDateObject(_this.activeAutoShipInfo[0].autoShipDisplayDate);
                    }
                }
                _this.inactiveAutoShipInfo = autoShipInfo.filter(function (autoship) { return autoship.autoshipStatusId === RowStatus.InComplete; });
            }
            else {
                _this.activeAutoShipInfo = [];
            }
        });
    };
    FBOProfileComponent.prototype.getDateObject = function (date) {
        var resultDate;
        if (date) {
            var splitDate = date.split('-');
            // Setting the year ,month , date
            resultDate = new Date(Number(splitDate[0]), Number(splitDate[1]) - 1, Number(splitDate[2]));
            return resultDate;
        }
    };
    FBOProfileComponent.prototype.getMemberPaymentDetails = function (memberId) {
        var _this = this;
        this._customerservice.getMemberPaymentDetails(memberId).subscribe(function (response) {
            if (response && response.savedCards && response.savedCards.length > 0) {
                _this.distributorDefaultCardPaymentInfo = response.savedCards;
                _this.distributorDefaultCardPaymentInfo.forEach(function (card) {
                    card.notes = card.default ? 'Default' : '';
                });
            }
            if (response && response.personalChecks && response.personalChecks.length > 0) {
                _this.distributorDefaultECheckPaymentInfo = response.personalChecks;
                _this.distributorDefaultECheckPaymentInfo.forEach(function (eCheque) {
                    eCheque.notes = eCheque.default ? 'Default' : '';
                });
            }
        });
    };
    FBOProfileComponent.prototype.getAllCountriesInfo = function () {
        var _this = this;
        this._customerService.getAllCountries(true).subscribe(function (response) {
            if (response) {
                _this.titanEnabledCountries = response.filter(function (country) { return country.titanEnabled; });
                _this.countries = response;
                _this.countriesList = response;
            }
            _this.getAllStates();
        });
    };
    FBOProfileComponent.prototype.getAllStates = function () {
        var _this = this;
        this._customerService.getAllStates().subscribe(function (response) {
            if (response) {
                _this.states = response;
                _this.statesModal = response;
            }
            _this._id ? _this.getFBOProfileInfoFromTitan(true) : '';
        });
    };
    /**
* failed to upload file
* @param item
* @param response
* @param status
* @param headers
*/
    FBOProfileComponent.prototype.onErrorItem = function (item, response, status, headers) {
        this.ngProgress.done();
        var message = this._translatePipe.get('customer-service.Invalid file format');
        this.message = message.value + (response ? ',' + response : '');
        this.showEmailErrorMessage = true;
        this.isSendingEmail = false;
        this.count = 0;
        this.composeEmailRequest.messageModel.attachments = [];
        this.uploadResponse = [];
    };
    FBOProfileComponent.prototype.onSuccessItem = function (item, response, status, headers) {
        if (response) {
            var res = JSON.parse(response);
            var fileDetails = {
                'userId': this.userInfo.userId,
                'fileName': this.uploader.queue[this.count].file.name,
                'url': res.url,
                'eTag': res.eTag,
                'key': res.key
            };
            this.uploadResponse.push(fileDetails);
            this.count++;
            if (this.uploader.queue.length === this.count) {
                this.composeEmailRequest.messageModel.attachments = this.uploadResponse;
                this.sentEmail(this.composeEmailRequest);
            }
        }
        else {
            this._commonService.createNotification('', 'File Not uploaded', NotificationType.ERROR);
        }
        this.ngProgress.done();
    };
    /**
    *Empty Method
    */
    FBOProfileComponent.prototype.noAction = function () {
    };
    /*Check for max of 5 attachments */
    FBOProfileComponent.prototype.checkMaxAttachments = function () {
        if (this.uploader.queue) {
            this.attachmentsLength = this.uploader.queue.length;
            if (this.attachmentsLength >= 5) {
                while (this.attachmentsLength > 5) {
                    this.uploader.queue[this.uploader.queue.length - 1].remove();
                    this.attachmentsLength--;
                }
            }
        }
    };
    FBOProfileComponent.prototype.impersonateUser = function () {
        this.enableFBOLogin = false;
        this.cookieService.delete(CacheKey.COUNTRY_CODE, environment.cookiePath, environment.cookieDomain);
        this.cookieService.delete(CacheKey.LANGUAGE_CODE, environment.cookiePath, environment.cookieDomain);
        this.cookieService.delete(CacheKey.COUNTRY_ID, environment.cookiePath, environment.cookieDomain);
        if (this.fboProfileDetail.memberId) {
            this.impersonateTitan(this.fboProfileDetail.fboId);
        }
        else if (this.fboProfileDetail && this.fboProfileDetail.address && this.fboProfileDetail.address.country) {
            this.impersonateLegacy(this.fboProfileDetail.fboId, this.fboProfileDetail.address.country);
        }
    };
    FBOProfileComponent.prototype.checkAndImpersonateTitanUser = function (fboId) {
        var _this = this;
        this._customerService.getUserResourceDetail(fboId)
            .subscribe(function (res) {
            if (res && res.id) {
                var activityLogKeys = [{
                        key: MemberActivityLogType.Impersonation_Started,
                        value: fboId
                    }];
                _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                _this.checkAndCreateExternalUserSession(fboId);
                _this.enableFBOLogin = true;
            }
            else {
                _this.showImpersonateUserErrorMessage();
            }
        }, function (error) { return _this.handleError(); });
    };
    FBOProfileComponent.prototype.showImpersonateUserErrorMessage = function () {
        var _this = this;
        var message = this._translatePipe.get('customer-service.Impersonate User Error Message');
        var options = this._translatePipe.get('customer-service.Click here for other options');
        var html = "<div>\n                    <div>" + message.value + "</div>" +
            "<div id=\"more-info\"><a id=\"more-options\">" + options.value + "</a></div>\n                    </div>";
        var type = this._commonService.getNotificationType(NotificationType.ERROR);
        var toast = this._notificationService.html(html, type, {
            timeOut: 0,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            clickIconToClose: true,
            icons: this._commonService.getIcons()
        });
        toast.click.subscribe(function (event) {
            if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_INFO
                || event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                _this.showMoreInformationPopup.open();
            }
        });
        this.enableFBOLogin = true;
    };
    FBOProfileComponent.prototype.closeShowMoreInformationPopup = function () {
        this.showMoreInformationPopup.close();
    };
    FBOProfileComponent.prototype.checkAndCreateExternalUserSession = function (fboId) {
        var _this = this;
        var sessionId = this.cookieService.get(CacheKey.EPSS);
        if (sessionId) {
            this._customerService.getAdminToken(fboId).subscribe(function (response) {
                if (response) {
                    _this._customerService.endUserSession(sessionId).subscribe(function (r) {
                        return _this._customerService.impersonate(response, fboId, CacheKey.TITAN).subscribe(function (res) {
                            window.open(window.location.origin + '/impersonation?istitan=' + _this.isTitanEnabled, '_blank');
                        }, function (error) { return _this.handleError(); });
                    }, function (error) { return _this.handleError(); });
                }
            }, function (error) { return _this.handleError(); });
        }
        else {
            this._customerService.getAdminToken(fboId).subscribe(function (response) {
                if (response) {
                    _this._customerService.impersonate(response, fboId, CacheKey.TITAN).subscribe(function (res) {
                        window.open(window.location.origin + '/impersonation?istitan=' + _this.isTitanEnabled, '_blank');
                    }, function (error) { return _this.handleError(); });
                }
            }, function (error) { return _this.handleError(); });
        }
    };
    FBOProfileComponent.prototype.impersonateTitan = function (fboId) {
        this.checkAndImpersonateTitanUser(fboId);
    };
    FBOProfileComponent.prototype.impersonateLegacy = function (fboId, country) {
        var _this = this;
        this._customerService.getAdminToken().subscribe(function (response) {
            if (response) {
                _this.enableFBOLogin = true;
                _this._customerService.impersonate(response, fboId, CacheKey.AS400).subscribe(function (res) {
                    window.open(window.location.origin + '/impersonation?istitan=' + _this.isTitanEnabled, '_blank');
                }, function (error) { return _this.handleError(); });
            }
        }, function (error) { return _this.handleError(); });
    };
    /**
     * @description will update the home Country in titan
     * @date 2020-09-23
     * @param {*} addressDetails
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.updateHomeCountryInTitan = function (addressDetails, transliterateProp) {
        var _this = this;
        var btn = document.getElementsByClassName('remove-disable')[0];
        if (addressDetails && addressDetails.addressLine1 && addressDetails.city && addressDetails.countryId) {
            this._customerservice.updateHomeCountryInTitan(this.fboProfileDetail.id, this.memberAddressDetailId, addressDetails, transliterateProp)
                .subscribe(function (response) {
                btn.disabled = false;
                if (response.success) {
                    var activityLogKeys = [{
                            key: MemberActivityLogType.RegisteredAddress_Updated,
                            value: _this.prepareHomeCountryAddress(addressDetails)
                        }];
                    _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                    var addedNotification = _this._translatePipe.get('customer-service.Registered Address Updated Successfully');
                    _this._commonService.createNotification('', addedNotification.value, NotificationType.SUCCESS);
                    _this.getFBOProfileInfoFromTitan();
                    _this.closePopUp();
                }
                else if (response.error !== '') {
                    _this._commonService.createNotification('', response.error, NotificationType.ERROR);
                }
            }, function (error) {
                btn.disabled = false;
                _this._commonService.createNotification('', 'Unable to Update Address', NotificationType.ERROR);
            });
        }
    };
    /**
     * @date 2020-09-23
     * @param {Address} address
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.getNewAddressInfo = function (address) {
        var _this = this;
        if (address) {
            var titanPlatformEnabled = false;
            var addressDetails_1 = this.prepareSaveAddressRequest(address, false);
            var homeCountry = this.countriesList.find(function (country) { return country.countryId === address.countryId; });
            if (homeCountry) {
                titanPlatformEnabled = homeCountry.titanPlatformEnabled;
            }
            var tranliterateProp_1 = this.populateTransliterateObj();
            if (this.fboProfileDetail && this.fboProfileDetail.homeCountryCode && address.countryCode && this.fboProfileDetail.homeCountryCode.toLowerCase() == address.countryCode.toLowerCase()) {
                this.updateCountry(address, addressDetails_1, tranliterateProp_1);
            }
            else {
                this._customerservice.getStoreInfoFromConfig(address.countryCode).pipe(catchError(function (err) { return of(err); })).subscribe(function (store) {
                    if (store && store.homeIsocodeThree && _this.fboProfileDetail && _this.fboProfileDetail.homeCountryCode
                        && _this.fboProfileDetail.homeCountryCode.toLowerCase() !== store.homeIsocodeThree.toLowerCase()) {
                        var language = _this._commonService.getStoreDefaultLanguage(store);
                        tranliterateProp_1 = _this._commonService.mapTransliterateProperties(store, language);
                    }
                    _this.updateCountry(address, addressDetails_1, tranliterateProp_1);
                });
            }
        }
    };
    FBOProfileComponent.prototype.updateCountry = function (address, addressDetails, tranliterateProp) {
        var _this = this;
        var btn = document.getElementsByClassName('remove-disable')[0];
        if (btn && !btn.disabled) {
            btn.disabled = true;
        }
        if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.RETAIL) {
            this.updateHomeCountryInTitan(addressDetails, tranliterateProp);
        }
        else {
            this._customerservice.getOperatingCountriesByCountryCode(address.countryCode).subscribe(function (response) {
                if (response && _this.fboProfileDetail.operatingCountryCode) {
                    if (_this.fboProfileDetail.operatingCountryCode !== response.operatingCountryCode) {
                        _this.updateOperatingCountry(address, true, tranliterateProp);
                    }
                    else {
                        _this.updateHomeCountryInTitan(addressDetails, tranliterateProp);
                    }
                }
            });
        }
    };
    /**
     * @description will update the registered address
     * @date 2020-09-23
     * @param {*} address
     * @param {boolean} isUpdateMemberHomeCompany
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.updateOperatingCountry = function (address, isUpdateMemberHomeCompany, transliterateProp) {
        var _this = this;
        var addressDetail = this.prepareSaveAddressRequest(address, isUpdateMemberHomeCompany);
        var btn = document.getElementsByClassName('remove-disable')[0];
        if (addressDetail && addressDetail.addressLine1 && addressDetail.city && addressDetail.countryCode) {
            this._customerservice.updateMemberRegisterAddress(+this.fboProfileDetail.id, this.memberAddressDetailId, addressDetail, transliterateProp)
                .subscribe(function (response) {
                btn.disabled = false;
                if (response.success) {
                    var notification = null;
                    if (response.requestStatus && response.requestStatus === StatusConstants.SUCCESS) {
                        notification = _this._translatePipe.get('customer-service.Registered Address Updated Successfully');
                        _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                        var activityLogKeys = [{
                                key: MemberActivityLogType.Homecountry_Updated,
                                value: addressDetail.countryCode
                            }];
                        _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                    }
                    else if (response.requestStatus && response.requestStatus === StatusConstants.IN_PROGRESS) {
                        notification = _this._translatePipe.get('Please allow up to 24 hours for modifications to be processed.');
                        _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    }
                    else {
                        notification = _this._translatePipe.get('errorcodes.' + response.validations[0].name);
                        _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                    _this.getFBOProfileInfoFromTitan();
                    _this.closePopUp();
                }
                else if (response.validations && response.validations.length) {
                    btn.disabled = false;
                    var notification = _this._translatePipe.get('errorcodes.' + response.validations[0].name);
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
            }, function (error) {
                btn.disabled = false;
                if (error.validations && error.validations.length) {
                    var notification = _this._translatePipe.get('errorcodes.' + error.validations[0].name);
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
                else {
                    var notification = _this._translatePipe.get('errorcodes.FAIL: SYSDWN. Valence API for Member Home Country Change');
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
            });
        }
    };
    FBOProfileComponent.prototype.prepareHomeCountryAddress = function (address) {
        var addressDetails = (address.addressLine1 && address.addressLine1 !== '') ? address.addressLine1.trim() : '';
        if (address.addressLine2 && address.addressLine2 !== '') {
            addressDetails += ',' + address.addressLine2.trim();
        }
        addressDetails += ',' + ((address.city && address.city !== '') ? address.city : '');
        if (address.stateCode && address.stateCode !== '') {
            addressDetails += ',' + address.stateCode;
        }
        if (address.postalCode && address.postalCode !== '') {
            addressDetails += ',' + address.postalCode;
        }
        if (address.countryCode && address.countryCode !== '') {
            addressDetails += ',' + address.countryCode;
        }
        return addressDetails;
    };
    FBOProfileComponent.prototype.GetMemberTypeList = function () {
        this.memberTypeName = [];
        this.memberTypeName.push({ id: this.memberTypeEnum.DISTRIBUTOR, type: StatusConstants.FBO });
        this.memberTypeName.push({ id: this.memberTypeEnum.FPC, type: StatusConstants.FPC });
        return this.memberTypeName;
    };
    FBOProfileComponent.prototype.GetMemberLevelList = function () {
        this.memberLevelList = [];
        this.memberLevelList.push({ id: MemberTitleExtEnums.Retail, type: StatusConstants.Retail });
        this.memberLevelList.push({ id: MemberTitleExtEnums.PreferredCustomer, type: StatusConstants.PreferredCustomer });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Assistant_Supervisor, type: StatusConstants.Assistant_Supervisor });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Supervisor, type: StatusConstants.Supervisor });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Assistant_Manager, type: StatusConstants.Assistant_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Manager, type: StatusConstants.Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Unrecognized_Manager, type: StatusConstants.Unrecognized_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Recognized_Manager, type: StatusConstants.Recognized_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Senior_Manager, type: StatusConstants.Senior_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Soaring_Manager, type: StatusConstants.Soaring_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Sapphire_Manager, type: StatusConstants.Sapphire_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Diamond_Sapphire_Manager, type: StatusConstants.Diamond_Sapphire_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Diamond_Manager, type: StatusConstants.Diamond_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Double_Diamond_Manager, type: StatusConstants.Double_Diamond_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Triple_Diamond_Manager, type: StatusConstants.Triple_Diamond_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Diamond_Centurion_Manager, type: StatusConstants.Diamond_Centurion_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.PreferredCustomer, type: StatusConstants.FPC });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Guest, type: StatusConstants.GUEST });
        return this.memberLevelList;
    };
    FBOProfileComponent.prototype.getFlp360AccessInfo = function () {
    };
    FBOProfileComponent.prototype.saveMemberTypeorLevelInfo = function () {
        var _this = this;
        if (this.changeMemberTypeandLevelForm.valid) {
            this.memberWholesaleQualifiedRequest.memberId = this.fboProfileDetail.fboId;
            this.memberWholesaleQualifiedRequest.memberNdpFlag = this.changeMemberTypeandLevelForm.value.enableStatus ? 'N' : 'Y';
            this.memberWholesaleQualifiedRequest.memberHomeCountry = this.homeCountry;
            this._customerservice.saveWholesaleQualifiedInfo(this.memberWholesaleQualifiedRequest)
                .subscribe(function (response) {
                if (response && response.success) {
                    _this._customerservice.saveWholesaleQualifiedInfoToTitan(_this.memberWholesaleQualifiedRequest)
                        .subscribe(function (res) {
                        if (res && res.isSuccess) {
                            _this.SaveMemberNote();
                            _this.changeMemberTypeandLevelPopup.close();
                            _this._commonService.createNotification('', 'Member is Updated to wholesale qualified', NotificationType.SUCCESS);
                            _this.getDistributorWithPaymentDetails();
                        }
                    });
                }
                else {
                    _this.changeMemberTypeandLevelPopup.close();
                    _this._commonService.createNotification('', 'error, While Updating', NotificationType.ERROR);
                }
            });
        }
        else {
            this._commonService.createNotification('', 'error', NotificationType.ERROR);
        }
    };
    FBOProfileComponent.prototype.SaveMemberNote = function () {
        var notesData = {
            'noteTypeID': MemberNoteType.AccountTypeID,
            'description': MemberNoteType.Description + ' by ' + this.userInfo.userName,
            'summary': MemberNoteType.Description,
            'createdByUserId': this.userInfo.userId,
            'createdByUserName': this.userInfo.userName,
            'createdDate': new Date(),
            'memberId': this.fboProfileDetail.id ? this.fboProfileDetail.id : null,
            'distributorId': this._id,
        };
        this._customerservice.saveNoteAtMemberLevel(notesData).subscribe(function (response) {
            if (response) {
            }
        });
    };
    /**
   *Gets static Image URLS from Assets
   *
   * @memberof MyprofileComponent
   */
    FBOProfileComponent.prototype.getStaticImageUrl = function () {
        if (environment.production) {
            return environment.baseHref + '/resources/static/src/' + DefaultProfileImage.PROFILE_DEFAULT_IMAGE;
        }
        else {
            return environment.baseHref + DefaultProfileImage.PROFILE_DEFAULT_IMAGE;
        }
    };
    /**
     * @description Navigate sponsor details while click on fbo number or name
     * @date 2019-07-08
     * @param {*} id
     * @param {string} memberType
     * @param {string} name
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.navigateToFBOProfile = function (id, memberType, firstName, lastName, memberLevelID) {
        var _this = this;
        // verifying permissions - whether any one of the permission exists for logged in user.
        this._commonService.getMemberStatus(id).subscribe(function (response) {
            if (response && response.status === AccountRestrictionStatus.RESTRICTED && !_this.accountViewPermission) {
                var memberlevel = _this._commonService.getMemberLevel(memberLevelID);
                _this.accountRestriction = true;
                var memberDetails = {
                    fboId: id,
                    firstName: firstName,
                    lastname: lastName,
                    memberLevel: memberlevel
                };
                _this.memberDetails = memberDetails;
            }
            else {
                _this.navigateFBODetail(id, memberType, firstName);
            }
        });
    };
    FBOProfileComponent.prototype.navigateFBODetail = function (id, memberType, firstName) {
        if (this._commonService.checkPermissionByAccessLevel(this.FBODetailPermissions, AccessLevel.Customer_Service)) {
            var fboInfo = { id: id, tabName: firstName, componentName: 'fboPage', memberType: MemberType.FOB };
            this.messageService.setCustomerServiceTabContent(fboInfo);
        }
        else {
            this.displayAlertbox();
        }
    };
    FBOProfileComponent.prototype.closeModal = function (status) {
        this.accountRestriction = status;
    };
    /**
   * display alert box if the logged in user do not have permission to see the fbo/retail information
   */
    FBOProfileComponent.prototype.displayAlertbox = function () {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    };
    /**
   * Get json form validations
   *
   * @memberof PersonalInfoComponent
   */
    FBOProfileComponent.prototype.getFormValidationsJSON = function () {
        var _this = this;
        this._commonService.getFormValidationsJSON()
            .subscribe(function (response) {
            _this.getCountrySpecificValidations(response);
        });
    };
    FBOProfileComponent.prototype.getCountrySpecificValidations = function (validations) {
        var _this = this;
        if (validations) {
            var filterCountryLevlValidations = validations
                .find(function (x) { return x.countryCode.toUpperCase() === _this.homeCountry.toUpperCase(); });
            if (filterCountryLevlValidations) {
                this.personalInfoFormValidations = filterCountryLevlValidations.validations;
            }
        }
    };
    FBOProfileComponent.prototype.onKeypress = function (event, controlName) {
        this.duplicateCheck = false;
        if (controlName === 'ssn') {
        }
        if (event.keyCode != 9) {
            var value = (event.key ? event.key : '');
            if (this.personalInfoFormValidations && this.personalInfoFormValidations.governmentID) {
                if (!new RegExp(this.personalInfoFormValidations.governmentID.pattern).test(value)) {
                    event.preventDefault();
                }
            }
            else {
                var pattern = /^[0-9]*$/;
                if (!new RegExp(pattern).test(value)) {
                    event.preventDefault();
                }
            }
        }
        else {
            error;
        }
    };
    // Updating updateGovernmentID
    FBOProfileComponent.prototype.updateGovernmentID = function (isValid) {
        var _this = this;
        this.fboProfileDetail.governmentIDType = this.fboProfileDetail.governmentIDType || GovernmentIDType.SSN;
        if (isValid && this.ssn !== '') {
            var identificationType_1 = this.getIdentificationType();
            var identificationModel = this.identificationTypes.find(function (x) {
                return x.countryID === _this.fboProfileDetail.homeCountryId && x.identificationType === identificationType_1;
            });
            var memberGovernmentIdentifications_1 = {
                'governmentIDType': identificationModel && identificationModel.identificationTypeID,
                'value': this.changeGovtIDForm.controls['ssn'].value,
                'identificationType': identificationModel && identificationModel.identificationType
            };
            this._customerService.validateGovernmentID(this.storeId, this.changeGovtIDForm.controls['ssn'].value, this.homeCountry, this.fboProfileDetail.memberId).subscribe(function (response) {
                _this.duplicateCheck = true;
            }, function (error) {
                _this.duplicateCheck = false;
                _this._customerservice.updateGovernmentID(memberGovernmentIdentifications_1, _this.fboProfileDetail.id).subscribe(function (response) {
                    if (response.isSuccess === true) {
                        _this.memberGovernmentIdentifiations = [];
                        var activityLogKeys = [{
                                key: MemberActivityLogType.Change_Government_ID,
                                value: '******' + _this.changeGovtIDForm.controls['ssn'].value.substr(-4)
                            }];
                        _this._id ? _this.getMembergovernmentIdentificationsInfo(_this.fboProfileDetail.memberId) : '';
                        _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe(function (res) { }, function (error) { });
                        _this.message = 'Request for Government ID update was submitted, changes will reflect shortly.';
                        _this._commonService.createNotification('', _this.message, NotificationType.WARN);
                    }
                    else {
                        _this._commonService.createNotification('', 'error, While Updating', NotificationType.ERROR);
                    }
                    _this.changeGovtIDPopup.close();
                });
            });
        }
    };
    /*
    * Update Date of Birth
    */
    FBOProfileComponent.prototype.updateDateOfBirth = function (isValid) {
        var _this = this;
        if (isValid) {
            var dob = this._datePipe.transform(this.changeDOBForm.controls['birthDate'].value, 'yyyy-MM-dd');
            this._customerService.updateDOB(this.fboProfileDetail.id, dob).subscribe(function (response) {
                if (response.isSuccess) {
                    var activityLogKeys = [{
                            key: MemberActivityLogType.Change_DOB,
                            value: _this._datePipe.transform(_this.changeDOBForm.controls['birthDate'].value, 'dd-MMM-yyyy')
                        }];
                    _this._commonService.saveMemberActivity(_this.fboProfileDetail.id, activityLogKeys).subscribe();
                    var notification = _this._translatePipe.get('customer-service.DOB Updated Successfully');
                    _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    _this.closePopUp();
                    _this.getFBOProfileInfoFromTitan();
                }
                else {
                    _this._commonService.createNotification('', 'error, While Updating', NotificationType.ERROR);
                }
                _this.getFBOProfileInfoFromTitan();
            });
        }
    };
    /**
     * @description open member preferences popup
     * @date 2020-04-13
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.openChangeMemberPreferences = function () {
        var _this = this;
        this.myMemberPreferences = [];
        if (this.fboProfileDetail.memberId) {
            this._customerService.getMemberPreferences(this.fboProfileDetail.memberId).subscribe(function (response) {
                if (response.memberPreferenceModels) {
                    response.memberPreferenceModels.forEach(function (item) {
                        if (item.preferenceId === MemberPreferenceType.Email) {
                            _this.myMemberPreferences.push(item);
                        }
                    });
                    if (_this.myMemberPreferences && _this.myMemberPreferences.length) {
                        _this.myMemberPreferences.forEach(function (preference) {
                            if (preference.preferenceId === MemberPreferenceType.Email) {
                                if (Number(preference.preferenceValue) === PreferenceValues.no) {
                                    preference.selected = true;
                                }
                                else if (Number(preference.preferenceValue) === PreferenceValues.yes) {
                                    preference.selected = false;
                                }
                            }
                        });
                    }
                    else {
                        _this.myMemberPreferences.push({
                            preferenceId: MemberPreferenceType.Email,
                            preferenceValue: '37',
                            selected: false,
                            memberId: _this.fboProfileDetail.memberId,
                            id: MemberPreferenceType.Email
                        });
                    }
                    _this.changeMemberPreference.open();
                }
            });
        }
    };
    /**
     * @description on checkbox change
     * @date 2020-04-13
     * @param {MemberPrefernceModel} preference
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.OnCheckPreference = function (preference, isChecked) {
        this.myMemberPreferences.forEach(function (item) {
            if (item.id === preference.id) {
                item.selected = isChecked ? true : false;
            }
        });
    };
    /**
     * @description update member preferences
     * @date 2020-04-13
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.updateMemberPreferences = function () {
        var requestArray = [];
        this.saveMemberPreferenceActiveLog();
        this.fboProfileDetail.memberPreference = this.myMemberPreferences[0].selected ? 'Yes' : 'No';
        this.distributorInfoObj.privacyRequested = this.fboProfileDetail.memberPreference;
        this.distributorInfo.emit(this.distributorInfoObj);
        this.myMemberPreferences.forEach(function (preference) {
            requestArray.push({
                id: preference.preferenceId,
                selected: preference.selected ? false : true
            });
            requestArray.push({
                id: MemberPreferenceType.PrivacyPreference,
                selected: preference.selected ? false : true,
            });
        });
        this.memberPreferenceUpdate(this.fboProfileDetail.memberId, requestArray);
        this.changeMemberPreference.close();
    };
    FBOProfileComponent.prototype.saveMemberPreferenceActiveLog = function () {
        var activityLogKeys = [];
        if (this.fboProfileDetail.memberPreference !== (this.myMemberPreferences[0].selected ? 'Yes' : 'No')) {
            activityLogKeys.push({
                key: MemberActivityLogType.Member_Preference_Updated,
                value: this.myMemberPreferences[0].selected ? 'Yes' : 'No'
            });
        }
        if (activityLogKeys && activityLogKeys.length) {
            this._commonService.saveMemberActivity(this.fboProfileDetail.memberId, activityLogKeys)
                .subscribe(function (res) { }, function (error) { });
        }
        return;
    };
    FBOProfileComponent.prototype.enableAmazonSubscription = function (subscribed) {
        var amazonSubscription = this.fboProfileDetail.amazonSubscription === CommonConstant.YES ? true : false;
        if (!(amazonSubscription === subscribed)) {
            var preference = [];
            preference.push({
                id: MemberPreferenceType.AmazonSubscription,
                selected: subscribed
            });
            this.memberPreferenceUpdate(this.fboProfileDetail.memberId, preference, true);
            this.fboProfileDetail.amazonSubscription = subscribed ? CommonConstant.YES : CommonConstant.NO;
            this.saveMemberAmazonSubscriptionLog(subscribed);
        }
    };
    FBOProfileComponent.prototype.memberPreferenceUpdate = function (memberId, preference, isAmazonSubscription) {
        var _this = this;
        var updatedBy;
        var userId = localStorage.getItem('appadmin.UserId');
        if (userId) {
            updatedBy = userId;
        }
        this._customerService.updateMemberPreferences(memberId, preference, updatedBy)
            .subscribe(function (response) {
            if (response) {
                var notificationValue = isAmazonSubscription ? 'Amazon Subscription Updated Successfully' : 'Member Preference Updated Successfully';
                var notification = _this._translatePipe.get(notificationValue);
                _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
            }
        }, function (error) {
            if (error) {
                var addedNotification = _this._translatePipe.get('errorcodes.' + error.validations[0].name);
                _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
            }
        });
    };
    FBOProfileComponent.prototype.saveMemberAmazonSubscriptionLog = function (subscribed) {
        var activityLogKeys = [];
        activityLogKeys.push({
            key: MemberActivityLogType.Amazon_Subscription_Updated,
            value: subscribed ? 'Yes' : 'No'
        });
        if (activityLogKeys && activityLogKeys.length) {
            this._commonService.saveMemberActivity(this.fboProfileDetail.memberId, activityLogKeys)
                .subscribe(function (res) { }, function (error) { });
        }
        return;
    };
    /**
   * @description create the formatted enrollment date
   * @date 2020-08-04
   * @param {string} dateString
   * @returns {Date}
   * @memberof FBOProfileComponent
   */
    FBOProfileComponent.prototype.getFormattedEnrollmentDate = function (dateString) {
        var enrollmentDate = null;
        if (dateString) {
            var enrolDate = new Date(dateString);
            enrollmentDate = new Date(enrolDate.getTime() + enrolDate.getTimezoneOffset() * 60000);
        }
        return enrollmentDate;
    };
    /**
     * @description Get member level and 4CC active
     * @date 2020-08-04
     * @param {string} homeCountry
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.getMemberLevel4CCActive = function (operatingCountry) {
        var _this = this;
        operatingCountry = operatingCountry ? operatingCountry.toString() : '';
        if (operatingCountry) {
            this._commonService
                .getTwoCCSnapshotDetails(this._id, operatingCountry)
                .subscribe(function (response) {
                if (response) {
                    _this.ccSnapshot4CCActive.ccKey = '4CC Active';
                    _this.ccSnapshotLevel.ccKey = 'Level';
                    // if (response[0].monthlyCCValues[2]) {
                    _this.ccSnapshot4CCActive.previousMonthValue = response[0].currentMonthActive;
                    _this.ccSnapshotLevel.previousMonthValue = response[0].endingLevel;
                    // }
                    // if (response[0].monthlyCCValues[3]) {
                    _this.ccSnapshot4CCActive.currentMonthValue = response[1].currentMonthActive;
                    _this.ccSnapshotLevel.currentMonthValue = response[1].endingLevel;
                    // }
                }
            });
        }
    };
    /**
     * @description Get Member level
     * @date 2020-08-28
     * @param {number} level
     * @returns {string}
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.getMemberLevel = function (level) {
        return MemberTitleExtEnums[level] ? MemberTitleExtEnums[level].replace('_', ' ') : '';
    };
    /**
     * @description will return save address request
     * @date 2020-09-23
     * @param {Address} address
     * @param {boolean} isUpdatememberHomeCompany
     * @returns {*}
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.prepareSaveAddressRequest = function (address, isUpdatememberHomeCompany) {
        var saveAddressRequest = {
            'memberId': this.fboProfileDetail.id,
            'addressLine1': address.addressLine1,
            'addressLine2': address.addressLine2,
            'addressLine3': address.addressLine3 ? address.addressLine3 : '',
            'addressLine4': address.addressLine4 ? address.addressLine4 : '',
            'city': address.city,
            'stateId': address.stateId ? address.stateId : null,
            'stateCode': address.stateCode ? address.stateCode : '',
            'countryId': address.countryId ? address.countryId : null,
            'countryCode': address.countryCode ? address.countryCode : null,
            'postalCode': address.postalCode ? address.postalCode : '',
            'contactTypeID': '',
            'defaultAddress': false,
            'addressVerified': address.addressVerified,
            'addressTypeId': AddressType.MAILING,
            'id': this.addressDetailId,
            'loggedInUserId': this.userInfo ? this.userInfo.userId : '',
            'responseCodes': address.responseCodes ? address.responseCodes : null,
            'latitude': address.latitude,
            'longitude': address.longitude,
            'changedValueType': []
        };
        if (isUpdatememberHomeCompany) {
            saveAddressRequest['memberHomeCompany'] = this.fboProfileDetail.operatingCountry;
        }
        if ((saveAddressRequest.addressLine1 ? saveAddressRequest.addressLine1 : "") !== (this.fboProfileDetail.address.addressLine1 ? this.fboProfileDetail.address.addressLine1 : "") ||
            (saveAddressRequest.addressLine2 ? saveAddressRequest.addressLine2 : "") !== (this.fboProfileDetail.address.addressLine2 ? this.fboProfileDetail.address.addressLine2 : '') ||
            (saveAddressRequest.addressLine3 ? saveAddressRequest.addressLine3 : "") !== (this.fboProfileDetail.address.addressLine3 ? this.fboProfileDetail.address.addressLine3 : '') ||
            (saveAddressRequest.addressLine4 ? saveAddressRequest.addressLine4 : "") !== (this.fboProfileDetail.address.addressLine4 ? this.fboProfileDetail.address.addressLine4 : '') ||
            (saveAddressRequest.city ? saveAddressRequest.city : "") !== (this.fboProfileDetail.address.city ? this.fboProfileDetail.address.city : "") ||
            (saveAddressRequest.postalCode ? saveAddressRequest.postalCode : "") !== (this.fboProfileDetail.address.zipCode ? this.fboProfileDetail.address.zipCode : "") ||
            (saveAddressRequest.countryId ? saveAddressRequest.countryId : "") !== (this.fboProfileDetail.address.countryId ? this.fboProfileDetail.address.countryId : "") ||
            (saveAddressRequest.stateId ? saveAddressRequest.stateId : "") !== (this.fboProfileDetail.address.stateId ? this.fboProfileDetail.address.stateId : "")) {
            if ((saveAddressRequest.countryId ? saveAddressRequest.countryId : "") !== (this.fboProfileDetail.address.countryId ? this.fboProfileDetail.address.countryId : "")) {
                saveAddressRequest.changedValueType = [FBOProfileUpdateEnum.MEMBER_HOME_COUNTRTY_CHANGE];
            }
            else {
                saveAddressRequest.changedValueType = [FBOProfileUpdateEnum.MEMBER_MAILING_ADDRESS_CHANGE];
            }
        }
        var addressVerifiedflag = +saveAddressRequest.latitude === 0 && +saveAddressRequest.longitude === 0 ? false : true;
        saveAddressRequest.addressVerified = saveAddressRequest.addressVerified && addressVerifiedflag ? true : false;
        return saveAddressRequest;
    };
    /**
     * @description will set enable Address subject
     * @date 2020-09-23
     * @param {string} block
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.enableAddressFields = function (block) {
        var addressFieldInfo = {
            isEnableAddressFields: true,
            block: block
        };
        this.messageService.setEnableAddressFields(addressFieldInfo);
    };
    /**
     * @date 2020-10-07
     * @param {*} event
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.displaySearchAddressSection = function (event) {
        this.isDisplaySearchAddressSection = event;
    };
    FBOProfileComponent.prototype.getIdentificationTypes = function () {
        var _this = this;
        this._customerService.getGovernmentIdentificationTypes()
            .subscribe(function (response) {
            if (response) {
                _this.identificationTypes = response;
                _this.governmentIdentificationTypes = JSON.parse(JSON.stringify(response));
                _this.alterIdentificationTypes(_this.governmentIdentificationTypes);
            }
        });
    };
    FBOProfileComponent.prototype.alterIdentificationTypes = function (governmentIdentificationTypes) {
        try {
            var storedCountries = localStorage.getItem("appadmin.Countries");
            var countries = storedCountries ? JSON.parse(storedCountries) : [];
            if (governmentIdentificationTypes && governmentIdentificationTypes.length && countries && countries.length) {
                var eligibleCountryIDs_1 = countries
                    .filter(function (country) { return country && country.isocodeThree && CountryCodeConstant.EligibleCountriesForVatTaxId.includes(country.isocodeThree.toUpperCase()); })
                    .map(function (country) { return country.countryId; });
                governmentIdentificationTypes.forEach(function (governmentIdentificationType) {
                    if (governmentIdentificationType && governmentIdentificationType.identificationType &&
                        governmentIdentificationType.identificationType === GovernmentIdentificationType.VAT_ID &&
                        governmentIdentificationType.countryID && eligibleCountryIDs_1 &&
                        eligibleCountryIDs_1.includes(governmentIdentificationType.countryID)) {
                        governmentIdentificationType.governmentIdTypeLabel = GovernmentIdentificationType.TAX_ID;
                    }
                });
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    FBOProfileComponent.prototype.getIdentificationType = function () {
        var identificationType;
        switch (this.fboProfileDetail.homeCountryCode.toUpperCase()) {
            case 'USA':
                identificationType = IdentificationTypeConstant.USA;
                break;
            case 'CAN':
                identificationType = IdentificationTypeConstant.CAN;
                break;
            case 'GBR':
                identificationType = IdentificationTypeConstant.GBR;
                break;
            case 'IRL':
                identificationType = IdentificationTypeConstant.GBR;
                break;
            case 'ILN':
                identificationType = IdentificationTypeConstant.GBR;
                break;
            case 'ARE':
                identificationType = IdentificationTypeConstant.ARE;
                break;
            case 'SAU':
                identificationType = IdentificationTypeConstant.SAU;
                break;
            case 'QAT':
                identificationType = IdentificationTypeConstant.QAT;
                break;
            case 'KWT':
                identificationType = IdentificationTypeConstant.KWT;
                break;
            case 'BHR':
                identificationType = IdentificationTypeConstant.BHR;
                break;
            case 'OMN':
                identificationType = IdentificationTypeConstant.OMN;
                break;
            case 'AUS':
                identificationType = IdentificationTypeConstant.AUS;
                break;
            case 'SWE':
                identificationType = IdentificationTypeConstant.SWE;
                break;
            case 'FIN':
                identificationType = IdentificationTypeConstant.FIN;
                break;
            case 'NOR':
                identificationType = IdentificationTypeConstant.NOR;
                break;
            case 'DNK':
                identificationType = IdentificationTypeConstant.DNK;
                break;
            case 'NZL':
                identificationType = IdentificationTypeConstant.NZL;
                break;
            case 'POL':
                identificationType = IdentificationTypeConstant.POL;
                break;
            case 'MKD':
                identificationType = IdentificationTypeConstant.MKD;
                break;
            case 'BGR':
                identificationType = IdentificationTypeConstant.BGR;
                break;
            default:
                identificationType = IdentificationTypeConstant.USA;
                break;
        }
        return identificationType;
    };
    FBOProfileComponent.prototype.openChangeGovtIDModal = function () {
        var _this = this;
        if (!this.memberGovernmentIdentifiations && !this.memberGovernmentIdentifiations.length && this.fboProfileDetail && this.fboProfileDetail.memberId) {
            this.getMembergovernmentIdentificationsInfo(this.fboProfileDetail.memberId);
        }
        var control = this.updateGovIDForm.controls['govermentIdentification'];
        for (var i = control.length - 1; i >= 0; i--) {
            control.removeAt(i);
        }
        if (this.memberGovernmentIdentifiations && this.memberGovernmentIdentifiations.length > 0) {
            var control_1 = this.updateGovIDForm.controls['govermentIdentification'];
            if (control_1 && control_1.length < 10) {
                var createIdentificationForm_1 = this.updateGovIDForm.get('govermentIdentification');
                this.memberGovernmentIdentifiations.forEach(function (item, index) {
                    createIdentificationForm_1.push(_this._formbuilder.group({
                        country: [_this.getMemberAllowedCountryCode(item.countryID), Validators.required],
                        governmentIdType: [_this.getIdentificationModel(item.governmentIdentificationType, item.countryID), Validators.required],
                        governmentIdValue: [item.value],
                        id: [item.id]
                    }));
                });
            }
        }
        else {
            this.addNewGovermentIdGroup();
        }
        this.governmentIdValueEditIndexes = [];
        this.changeGovtIDPopup.open();
        setTimeout(function () {
            if (document.getElementById('ssn-input')) {
                document.getElementById('ssn-input').focus();
            }
        }, 200);
    };
    FBOProfileComponent.prototype.getMemberAllowedCountryCode = function (countryId) {
        if (countryId) {
            var selectedCountry = this.countries.find(function (country) { return country.countryId === countryId; });
            return selectedCountry.isocodeThree;
        }
    };
    FBOProfileComponent.prototype.getIdentificationModel = function (governmentIdentificationType, countryID) {
        var identificationsByCountry;
        if (governmentIdentificationType && countryID) {
            identificationsByCountry = this.governmentIdentificationTypes.find(function (x) { return x.countryID === countryID && x.identificationType === governmentIdentificationType; });
        }
        return identificationsByCountry;
    };
    FBOProfileComponent.prototype.addNewGovermentIdGroup = function () {
        var control = this.updateGovIDForm.controls['govermentIdentification'];
        if (control && control.length < 10) {
            var createIdentificationForm = this.updateGovIDForm.get('govermentIdentification');
            createIdentificationForm.push(this._formbuilder.group({
                country: ['', Validators.required],
                governmentIdType: ['', Validators.required],
                governmentIdValue: ['', Validators.required],
                id: ['']
            }));
        }
    };
    FBOProfileComponent.prototype.countryChangeForGovermentId = function (countryCode, index, isCountryChange) {
        var governmentIdentificationForm = this.updateGovIDForm.get('govermentIdentification');
        governmentIdentificationForm.controls[index].controls['governmentIdType'].setValue('');
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValue('');
        governmentIdentificationForm.controls[index].controls['governmentIdType'].updateValueAndValidity();
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
    };
    FBOProfileComponent.prototype.deleteGovernmentID = function (index, id) {
        var governmentIdentificationForm = this.updateGovIDForm.get('govermentIdentification');
        if (governmentIdentificationForm.controls[index].controls['country'].value || governmentIdentificationForm.controls[index].controls['governmentIdValue'].value || governmentIdentificationForm.controls[index].controls['governmentIdType'].value) {
            this.govIdRemoveConfirmationPopup.open(index, id);
        }
        else {
            this.deleteGovernmentIDGroup(index, id);
        }
    };
    FBOProfileComponent.prototype.editGovernmentID = function (index, id) {
        this.isEditGovId = true;
        if (id) {
            this.governmentIdValueEditIndexes.push(id);
        }
        var governmentIdentificationForm = this.updateGovIDForm.get('govermentIdentification');
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValue('');
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
        var isValidationsSet = false;
        if (governmentIdentificationForm.countryID && governmentIdentificationForm.governmentIdentificationType) {
            var pattern = this.getIdentificationPattern(this.getMemberAllowedCountryCode(governmentIdentificationForm.countryID), governmentIdentificationForm.governmentIdentificationType);
            if (pattern) {
                governmentIdentificationForm.controls[index].controls['governmentIdValue']
                    .setValidators(this.getValidators(pattern), false);
                governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
                isValidationsSet = true;
            }
        }
        if (!isValidationsSet) {
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValidators([Validators.required]);
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
        }
        this.setValidationsToGovernmentId(index, governmentIdentificationForm.controls[index].controls['country'].value, governmentIdentificationForm.controls[index].controls['governmentIdType'].value);
    };
    FBOProfileComponent.prototype.closeDeleteGovernmentIDGroupPopup = function () {
        this.duplicateGovIdErrorMessage = null;
        this.govIdRemoveConfirmationPopup.close();
    };
    FBOProfileComponent.prototype.deleteGovernmentIDGroup = function (index, id) {
        var _this = this;
        if (this.fboProfileDetail && this.memberGovernmentIdentifiations && this.memberGovernmentIdentifiations.length && this.fboProfileDetail.homeCountryId) {
            if (this.memberGovernmentIdentifiations.find(function (x) { return x.id == id && x.countryID == _this.fboProfileDetail.homeCountryId &&
                (x.governmentIdentificationType).toUpperCase() === 'VAT ID'; })) {
                this.deleteHomeCountryVat = true;
            }
        }
        this.duplicateGovIdErrorMessage = null;
        this.govIdRemoveConfirmationPopup.close();
        // const control = <FormArray>this.updateGovIDForm.controls['govermentIdentification'];
        var control = this.updateGovIDForm.get('govermentIdentification');
        control.removeAt(index);
        var position = this.governmentIdValueEditIndexes.indexOf(id);
        if (position != -1) {
            this.governmentIdValueEditIndexes.splice(position, 1);
        }
        this.updateGovIDForm.markAsDirty();
    };
    FBOProfileComponent.prototype.getGovermentIdentificationPatterns = function () {
        var _this = this;
        this._commonService.getGovermentIdentificationPatterns().subscribe(function (response) {
            _this.govermentIdentificationPattern = response;
        });
    };
    FBOProfileComponent.prototype.addGovernmentIdsList = function (governmentIdForm, isValid) {
        this.vatIdBWP = true;
        this.businessEntityBWP = false;
        this.checkBondedWarehouseProject(governmentIdForm, isValid);
    };
    FBOProfileComponent.prototype.checkGovernmentIdValue = function (governmentIdForm, isValid) {
        var _this = this;
        if (governmentIdForm && isValid) {
            this.governmentIdValidationInProgress = true;
            governmentIdForm.govermentIdentification.forEach(function (item) {
                if (_this.fboProfileDetail && _this.memberGovernmentIdentifiations && _this.memberGovernmentIdentifiations.length && _this.fboProfileDetail.homeCountryId) {
                    if (item.governmentIdType && item.governmentIdType.identificationType && item.governmentIdType.countryID &&
                        item.governmentIdType.identificationType === GovernmentIdentificationType.VAT_ID && item.governmentIdType.countryID == _this.fboProfileDetail.homeCountryId) {
                        _this.memberGovernmentIdentifiations.forEach(function (x) {
                            if (x.governmentIdentificationType && x.countryID && item.governmentIdValue &&
                                x.governmentIdentificationType === GovernmentIdentificationType.VAT_ID && x.countryID == _this.fboProfileDetail.homeCountryId) {
                                if (x.value) {
                                    _this.updateHomeCountryVat = item.governmentIdValue !== x.value;
                                }
                                else {
                                    _this.updateHomeCountryVat = true;
                                }
                            }
                        });
                        var memberGovernmentIdentifiations = _this.memberGovernmentIdentifiations.filter(function (x) { return x.governmentIdentificationType === GovernmentIdentificationType.VAT_ID && x.countryID == _this.fboProfileDetail.homeCountryId; });
                        if (!memberGovernmentIdentifiations.length && !_this.updateHomeCountryVat) {
                            _this.updateHomeCountryVat = true;
                        }
                    }
                    else if (item.governmentIdType.identificationType != GovernmentIdentificationType.VAT_ID && item.governmentIdType.countryID == _this.fboProfileDetail.homeCountryId) {
                        _this.memberGovernmentIdentifiations.forEach(function (x) {
                            if (x.governmentIdentificationType === GovernmentIdentificationType.VAT_ID && x.governmentIdentificationType != item.governmentIdType.identificationType && x.countryID == _this.fboProfileDetail.homeCountryId) {
                                _this.deleteHomeCountryVat = true;
                            }
                        });
                    }
                }
                else if (!_this.memberGovernmentIdentifiations.length && item.governmentIdType.identificationType === GovernmentIdentificationType.VAT_ID
                    && item.governmentIdType.countryID == _this.fboProfileDetail.homeCountryId) {
                    _this.updateHomeCountryVat = true;
                }
            });
            var governmentIdTypes = this.prepareMemberGovernmentIdRequest(governmentIdForm);
            this._enrollService.updateMemberGovernmentIdentifications(this.fboProfileDetail.memberId, governmentIdTypes, this.deleteHomeCountryVat).subscribe(function (response) {
                if (response) {
                    _this.updateActivityLogForGovernmentIdentifications(governmentIdForm, _this.memberGovernmentIdentifiations, _this.fboProfileDetail.memberId);
                    // this.getFBOProfileInfoFromTitan(false, true);
                    _this.getMembergovernmentIdentificationsInfo(_this.fboProfileDetail.memberId);
                    // const notification: any = this._translatePipe.get('customer-service.Government Identifications are updated Successfully');
                    _this._commonService.createNotification('', 'Government Identifications are updated Successfully', NotificationType.SUCCESS);
                    _this.isUpdateButtonClicked = false;
                    _this.governmentIdValidationInProgress = false;
                    if (governmentIdForm.govermentIdentification.find(function (el) { return el && el.governmentIdType.countryID === _this.homeCountryId; })) {
                        _this.bondedWarehouseProjectSelected = false;
                        _this.bwpDisableMessage = false;
                        _this.submitBondedWarehouseProject();
                    }
                    _this.closeGovtIDPopUp();
                }
            });
        }
    };
    FBOProfileComponent.prototype.prepareMemberGovernmentIdRequest = function (governmentIdForm) {
        var _this = this;
        var governmentIdTypes = [];
        governmentIdForm.govermentIdentification.forEach(function (item) {
            governmentIdTypes.push({
                id: item.id ? item.id : null,
                governmentIDType: item.governmentIdType && item.governmentIdType.identificationTypeID ? item.governmentIdType.identificationTypeID : null,
                countryID: item.governmentIdType && item.governmentIdType.countryID ? item.governmentIdType.countryID : null,
                value: item.governmentIdValue ? item.governmentIdValue : null,
                identificationType: item.governmentIdType && item.governmentIdType.identificationTypeID ? item.governmentIdType.identificationType : null,
                changedValueType: ((item.governmentIdType.identificationType === GovernmentIdentificationType.VAT_ID) &&
                    (item.governmentIdType && item.governmentIdType.countryID && (item.governmentIdType.countryID == _this.fboProfileDetail.homeCountryId)) &&
                    (_this.updateHomeCountryVat)) ? [FBOProfileUpdateEnum.MEMBER_VATID_CHANGE] : null
            });
        });
        return governmentIdTypes;
    };
    FBOProfileComponent.prototype.updateButtonClicked = function () {
        this.isUpdateButtonClicked = true;
    };
    FBOProfileComponent.prototype.cancelButtonClicked = function () {
        this.isCancelButtonClicked = true;
    };
    FBOProfileComponent.prototype.checkUniqueGovIDValue = function (govIdForm, index) {
        var _this = this;
        var governmentIdentificationForm = this.updateGovIDForm.get('govermentIdentification');
        var country = governmentIdentificationForm.controls[index].controls['country'].value;
        var govIdValue = governmentIdentificationForm.controls[index].controls['governmentIdValue'].value;
        if (govIdValue) {
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValue(govIdValue.trim());
        }
        var govIdentificationType = governmentIdentificationForm.controls[index].controls['governmentIdType'].value;
        var idValue = governmentIdentificationForm.controls[index].controls['id'].value;
        var isDuplicateGovId = false;
        var isValidBsn = true;
        if (!this.isCancelButtonClicked) {
            if (country && govIdValue && governmentIdentificationForm.controls[index].valid) {
                this.governmentIdValidationInProgress = true;
                var storeInformation_1 = null;
                this._configurationService.getStoreByCountry(country).subscribe(function (data) {
                    _this.governmentIdValidationInProgress = false;
                    storeInformation_1 = data;
                    var storeId = null;
                    if (storeInformation_1 && storeInformation_1.id) {
                        storeId = storeInformation_1.id;
                    }
                    _this.governmentIdValidationInProgress = true;
                    if (_this.appConfig.isBSNEnabled && govIdentificationType.identificationType === GovernmentIdentificationType.BSN) {
                        _this._customerService.validateBSNumber(country, govIdValue)
                            .subscribe(function (response) {
                            _this.governmentIdValidationInProgress = false;
                            if (response && response.valid) {
                                isValidBsn = true;
                                var position = _this.governmentIdValueEditIndexes.indexOf(idValue);
                                if (position !== -1) {
                                    _this.governmentIdValueEditIndexes.splice(position, 1);
                                }
                            }
                            else {
                                isValidBsn = false;
                                governmentIdentificationForm.controls[index].controls['governmentIdValue']
                                    .setErrors({ inValidBsn: 'Invalid BSN' });
                            }
                            if (_this.isUpdateButtonClicked) {
                                _this.addGovernmentIdsList(govIdForm.value, govIdForm.valid);
                            }
                        }, function (error) {
                            _this.governmentIdValidationInProgress = false;
                        });
                    }
                    else {
                        _this._customerService.validateGovernmentID(storeId, govIdValue, country, _this.fboProfileDetail.memberId, govIdentificationType.identificationType)
                            .subscribe(function (response) {
                            _this.governmentIdValidationInProgress = false;
                            if (response && response.success) {
                                isDuplicateGovId = true;
                                // already exist
                            }
                            else {
                                isDuplicateGovId = true;
                                // already exist
                            }
                            var personalInfoSettings = _this._personalInfoConfigService.getSettings(country);
                            if (isDuplicateGovId) {
                                governmentIdentificationForm.controls[index].controls['governmentIdValue'].setErrors({ duplicateGovId: personalInfoSettings && personalInfoSettings.personalIDValidationMgs && govIdentificationType.identificationType.toLowerCase() === GovernmentIdentificationType.PERSONAL_ID.toLowerCase() ? "Invalid PESEL Number" : 'Government Id Already Exists' });
                            }
                        }, function (error) {
                            _this.governmentIdValidationInProgress = false;
                            var response = error;
                            if (response && response.validations && !response.statusCode
                                && response.validations.length > 0) {
                            }
                            // id not exist
                            isDuplicateGovId = false;
                            var position = _this.governmentIdValueEditIndexes.indexOf(idValue);
                            if (position != -1) {
                                _this.governmentIdValueEditIndexes.splice(position, 1);
                            }
                            if (_this.isUpdateButtonClicked) {
                                _this.addGovernmentIdsList(govIdForm.value, govIdForm.valid);
                            }
                        });
                    }
                }, function (error) {
                    _this.governmentIdValidationInProgress = false;
                });
            }
        }
    };
    FBOProfileComponent.prototype.changeGovIdToUppercase = function (index) {
        var governmentIdentificationForm = this.updateGovIDForm.get('govermentIdentification');
        if (governmentIdentificationForm.controls[index].controls['governmentIdValue'].value) {
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValue(governmentIdentificationForm.controls[index].controls['governmentIdValue'].value.toUpperCase());
        }
    };
    FBOProfileComponent.prototype.setValidationsToGovernmentId = function (index, countryCode, governmentIdentificationType, isDuplicateGovId, clearValue) {
        if (isDuplicateGovId === void 0) { isDuplicateGovId = false; }
        if (clearValue === void 0) { clearValue = true; }
        var governmentIdentificationForm = this.updateGovIDForm.get('govermentIdentification');
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].clearValidators();
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValidators([Validators.required]);
        if (clearValue) {
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValue('');
        }
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
        if (countryCode && governmentIdentificationType.identificationTypeID > 0 && index >= 0 && this.govermentIdentificationPattern.length > 0) {
            var selectedIdentificationType = governmentIdentificationType.identificationType;
            var countryIdentificationPattern = this.getIdentificationPattern(countryCode, selectedIdentificationType);
            if (countryIdentificationPattern) {
                this.setIdentificationValueValidators(governmentIdentificationForm, countryIdentificationPattern, index, isDuplicateGovId);
            }
        }
    };
    FBOProfileComponent.prototype.getIdentificationPattern = function (countryCode, identificationType) {
        if (countryCode && identificationType) {
            var pattern = this.govermentIdentificationPattern.find(function (identification) { return identification.countryCode.toLowerCase() === countryCode.toLowerCase() && identification.identificationType.toLowerCase() === identificationType.toLowerCase(); });
            return pattern;
        }
        else {
            return null;
        }
    };
    FBOProfileComponent.prototype.setIdentificationValueValidators = function (governmentIdentificationForm, identificationPattern, index, isDuplicateGovId) {
        if (isDuplicateGovId === void 0) { isDuplicateGovId = false; }
        if (identificationPattern) {
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValidators(this.getValidators(identificationPattern), isDuplicateGovId);
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
        }
    };
    FBOProfileComponent.prototype.getValidators = function (identificationPattern, isDuplicateGovId) {
        if (isDuplicateGovId === void 0) { isDuplicateGovId = false; }
        var validators = [];
        validators.push(Validators.required);
        if (identificationPattern.pattern) {
            validators.push(Validators.pattern(identificationPattern.pattern));
        }
        if (identificationPattern.minLength) {
            validators.push(Validators.minLength(identificationPattern.minLength));
        }
        if (identificationPattern.maxLength) {
            validators.push(Validators.maxLength(identificationPattern.maxLength));
        }
        if (isDuplicateGovId) {
            validators.push(DuplicateGovernmentIdValidator.duplicateGovId(isDuplicateGovId));
        }
        return validators;
    };
    FBOProfileComponent.prototype.getBusinessEntityValidators = function (fieldName) {
        var validators = [];
        switch (fieldName) {
            case 'businessEntityId':
                validators.push(Validators.minLength(5), Validators.maxLength(50), Utils.alphaNumericIphenCharacterValidation);
                if (this.appConfig && (!this.appConfig.businessEntityConfig || !this.appConfig.businessEntityConfig.businessEntityIDOptional)) {
                    validators.push(Validators.required);
                }
                break;
        }
        return validators;
    };
    FBOProfileComponent.prototype.duplicateGovIdType = function ($event) {
        if ($event) {
            this.duplicateGovIdErrorMessage = $event;
            setTimeout(function () {
                this.duplicateGovIdErrorMessage = null;
            }, 5000);
        }
        else {
            this.duplicateGovIdErrorMessage = null;
        }
    };
    FBOProfileComponent.prototype.getGovIdMask = function (index) {
        var governmentIdentificationForm = this.updateGovIDForm.get('govermentIdentification');
        var country = governmentIdentificationForm.controls[index].controls['country'].value;
        var identificationType = governmentIdentificationForm.controls[index].controls['governmentIdType'].value.identificationType;
        var govIdMask = this.getIdentificationPattern(country, identificationType);
        if (govIdMask && govIdMask.maskFormat) {
            return govIdMask.maskFormat;
        }
        else {
            return '';
        }
    };
    FBOProfileComponent.prototype.getGovIdMaxLength = function (index) {
        var governmentIdentificationForm = this.updateGovIDForm.get('govermentIdentification');
        var country = governmentIdentificationForm.controls[index].controls['country'].value;
        var identificationType = governmentIdentificationForm.controls[index].controls['governmentIdType'].value.identificationType;
        var govIdpattern = this.getIdentificationPattern(country, identificationType);
        if (govIdpattern && govIdpattern.maxLength) {
            return govIdpattern.maxLength;
        }
        else {
            return '';
        }
    };
    FBOProfileComponent.prototype.getMaskedValue = function (value) {
        return 'XXX-XX-' + value.substr(-4);
    };
    FBOProfileComponent.prototype.updateActivityLogForGovernmentIdentifications = function (governmentIdForm, memberGovernmentIdentifiations, memberid) {
        var _this = this;
        var activityLogKeys = [];
        memberGovernmentIdentifiations.filter(function (x) { return x.id; });
        governmentIdForm.govermentIdentification.forEach(function (item) {
            if (!item.id) {
                var activityvalue = ' for ' + _this.getMemberAllowedCountryName(item.governmentIdType.countryID) + ' ' + item.governmentIdType.identificationType + ' is created to ' + _this.getMaskedValue(item.governmentIdValue);
                activityLogKeys.push({
                    key: MemberActivityLogType.GovernmentID_Created,
                    value: activityvalue
                });
            }
            if (item.id) {
                var memberidentity = memberGovernmentIdentifiations.find(function (memberidentity) { return memberidentity.id === item.id; });
                if (memberidentity && memberidentity.value != item.governmentIdValue) {
                    var activityvalue = ' for ' + _this.getMemberAllowedCountryName(memberidentity.countryID) + ' ' + memberidentity.governmentIdentificationType + ' is updated to ' + _this.getMaskedValue(item.governmentIdValue);
                    activityLogKeys.push({
                        key: MemberActivityLogType.GovernmentID_Updated,
                        value: activityvalue
                    });
                }
            }
        });
        var deletedGovernmentIdList = memberGovernmentIdentifiations.filter(function (elem) { return !governmentIdForm.govermentIdentification.find(function (_a) {
            var id = _a.id;
            return elem.id === id;
        }); });
        deletedGovernmentIdList.forEach(function (deletedGovernmentId) {
            var activityvalue = ' for ' + _this.getMemberAllowedCountryName(deletedGovernmentId.countryID) + ' ' + deletedGovernmentId.governmentIdentificationType + ' is removed to ' + _this.getMaskedValue(deletedGovernmentId.value);
            activityLogKeys.push({
                key: MemberActivityLogType.GovernmentID_Deleted,
                value: activityvalue
            });
        });
        if (activityLogKeys && activityLogKeys.length) {
            this._commonService.saveMemberActivity(memberid, activityLogKeys)
                .subscribe(function (res) { }, function (error) { });
        }
    };
    FBOProfileComponent.prototype.getMemberAllowedCountryName = function (countryId) {
        if (countryId) {
            var selectedCountry = this.countries.find(function (country) { return country.countryId === countryId; });
            return selectedCountry.name;
        }
    };
    /**
     * on change of Ach
     */
    FBOProfileComponent.prototype.openPayByCheckAccountModal = function (achDetails, isNewAch) {
        if (isNewAch) {
            this.isEditEcheck = false;
            this.editEcheckInfo = null;
            this.addNewAchCard = true;
            this.achPaymentPopup.open();
        }
    };
    /**
     * @description submit ach payment information
     * @memberof ACHComponent
   */
    FBOProfileComponent.prototype.closeAchPaymentPopup = function (achPaymentInfo) {
        if (achPaymentInfo) {
            this.achPaymentInfo = achPaymentInfo;
            this.achToken = this.achPaymentInfo.personalCheckId;
            this.achPaymentPopup.close();
            this.getMemberPaymentDetails(this.achPaymentInfo.customerId);
        }
    };
    FBOProfileComponent.prototype.onPaymentAchFormClose = function () {
        this.addNewAchCard = false;
        this.achPaymentPopup.close();
    };
    FBOProfileComponent.prototype.enableAuthFormReceiving = function (form, id) {
        var _this = this;
        if (this.distributorDefaultECheckPaymentInfo && this.distributorDefaultECheckPaymentInfo.length) {
            this.distributorDefaultECheckPaymentInfo.forEach(function (item) {
                if (item && item.id === id) {
                    _this._customerService.verifyPersonalCheck(item.customerId, item.id, form)
                        .subscribe(function (response) {
                        if (response) {
                        }
                    }, function (error) { });
                }
            });
        }
    };
    FBOProfileComponent.prototype.fetchEcheckSecTypes = function (secType) {
        if (secType === 'WEB') {
            return 'WEB ACH';
        }
        else {
            return 'PPD ACH';
        }
    };
    /**
     * check agent allowed to change sponsor
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.getChangeSponsorPermission = function () {
        var _this = this;
        if (this.changeGeneralSponsorPermission) {
            this.isAgentAllowedToChangeSponsor = false;
            if (!this.userInfo.hasSystemRole) {
                if (this.userInfo.allowedOperatingCountries) {
                    this._customerservice.getOperatingCountries().subscribe(function (response) {
                        if (response) {
                            var countryIds_2 = _this.userInfo.allowedOperatingCountries.split(',');
                            var countries = response.filter(function (item) {
                                return countryIds_2.indexOf(item.id.toString()) > -1;
                            });
                            for (var i = 0; i < countries.length; i++) {
                                if (countries[i].value === _this.fboProfileDetail.operatingCountryCode) {
                                    _this.isAgentAllowedToChangeSponsor = true;
                                    break;
                                }
                            }
                        }
                    });
                }
                else {
                    this.isAgentAllowedToChangeSponsor = false;
                }
            }
            else {
                this.isAgentAllowedToChangeSponsor = true;
            }
        }
    };
    /**
     * get sponsor detail by memberID
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.getSponsorDetails = function (memberId) {
        var _this = this;
        this.sponsorDetails = [];
        this._sponsorService.getSponsorDetailsByMemberID(memberId).subscribe(function (response) {
            if (response && response.length) {
                for (var _a = 0, response_1 = response; _a < response_1.length; _a++) {
                    var sponsor = response_1[_a];
                    sponsor.storeCountryName = _this.mapSponsorCountry(sponsor.storeCountryCode);
                }
                _this.sponsorDetails = response;
            }
        }, function (error) {
            // No Sponsor message
        });
    };
    /**
     * Map sponsor country name based on country code
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.mapSponsorCountry = function (countryCode) {
        if (this.countries) {
            var countryInfo = this.countries.find(function (country) { return country.isocodeThree && countryCode && country.isocodeThree.toLowerCase() === countryCode.toLowerCase(); });
            return countryInfo ? countryInfo.name : countryCode;
        }
        return countryCode;
    };
    /**
     * map list of countries to string
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.mapChangeSponsorCountries = function () {
        if (this.sponsorDetails && this.sponsorDetails.length) {
            var sponsorChangeCountryInfo = this.sponsorDetails.map(function (sponsor) { return sponsor.storeCountryName; });
            return sponsorChangeCountryInfo.join(', ');
        }
    };
    /**
     * on submit sponsor change
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.onSubmitSponsorChange = function (isValidForm) {
        var _this = this;
        this.errorCodes = [];
        if (isValidForm) {
            if (this.changeSponsorForm && this.changeSponsorForm.controls['sponsorType'].value === SponsorType.General_Sponsor_Change) {
                var sponsorSearchRequest = this.prepareSponsorSearchRequest();
                this._sponsorService.searchSponsors(sponsorSearchRequest).subscribe(function (sponsorSearchResponse) {
                    if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
                        _this.memberSponsorUpdate(sponsorSearchResponse);
                    }
                    else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
                        sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                        setTimeout(function () {
                            _this.searchSponsorByPolling(sponsorSearchResponse, SponsorSearchOption.SearchByIKnowSponsor);
                        }, 2000);
                    }
                    else {
                        _this.sponsorChangeError = true;
                    }
                }, function (error) {
                    if (error.validations && error.validations.length > 0 && error.validations[0].message === 'FBO not found') {
                        _this.sponsorNotFoundError = true;
                    }
                    else {
                        _this.sponsorChangeError = true;
                    }
                });
            }
        }
    };
    /**
     * Update member sponsor
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.memberSponsorUpdate = function (sponsorSearchResponse) {
        var _this = this;
        var sponsorChangeRequest = this.prepareSponsorChangeRequest(sponsorSearchResponse);
        if (sponsorChangeRequest) {
            this._customerService.updateMemberSponsor(sponsorChangeRequest).subscribe(function (response) {
                if (response.success) {
                    _this.saveSponsorChangeActivityLog();
                    _this.newSponsor = sponsorSearchResponse.sponsorSearchResultModels[0];
                    _this.sponsorChangeSuccess = true;
                    _this.getFBOProfileInfoFromTitan();
                }
                else {
                    _this.sponsorChangeError = true;
                }
            }, function (error) {
                _this.sponsorChangeError = true;
            });
        }
    };
    /**
     * Search sponsor by UUID
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.searchSponsorByPolling = function (searchResponse, searchOption) {
        var _this = this;
        this.clearSponsorErrorMsg();
        this._sponsorService.getSearchSponsorsByUUID(searchResponse).subscribe(function (sponsorSearchResponse) {
            if (sponsorSearchResponse) {
                if (_this.sponsorPollCount < _this.sponsorMaxPollCount) {
                    _this.sponsorPollCount = _this.sponsorPollCount + 1;
                    if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
                        _this.memberSponsorUpdate(sponsorSearchResponse);
                    }
                    else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED || sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                        setTimeout(function () {
                            _this.searchSponsorByPolling(sponsorSearchResponse, searchOption);
                        }, 2000);
                    }
                    else {
                        _this.sponsorChangeError = true;
                    }
                }
                else {
                    _this.sponsorChangeError = true;
                }
            }
        }, function (error) {
            if (error.validations && error.validations.length > 0 && error.validations[0].message === 'FBO not found') {
                _this.sponsorNotFoundError = true;
            }
            else {
                _this.sponsorChangeError = true;
            }
        });
    };
    /**
     * Prepare sponsor change search request
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.prepareSponsorSearchRequest = function () {
        return {
            UserName: this.changeSponsorForm.controls['newSponsorId'].value.trim(),
            Email: '',
            FirstName: '',
            LastName: '',
            CountryId: '',
            PreferenceValue: '',
            PostalCode: '',
            StateId: '',
            City: '',
            Option: SponsorSearchOption.SearchByIKnowSponsor,
            EnableLongPoll: environment.enableLongPoll,
            Store: this.fboProfileDetail.homeCountryCode
        };
    };
    /**
     * prepare sponsor change request object
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.prepareSponsorChangeRequest = function (sponsorSearchResponse) {
        if (sponsorSearchResponse.sponsorSearchResultModels && sponsorSearchResponse.sponsorSearchResultModels.length > 0) {
            return {
                memberHomeCountry: this.fboProfileDetail.homeCountryCode,
                changeSponsorType: SponsorChangeType.GENERALSPONSOR,
                language: this.fboProfileDetail.preferredLanguage,
                email: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorEmail,
                contactPhone: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorPhone,
                sponsorId: this.changeSponsorForm.controls['newSponsorId'].value,
                distributorId: this.fboProfileDetail.distributorId,
                memberId: this.fboProfileDetail.id,
                sponsorName: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorName,
                updatedBy: this.userInfo.userId,
                addressLine1: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorAddressLine1,
                addressLine2: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorAddressLine2,
                city: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorCity,
                stateId: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorStateId,
                countryId: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorCountryId,
                postalCode: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorPostalCode,
                uuid: sponsorSearchResponse.uuid
            };
        }
        return null;
    };
    /**
     * save sponsor change member activity
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.saveSponsorChangeActivityLog = function () {
        var activityLogKeys = [];
        activityLogKeys.push({
            key: MemberActivityLogType.Sponsor_Update,
            value: this.fboProfileDetail.sponsorDetails.fboId + ' to ' + this.changeSponsorForm.controls['newSponsorId'].value
        });
        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
    };
    /**
     * Method to close sponsor change popup
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.closeSponsorPopUp = function () {
        this.sponsorDetails = [];
        this.changeSponsorPopup.close();
        this.clearSponsorErrorMsg();
    };
    /**
     * Method to clear change sponsor properties
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.clearSponsorErrorMsg = function () {
        this.sponsorChangeSuccess = false;
        this.sponsorChangeError = false;
        this.sponsorNotFoundError = false;
    };
    /**
     * Scroll the popup to Top on Open Compose Email popup
     */
    FBOProfileComponent.prototype.onComposeEmailPopupOpen = function () {
        setTimeout(function () {
            var modalElement = document.getElementsByClassName('draft-email__modal modalwidth');
            if (modalElement && modalElement.length > 0) {
                var childModalElement = modalElement[0].getElementsByClassName('modal in fade');
                if (childModalElement && childModalElement.length > 0) {
                    childModalElement[0].scrollTop = 0;
                }
            }
        }, 0);
    };
    /**
     * To Close Email Popup
     */
    FBOProfileComponent.prototype.closeComposeEmailPopup = function () {
        this.composeEmailPopup.close();
        this.composeEmailForm = null;
    };
    /**
     * To Set default value when open email popup
     */
    FBOProfileComponent.prototype.showComposeEmailPopup = function () {
        var operatingCountryCode = IsoCodeThree.USA;
        if (operatingCountryCode && this.emailSignatureResponse && this.emailSignatureResponse.length > 0) {
            this.signatureValue = this._customerService.getSignatureValue(operatingCountryCode, this.emailSignatureResponse);
        }
        this.composeEmailPopup.closeOnOutsideClick = true;
        this.composeEmailPopup.closeOnEscape = false;
        this.showErrorMsg = false;
        this.showEmailErrorMessage = false;
        this.showMaxFileSizeValidation = false;
        this.getTicketStatuses();
        this.createComposeEmailForm();
        this.getOperatingCountries();
        this.composeEmailPopup.open();
    };
    /**
     * To Close Email Popup
     */
    FBOProfileComponent.prototype.onComposeEmailPopupClose = function () {
        this.composeEmailForm = null;
    };
    /**
     * To Get Allowed Countries
     */
    FBOProfileComponent.prototype.getAllowedCountries = function () {
        var countryIds = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(",");
                if (this.userInfo.privileges.departments) {
                    countryIds.push.apply(countryIds, this.userInfo.privileges.departments.map(function (a) { return a.allowedOperatingCountries; }));
                }
                countryIds = countryIds ? countryIds : [];
                if (countryIds.length > 0) {
                    var ids = countryIds;
                    this.operatingCountries = this.businessEntities.filter(function (item) {
                        return ids.indexOf(item.id + "") != -1;
                    });
                }
            }
            else {
                this.operatingCountries = this.businessEntities;
            }
        }
        else {
            this.operatingCountries = this.businessEntities;
        }
        this.operatingCountries.sort(function (item1, item2) {
            var country1 = item1.name.toLowerCase(), country2 = item2.name.toLowerCase();
            if (country1 < country2) {
                return -1;
            }
            if (country1 > country2) {
                return 1;
            }
            return 0;
        });
        var usaInfo = this.operatingCountries.find(function (country) { return country.id === OperatingCountryEnums.USA; });
        if (usaInfo) {
            this.operatingCountries.splice(this.countries.indexOf(usaInfo), 1);
            this.operatingCountries.splice(0, 0, usaInfo);
        }
        this.composeEmailForm.controls['operatingCountry'].setValue(this.operatingCountries[0].id);
        this.getDepartmentDetails(this.operatingCountries[0].id);
        this.getTicketTypesAndSubTypes();
    };
    /**
     * To Get Allowed Operating Countries
     */
    FBOProfileComponent.prototype.getOperatingCountries = function () {
        var _this = this;
        this._customerservice.getAllBusinessEntities().subscribe(function (response) {
            if (response) {
                _this.businessEntities = response;
                _this.getAllowedCountries();
            }
        });
    };
    /**
     * On Tags Change
     */
    FBOProfileComponent.prototype.onTagsChange = function (value) {
        if (value && !this.composeEmailForm.controls['toAddress'].value.length) {
            this.showToAddressValidation = false;
        }
        else {
            this.showToAddressValidation = true;
        }
    };
    /**
     * To Change From Address And Update Email Id Dynamically
     */
    FBOProfileComponent.prototype.changeFromAddress = function (mailId) {
        var departmentInfo = mailId && this.departments && this.departments.length > 0
            ? this.departments.find(function (department) { return department.id === +mailId; }) : null;
        if (departmentInfo) {
            this.changeSignatureByOperatingCountry(departmentInfo.operatingCountryId, departmentInfo.name.toLowerCase().includes(Department.SMILE_TEAM_360.toLowerCase()));
        }
        var emailId = departmentInfo && this.departments && this.departments.length > 0
            ? departmentInfo.email : mailId;
        var editorElement = document.querySelector('#ckeditor-js .ck-editor__editable');
        var editordata = editorElement.ckeditorInstance.getData();
        var emailElement = editorElement.querySelector('#emailId');
        if (emailId) {
            if (emailElement) {
                emailElement.innerHTML = emailId;
                editorElement.ckeditorInstance.setData(editorElement.innerHTML);
                this.composeEmailForm.controls['body'].setValue(editorElement.innerHTML);
            }
            else {
                var siteElement = editorElement.lastElementChild;
                if (siteElement.innerHTML.indexOf(CommonConstant.EmailSignature) > -1) {
                    var content = siteElement.outerHTML;
                    editordata = editordata.split(content).join('<p id="emailId">' + emailId + '</p>' + content);
                    editorElement.ckeditorInstance.setData(editorElement.innerHTML);
                }
                else {
                    editordata = editordata + '<p id="emailId">' + emailId + '</p>';
                    editorElement.ckeditorInstance.setData(editordata);
                }
                this.composeEmailForm.controls['body'].setValue(editorElement.innerHTML);
            }
        }
    };
    /**
     * To Create Compose Email Form
     */
    FBOProfileComponent.prototype.createComposeEmailForm = function () {
        this.prepareEmailBodyContent();
        this.uploader.queue = [];
        this.composeEmailForm = this._formbuilder.group({
            operatingCountry: ['', Validators.required],
            fromAddress: ['', [Validators.required]],
            toAddress: [[], [Validators.required]],
            subject: ['', [Validators.required, Validators.maxLength(this.subjectMaxLength.maxLength)]],
            ccAddress: [[]],
            bccAddress: [[]],
            statusId: [Status.Closed, Validators.required],
            ticketType: ['', Validators.required],
            subType: ['', Validators.required],
            assignedToMyself: [],
            body: [this.bodyStr]
        });
        if (this.fboProfileDetail && (this.fboProfileDetail.emailId || this.fboProfileDetail.email)) {
            this.composeEmailForm.controls['toAddress'].setValue([{
                    display: this.fboProfileDetail.emailId ? this.fboProfileDetail.emailId : this.fboProfileDetail.email,
                    value: this.fboProfileDetail.emailId ? this.fboProfileDetail.emailId : this.fboProfileDetail.email
                }]);
        }
        this.composeEmailForm.controls['subject'].markAsTouched();
    };
    /**
     * get ticket status for populating to dropdown
     */
    FBOProfileComponent.prototype.getTicketStatuses = function () {
        var _this = this;
        this._customerservice.getTicketStatus().subscribe(function (response) {
            if (response && response.length > 0) {
                _this.statuses = sortBy(response, 'value');
            }
            else {
                _this.statuses = [];
            }
        });
    };
    /**
     * To prepare email body content for compose email
     */
    FBOProfileComponent.prototype.prepareEmailBodyContent = function () {
        var fboDetails = '';
        if (this.fboProfileDetail) {
            var fboId = this.distributorFormatPipe
                .transform((this.fboProfileDetail.distributorId ?
                this.fboProfileDetail.distributorId : this.fboProfileDetail.fboId));
            fboId = (this.fboProfileDetail.memberType !== MemberType.GUEST ? (' | ' + fboId) : ' ');
            fboDetails = (this.fboProfileDetail.firstName + ' ') + (this.fboProfileDetail.displayMiddleName && this.fboProfileDetail.middleName ?
                this.fboProfileDetail.middleName + ' ' : '') + this.fboProfileDetail.lastName;
            +fboId + (this.fboProfileDetail.memberType
                ? (' | ' + (this.fboProfileDetail.level ? this.fboProfileDetail.level : this.fboProfileDetail.memberType)) : '');
        }
        else {
            fboDetails = 'NA';
        }
        if (this.signatureValue && this.signatureValue.length > 0) {
            this.bodyStr = "<div>\n            <p></p>\n            </div> "
                + '<div class="emailbody"><strong>Member: </strong>'
                + fboDetails + '</div>'
                + '<div class="emailbody"><strong>Email: </strong>'
                + (this.fboProfileDetail && (this.fboProfileDetail.email || this.fboProfileDetail.emailId)
                    ? (this.fboProfileDetail.email ? this.fboProfileDetail.email : this.fboProfileDetail.emailId) : 'NA') + '</div>'
                + '<p></p>'
                + '<div id="emailsignature">' + this.signatureValue + '</div>';
            var styles = "<style>p,h1,h2,h3,h4{margin:0}</style>";
            if (this.bodyStr.includes(styles)) {
                this.bodyStr = this.bodyStr.replace(styles, '');
            }
            if (this.bodyStr.includes('<style>')) {
                this.bodyStr = this.bodyStr.replace(/<style>(.|\n)*?<\/style>/g, '');
            }
            else if (this.bodyStr.includes('&lt;!--') && this.bodyStr.includes('--&gt;')) {
                this.bodyStr = this.bodyStr.replace(/&lt;!--(.|\n)*?--&gt;/, '');
            }
            this.bodyStr = this.bodyStr.replace(/<div[^>]*style="display:none[^>]*>(.|\n)*?<\/div>/, '');
            this.bodyStr = this.bodyStr.replace(/<span[^>]*style="display:none[^>]*>(.*?)<\/span>/, '');
            if (this.bodyStr.includes("style=\"mso-margin-top-alt:auto;mso-margin-bottom-alt:auto\"")) {
                // tslint:disable-next-line:max-line-length
                this.bodyStr = this.bodyStr.replace(/<p[^>]*style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto[^>](.*?)>/, "<p></p><p>");
            }
        }
    };
    /**
     * To Validate the Attachments
     */
    FBOProfileComponent.prototype.validateMessageAttachments = function () {
        this.showMaxFileSizeValidation = false;
        if (this.uploader.queue) {
            var totalSize = 0;
            var messageAttachmentSize_1 = 0;
            this.uploader.queue.forEach(function (item) {
                messageAttachmentSize_1 = messageAttachmentSize_1 + item.file.size;
            });
            totalSize = +(messageAttachmentSize_1 / 1024 / 1024).toFixed(2);
            this.attachmentsLength = this.uploader.queue.length;
            if (totalSize > environment.draftEmailAttachmentsSize) {
                this.uploader.queue[this.uploader.queue.length - 1].remove();
                this.attachmentsLength--;
                this.showMaxFileSizeValidation = true;
            }
            if (this.attachmentsLength >= 5) {
                while (this.attachmentsLength > 5) {
                    this.uploader.queue[this.uploader.queue.length - 1].remove();
                    this.attachmentsLength--;
                }
            }
        }
    };
    /**
     * To Remove the attchments
     */
    FBOProfileComponent.prototype.removeSize = function () {
        this.validateMessageAttachments();
    };
    /**
     * To Get department Details
     */
    FBOProfileComponent.prototype.getDepartmentDetails = function (id) {
        var _this = this;
        var isSuperadmin = this.userInfo.hasSystemRole;
        var departmentIds = [];
        if (!isSuperadmin) {
            var departmentData = this.userInfo.privileges.departments;
            if (departmentData && departmentData.length > 0) {
                this.showErrorMsg = false;
                for (var i = 0; i < departmentData.length; i++) {
                    departmentIds.push(departmentData[i].id);
                }
            }
            else {
                this.showErrorMsg = true;
            }
        }
        if (isSuperadmin || (!isSuperadmin && departmentIds)) {
            this._departmentService.getDepartmentsdataByOperatingCountryId(id).subscribe(function (response) {
                if (response) {
                    _this.departments = response;
                    if (isSuperadmin) {
                        _this.departments = response.filter(function (item) { return item.email && item.whiteListed; });
                    }
                    else {
                        var data = [];
                        for (var i = 0; i < departmentIds.length; i++) {
                            for (var j = 0; j < _this.departments.length; j++) {
                                if (departmentIds[i] === _this.departments[j].id && _this.departments[j].email && _this.departments[j].whiteListed) {
                                    data.push(_this.departments[j]);
                                }
                            }
                        }
                        _this.departments = data;
                    }
                    _this.showErrorMsg = _this.departments && _this.departments.length > 0 ? false : true;
                }
            });
        }
    };
    /**
     * This method used to get users by search text
    */
    FBOProfileComponent.prototype.setOffsetPosition = function (positionTimeout) {
        clearTimeout(positionTimeout);
        positionTimeout = setTimeout(function () {
            var tagInput = document.querySelector('.copy_to__block .ng2-tag-input__text-input');
            var dropdownElement = document.querySelector('.copy_to__block .ng2-dropdown-menu');
            if (tagInput) {
                dropdownElement.style.left = (12 + tagInput.offsetLeft) + 'px';
            }
        }, 0);
    };
    /**
     * To Submit Email Form
     */
    FBOProfileComponent.prototype.onSubmit = function (isValid, formValue) {
        this.isSendingEmail = true;
        this.getCkeditorData(isValid, formValue);
    };
    /**
     * Will get the data from ckEditorInstance
     */
    FBOProfileComponent.prototype.getCkeditorData = function (isValid, formValue) {
        var editor = document.querySelector('#ckeditor-js .ck-editor__editable');
        this.uploadedImageLength = 0;
        this.uploadedImageUrlArr = [];
        if (editor) {
            var contentDiv = document.querySelector('#ckeditor-content');
            contentDiv.innerHTML = (editor.ckeditorInstance.getData());
            var elements = document.querySelectorAll('#ckeditor-content')[0].getElementsByClassName('image');
            if (elements && elements.length > 0) {
                for (var _a = 0, elements_1 = elements; _a < elements_1.length; _a++) {
                    var element = elements_1[_a];
                    if (element && element.nodeName === 'FIGURE') {
                        if (element && element.attributes && element.attributes.style && element.attributes.style.value) {
                            var width = element.attributes.style.value.replace('width:', '');
                            if (element.firstChild && element.firstChild.nodeName === 'IMG') {
                                element.firstChild.setAttribute('width', width);
                                element.removeAttribute('style');
                                if (element.firstChild.attributes.src.value.split(',')[0].indexOf('base64') >= 0) {
                                    this.dataURItoBlob(isValid, formValue, element);
                                    this.uploadedImageLength++;
                                }
                            }
                        }
                        else {
                            if (element && element.firstChild && element.firstChild.nodeName === 'IMG') {
                                if (element.firstChild.attributes.src.value.split(',')[0].indexOf('base64') >= 0) {
                                    this.dataURItoBlob(isValid, formValue, element);
                                    this.uploadedImageLength++;
                                }
                            }
                        }
                    }
                }
            }
            this.bodyStr = document.querySelector('#ckeditor-content').innerHTML;
            this.composeEmailForm.controls['body'].setValue(this.bodyStr);
        }
        if (this.uploadedImageLength === 0) {
            this.onSubmitComplete(isValid, formValue);
        }
    };
    /**
     * To Conversion
     */
    FBOProfileComponent.prototype.dataURItoBlob = function (isValid, formValue, element) {
        var _this = this;
        var byteString;
        var fileName = 'image_' + Date.now();
        var dataURI = element.firstChild.attributes.src.value;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = decodeURI(dataURI.split(',')[1]);
        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        var blob = new Blob([ia], { type: mimeString });
        var formData = new FormData(document.forms[0]);
        var file = new File([blob], fileName);
        formData.append("file", file);
        formData.append("fileName", fileName);
        formData.append("path", 'content/customer-service/' + this._id + '/images/');
        this._customerservice.uploadImageFile(formData)
            .subscribe(function (response) {
            if (response) {
                element.firstChild.attributes.src.value = response.signedUrl;
                _this.uploadedImageUrlArr.push(response.key);
                if (_this.uploadedImageLength === _this.uploadedImageUrlArr.length) {
                    _this.onSubmitComplete(isValid, formValue);
                }
            }
        });
    };
    /**
     * Upload file
     */
    FBOProfileComponent.prototype.uploadFile = function () {
        var _this = this;
        if (this.uploader && this.uploader.queue.length > 0) {
            this.ngProgress.start();
            var filelength_1 = 0;
            var fboId_1 = this._id;
            this.uploader.onBuildItemForm = function (item, form) {
                filelength_1++;
                item.withCredentials = false;
                item.uploader.authToken = _this._customerservice.getAuthorizationToken();
                var fileNameArr = item.file.name.split('.');
                var filename = fileNameArr[0].replace(/[&\/\\#,+()$~%'":*?@!$^*;<>{}/ +(?= )]/g, '');
                item.file.name = filename + '_' + fboId_1 + '_' + filelength_1
                    + (fileNameArr.length > 1 ? '.' + fileNameArr[fileNameArr.length - 1] : '');
                form.append('fileName', decodeURIComponent(encodeURIComponent(item.file.name)));
                form.append('path', 'content/customer-service/' + _this._id + '/');
            };
            for (var i = 0; i < this.uploader.queue.length; i++) {
                this.uploader.queue[i].upload();
            }
        }
    };
    /**
     * To Map Input Values
     */
    FBOProfileComponent.prototype.mapTagInputValue = function (tagInputValue) {
        if (tagInputValue && tagInputValue.length > 0) {
            return tagInputValue.map(function (x) {
                return x['value'];
            });
        }
    };
    /**
     * To Submit the form values
     */
    FBOProfileComponent.prototype.onSubmitComplete = function (isValid, formValue) {
        this.bodyStr = document.querySelector('#ckeditor-content').innerHTML;
        this.composeEmailForm.controls['body'].setValue(this.bodyStr);
        this.bodyStr = this.bodyStr.replace(/<p>&nbsp;<\/p>/gi, '');
        this.bodyStr = this.bodyStr.replace(/<h4>&nbsp;<\/h4>/gi, '');
        if (isValid && !this.submitCompleted) {
            var departmentInfo = formValue && formValue.fromAddress && this.departments && this.departments.length > 0
                ? this.departments.find(function (department) { return department.id === +formValue.fromAddress; }) : null;
            this.composeEmailRequest = {
                messageModel: {
                    from: departmentInfo ? departmentInfo.email : '',
                    to: this.mapTagInputValue(formValue.toAddress),
                    cc: this.mapTagInputValue(formValue.ccAddress),
                    bcc: this.mapTagInputValue(formValue.bccAddress),
                    subject: formValue && formValue.subject ? formValue.subject : '',
                    mailBody: this.bodyStr,
                    attachments: null,
                },
                ticketModel: {
                    sourceId: this.sourceTypesEnum.Email,
                    callerName: this.userInfo.firstName + ' ' + this.userInfo.lastName,
                    operatingCountryId: formValue.operatingCountry,
                    typeId: formValue.ticketType,
                    subTypeId: formValue.subType,
                    description: this.bodyStr,
                    departmentId: departmentInfo ? departmentInfo.id : null,
                    priorityId: (departmentInfo.name.toLowerCase().indexOf(Department.KEY.toLowerCase()) > -1
                        && formValue.operatingCountry == OperatingCountryEnums.SWE) ? Priority.High : Priority.Medium,
                    dueDate: null,
                    subject: formValue.subject,
                    assignedToId: this.userInfo.userId,
                    memberId: this.fboProfileDetail.distributorId ? this.fboProfileDetail.distributorId : "",
                    distributorName: this.fboProfileDetail.name,
                    agentEmail: this.userInfo.email,
                    agentName: this.userInfo.firstName + ' ' + this.userInfo.lastName,
                    ticketLink: window.location.href,
                    countryId: this.fboProfileDetail.homeCountryId ? this.fboProfileDetail.homeCountryId : null,
                    memberType: this.getMemberType(),
                    userId: this.userInfo.userId,
                    firstName: this.userInfo.firstName,
                    lastName: this.userInfo.lastName,
                    sourceIdentifierValue: this.userInfo.email,
                    statusId: formValue.statusId,
                    copyToUsers: []
                }
            };
        }
        if (this.uploader.queue.length > 0) {
            this.uploadFile();
        }
        else {
            this.sentEmail(this.composeEmailRequest);
        }
    };
    /**
     * To Get member Type
     */
    FBOProfileComponent.prototype.getMemberType = function () {
        if (this.fboProfileDetail.memberType === MemberType.RETAIL || this.fboProfileDetail.memberType === 'R'
            || this.fboProfileDetail.memberType.toUpperCase() === MemberType.RETAILCUSTOMER) {
            return MemberType.RETAIL;
        }
        else if (this.fboProfileDetail.memberType === MemberType.GUEST || this.fboProfileDetail.memberType === 'G') {
            return MemberType.GUEST;
        }
        else if (this.fboProfileDetail.memberType === MemberType.FPC) {
            return MemberType.FPC;
        }
        else {
            return MemberType.FOB;
        }
    };
    /**
     * To Sent Email & Create Ticket
     */
    FBOProfileComponent.prototype.sentEmail = function (composeEmail) {
        var _this = this;
        this.showEmailErrorMessage = false;
        this.showMaxFileSizeValidation = false;
        this.submitCompleted = true;
        composeEmail.messageModel.mailBody = composeEmail.messageModel.mailBody.replace(/[^\x00-\x7F]/g, '');
        composeEmail.messageModel.mailBody = composeEmail.messageModel.mailBody.replace(/<p><br data-cke-filler="true">(.*?)<\/p>/gi, '');
        composeEmail.messageModel.mailBody = composeEmail.messageModel.mailBody.replace(/<h4><br data-cke-filler="true">(.*?)<\/h4>/gi, '');
        var errorNotification = this._translatePipe.get('customer-service.Something went wrong, Please try again after sometime');
        this._customerservice.composeEmailAndCreateTicket(composeEmail)
            .subscribe(function (response) {
            if (response && response.success) {
                if (_this.uploadResponse && _this.uploadResponse.length > 0) {
                    _this.saveAttachments(response.ticketModel.id);
                }
                else {
                    _this.successResponse();
                }
            }
            else if (response && response.validations.length > 0) {
                _this.message = response.validations[0].message ? response.validations[0].message : errorNotification.value;
                _this.count = 0;
                _this.composeEmailRequest.messageModel.attachments = [];
                _this.uploadResponse = [];
                _this.showEmailErrorMessage = true;
                _this.isSendingEmail = false;
            }
            else {
                var message = _this._translatePipe.get('customer-service.One or More error occured, while sending email/creating ticket');
                _this.message = message.value;
                _this.count = 0;
                _this.composeEmailRequest.messageModel.attachments = [];
                _this.uploadResponse = [];
                _this.showEmailErrorMessage = true;
                _this.isSendingEmail = false;
            }
            _this.submitCompleted = false;
        }, function (error) {
            _this.message = errorNotification.value;
            _this.count = 0;
            _this.composeEmailRequest.messageModel.attachments = [];
            _this.uploadResponse = [];
            _this.showEmailErrorMessage = true;
            _this.isSendingEmail = false;
            _this.submitCompleted = false;
        });
    };
    /**
     * To Success Response
     */
    FBOProfileComponent.prototype.successResponse = function (isAttachmentUploadError, ticketId) {
        this.isSendingEmail = false;
        this.composeEmailPopup.close();
        this.count = 0;
        var message = '';
        this.composeEmailRequest.messageModel.attachments = [];
        this.uploadResponse = [];
        if (isAttachmentUploadError) {
            message = 'Email sent & Ticket created sucessfully, Some error occured while uploading attachments, Please upload by editing the ticket (Ticket#: ' + ticketId + ')';
            this._commonService.createNotification('', this.message, NotificationType.WARN);
        }
        else {
            message = this._translatePipe.get('customer-service.Email sent & Ticket created sucessfully');
            this._commonService.createNotification('', message.value, NotificationType.SUCCESS);
        }
    };
    /**
     * To save the attachments
     */
    FBOProfileComponent.prototype.saveAttachments = function (ticketId) {
        var _this = this;
        if (ticketId) {
            this._customerservice.saveAttachments(this.uploadResponse, ticketId).subscribe(function (response) {
                if (response) {
                    _this.successResponse();
                }
            }, function (error) {
                _this.successResponse(true, ticketId);
            });
        }
    };
    /**
     * To Change the operating country
     */
    FBOProfileComponent.prototype.operatingCountryChange = function (id) {
        this.composeEmailForm.controls['ticketType'].setValue('');
        this.composeEmailForm.controls['subType'].setValue('');
        this.changeSignatureByOperatingCountry(id);
        this.composeEmailForm.controls['fromAddress'].setValue('');
        this.departments = [];
        this.getDepartmentDetails(id);
        this.getTicketTypesAndSubTypes();
    };
    /**
     * To Get ticket types & sub types
     */
    FBOProfileComponent.prototype.getTicketTypesAndSubTypes = function () {
        var _this = this;
        this.ticketTypes = [];
        this.subTypes = [];
        this.composeEmailForm.controls['ticketType'].setValue('');
        this.composeEmailForm.controls['subType'].setValue('');
        var operatingCountry = this.composeEmailForm.controls['operatingCountry'].value;
        if (operatingCountry) {
            this._departmentService.getTicketTypesAndSubTypes(operatingCountry).subscribe(function (response) {
                if (response && response.length > 0) {
                    _this.ticketTypes = response;
                    _this.ticketTypes.forEach(function (type) {
                        if (type.value) {
                            type.sortValue = type.value.toLowerCase();
                        }
                    });
                }
            });
        }
    };
    /**
     * To Get subtypes
     */
    FBOProfileComponent.prototype.getSubTypes = function (event) {
        var ticketTypeId = +event;
        this.subTypes = [];
        this.composeEmailForm.controls['subType'].setValue('');
        if (ticketTypeId && this.ticketTypes && this.ticketTypes.length > 0) {
            var types = JSON.parse(JSON.stringify(this.ticketTypes));
            this.subTypes = types.find(function (item) { return item.id === ticketTypeId; }) ?
                types.find(function (item) { return item.id === ticketTypeId; }).subTypes : [];
        }
    };
    /**
     * Change signature by operating country in compose email screen
     */
    FBOProfileComponent.prototype.changeSignatureByOperatingCountry = function (id, isSmileTeamTicket) {
        this.signatureValue = '';
        var operatingcountry = this.businessEntities.filter(function (item) { return item.id == id; })[0];
        var operatingCountryCode = isSmileTeamTicket ? IsoCodeThree.USA : operatingcountry["value"];
        if (operatingCountryCode && this.emailSignatureResponse && this.emailSignatureResponse.length > 0) {
            this.signatureValue = this._customerService.getSignatureValue(operatingCountryCode, this.emailSignatureResponse);
        }
        var editorElement = document.querySelector('#ckeditor-js .ck-editor__editable');
        var emailElement = editorElement.querySelector('#emailsignature');
        if (this.signatureValue && this.signatureValue.length > 0) {
            if (emailElement) {
                emailElement.innerHTML = this.signatureValue;
                editorElement.ckeditorInstance.setData(editorElement.innerHTML);
                this.composeEmailForm.controls['body'].setValue(editorElement.innerHTML);
            }
            else {
                var editordata = editorElement.ckeditorInstance.getData();
                editordata = editordata + '<div id="emailsignature">' + this.signatureValue + '</div>';
                editorElement.ckeditorInstance.setData(editorElement.innerHTML);
                this.composeEmailForm.controls['body'].setValue(editorElement.innerHTML);
            }
        }
    };
    FBOProfileComponent.prototype.isBetaEnabledCountry = function (homeCountryCode) {
        var betaCountries = [];
        var isBetaEnabledCountry = false;
        if (environment.betaEnabledCountries && environment.betaEnabledCountries.length) {
            betaCountries = environment.betaEnabledCountries.toLowerCase().split(',');
        }
        if (homeCountryCode && betaCountries) {
            if (betaCountries.includes(homeCountryCode.toLowerCase())) {
                isBetaEnabledCountry = true;
            }
        }
        return isBetaEnabledCountry;
    };
    FBOProfileComponent.prototype.displayErrorMessage = function (distributorId) {
        var translatedContent = this._translatePipe.get('customer-service.Invalid FBO');
        var errorMessage = translatedContent.value + ' ' + '(' + distributorId + ')';
        this._commonService.createNotification('', errorMessage, NotificationType.ERROR);
    };
    FBOProfileComponent.prototype.getCustomBankTypeSelectOption = function () {
        var _this = this;
        this.customSelectSubscription = this._messageService.getBankTypeChange()
            .subscribe(function (bankCode) {
            if (!_this.memberBonusInfo || (_this.memberBonusInfo && _this.memberBonusInfo.bankCode && _this.memberBonusInfo.bankCode.toLowerCase() !== bankCode.toLowerCase())) {
                _this.preloadMemberBonusInfo = null;
            }
        });
    };
    FBOProfileComponent.prototype.openUpdateBonusInfoModal = function () {
        var _this = this;
        this._personalMessageService.setValidBonusInfoForm(true);
        this._personalMessageService.setPreviousBonusInfo(this.memberBonusInfo);
        this._configurationService.setBonusInfoCountry(this.homeCountry);
        this._configurationService.setEnrollCountry(this.homeCountry);
        this.validBonusInfo = true;
        if (this.showSingleAndDirectDebitMenu) {
            this.fetchTermsConditionDocument();
            this.disableBonusInfoChecks = true;
            this.isCreditAssessmentEnabled = this.memberBonusInfo && this.memberBonusInfo.creditAssessmentEnabled ? this.memberBonusInfo.creditAssessmentEnabled : false;
            this.isSingleDebitEnabled = this.memberBonusInfo && this.memberBonusInfo.singleDebitEnabled ? this.memberBonusInfo.singleDebitEnabled : false;
            this.isDirectDebitEnabled = this.memberBonusInfo && this.memberBonusInfo.directDebitEnabled ? this.memberBonusInfo.directDebitEnabled : false;
            this.blxBonusInformationModalPopup.open();
        }
        else {
            this.bonusInformationPopup.open();
        }
        this.isDeleteBonusInfo = false;
        this.editBonusInfo = false;
        this.preloadMemberBonusInfo = this.memberBonusInfo;
        this.getMemberBonusInfo();
        setTimeout(function () {
            _this.prepareBonusInfoSchemaForm();
        }, 300);
    };
    FBOProfileComponent.prototype.closeBonusInformationModal = function () {
        this.updateOnlyBonusInfoPaymentMethods = false;
        this._personalMessageService.setPreviousBonusInfo(null);
        this._configurationService.setBonusInfoCountry(null);
        this.bonusInfoChanged = false;
        if (this.showSingleAndDirectDebitMenu) {
            this.displayIBANAckError = false;
            this.blxBonusInformationModalPopup.close();
        }
        else {
            this.bonusInformationPopup.close();
        }
        this.editBonusInfo = false;
        this.isDeleteBonusInfo = false;
        this._personalMessageService.setDisableBonusInfoForm(true);
        this.disableBonusInfoChecks = true;
        this.getMemberBonusInfo();
    };
    FBOProfileComponent.prototype.deleteBonusInfoConfirmation = function (status) {
        if (status) {
            if (this.memberBonusInfo && this.memberBonusInfo.id) {
                this.closeDeleteBonusInfoConfirmation();
                this.isDeleteBonusInfo = true;
                this._personalMessageService.setDisableBonusInfoForm(true);
                this.disableBonusInfoChecks = true;
            }
        }
        else {
            if (this.memberBonusInfo && this.memberBonusInfo.id) {
                this.openDeleteBonusInfoConfirmation();
            }
        }
    };
    FBOProfileComponent.prototype.openDeleteBonusInfoConfirmation = function () {
        this.deleteBonusInfoConfirmationPopup.open();
    };
    FBOProfileComponent.prototype.closeDeleteBonusInfoConfirmation = function () {
        this.deleteBonusInfoConfirmationPopup.close();
    };
    FBOProfileComponent.prototype.deletedBonuInformation = function (memberId) {
        var _this = this;
        var singleDirectDebitEnabled = false;
        var options;
        var blxCountry = environment.beneluxCountries.split(',').find(function (countryCode) { return countryCode && _this.homeCountry && countryCode.toUpperCase() === _this.homeCountry.toUpperCase(); });
        if (this.memberBonusInfo && (this.isCreditAssessmentEnabled || blxCountry)) {
            singleDirectDebitEnabled = true;
        }
        if (this.storeInfo && this.userInfo) {
            options = {
                operatingCompany: this.storeInfo.homeIsocodeThree ? this.storeInfo.homeIsocodeThree : null,
                storeCountryId: this.storeInfo.id ? this.storeInfo.id : null,
                updatedBy: this.userInfo.userId ? this.userInfo.userId : null
            };
            if (this.fboProfileDetail) {
                options.distributorId = this.fboProfileDetail.distributorId;
            }
        }
        if (memberId) {
            this._customerService.deleteMemberBankDetails(memberId, singleDirectDebitEnabled, FBOProfileUpdateEnum.BONUS_PAY_BANK_DETAILS_CHANGE, options)
                .subscribe(function (res) {
                if (res) {
                    _this.memberBonusInfo = null;
                    _this.preloadMemberBonusInfo = _this.memberBonusInfo;
                    _this._commonService.createNotification("", "Bonus information deleted successfully", NotificationType.SUCCESS);
                    _this._messageService.setBlxBonusInformation(null);
                    _this._personalMessageService.setPreviousBonusInfo(null);
                    _this.closeBonusInformationModal();
                }
                else {
                    _this._commonService.createNotification("", "Bonus information delete failed, Please try again", NotificationType.ERROR);
                }
                _this.disableBonusButton = true;
            });
        }
    };
    FBOProfileComponent.prototype.editBonusInformation = function (memberId, bonusId) {
        this.editBonusInfo = true;
        this._personalMessageService.setDisableBonusInfoForm(false);
        //this.disableBonusInfoChecks = false;
        this.disableBonusInfoChecks = (this.memberBonusInfo && this.memberBonusInfo.accountNumber) && this.editBonusInfo ? false : true;
    };
    FBOProfileComponent.prototype.addNewBonusInformation = function (memberId) {
        this.editBonusInfo = true;
    };
    FBOProfileComponent.prototype.getValidBonusInfoSubscription = function () {
        var _this = this;
        this.validBonusInfoSubscription = this._personalMessageService.getValidBonusInfoForm().subscribe(function (data) {
            _this.validBonusInfo = data;
        });
    };
    FBOProfileComponent.prototype.getValidIbanInfoSubscription = function () {
        var _this = this;
        this.validIbanInfoSubscription = this._personalMessageService.getValidateIbanInfo().subscribe(function (data) {
            _this.invalidIban = data;
        });
    };
    FBOProfileComponent.prototype.saveBonusInformation = function (memberId, bonusInfo, isNewAdded) {
        var profileUpdateChangedValues = [];
        if (this.memberBonusInfo) {
            if ((bonusInfo.accountNumber ? bonusInfo.accountNumber : "") !== (this.memberBonusInfo.accountNumber ? this.memberBonusInfo.accountNumber : "") ||
                ((bonusInfo.bankName ? bonusInfo.bankName : "") !== (this.memberBonusInfo.bankName ? this.memberBonusInfo.bankName : "")) ||
                ((bonusInfo.checkDigit ? bonusInfo.checkDigit : "") !== (this.memberBonusInfo.checkDigit ? this.memberBonusInfo.checkDigit : "")) ||
                ((bonusInfo.clearingNumber ? bonusInfo.clearingNumber : "") !== (this.memberBonusInfo.clearingNumber ? this.memberBonusInfo.clearingNumber : "")) ||
                ((bonusInfo.accountName ? bonusInfo.accountName : "") !== (this.memberBonusInfo.accountName ? this.memberBonusInfo.accountName : "")) ||
                ((bonusInfo.accountReferenceNumber ? bonusInfo.accountReferenceNumber : "") !== (this.memberBonusInfo.accountReferenceNumber ? this.memberBonusInfo.accountReferenceNumber : "")) ||
                ((bonusInfo.sortCode ? bonusInfo.sortCode : "") !== (this.memberBonusInfo.sortCode ? this.memberBonusInfo.sortCode : ""))) {
                profileUpdateChangedValues.push(FBOProfileUpdateEnum.BONUS_PAY_BANK_DETAILS_CHANGE);
            }
        }
        else {
            profileUpdateChangedValues.push(FBOProfileUpdateEnum.BONUS_PAY_BANK_DETAILS_CHANGE);
        }
        bonusInfo.countryCode = this.homeCountry;
        bonusInfo.id = this.memberBonusInfo && this.memberBonusInfo.id ? this.memberBonusInfo.id : null;
        bonusInfo.creditAssessmentEnabled = this.isCreditAssessmentEnabled ? this.isCreditAssessmentEnabled : false;
        bonusInfo.singleDebitEnabled = this.isSingleDebitEnabled ? this.isSingleDebitEnabled : false;
        bonusInfo.directDebitEnabled = this.isDirectDebitEnabled ? this.isDirectDebitEnabled : false;
        bonusInfo.createdBy = isNewAdded || bonusInfo.id ? null : this.userInfo.userId;
        bonusInfo.updatedBy = isNewAdded || bonusInfo.id ? this.userInfo.userId : null;
        bonusInfo.changedValueType = profileUpdateChangedValues;
        bonusInfo.storeId = this.storeInfo && this.storeInfo.id ? this.storeInfo.id : null;
        if (this.fboProfileDetail) {
            bonusInfo.distributorId = this.fboProfileDetail.distributorId;
        }
        if (this.showSingleAndDirectDebitMenu && !bonusInfo.accountNumber) {
            //bonusInfo.singleDebitEnabled = false;
            bonusInfo.directDebitEnabled = false;
        }
        // other than BLX need to pass NULL for Single and Direct debit
        if (!this.showSingleAndDirectDebitMenu) {
            bonusInfo.singleDebitEnabled = null;
            bonusInfo.directDebitEnabled = null;
        }
        if (this.showSingleAndDirectDebitMenu) {
            if (this.validBonusInfo || this.editSingleAndDirectDebitPayment) {
                this.saveMemberBankDetails(memberId, bonusInfo);
            }
        }
        else {
            this.saveMemberBankDetails(memberId, bonusInfo);
        }
    };
    FBOProfileComponent.prototype.saveMemberBankDetails = function (memberId, bonusInfo) {
        if (this.memberBonusInfo && !this.memberBonusInfo.accountNumber && this.personalInfoSettings && this.personalInfoSettings.enableSingleAndDirectDebit) {
            this.updateMemberBankDetails(memberId, bonusInfo);
        }
        else {
            this.postMemberBankDetails(memberId, bonusInfo);
        }
    };
    FBOProfileComponent.prototype.postMemberBankDetails = function (memberId, bonusInfo) {
        var _this = this;
        this._customerService.saveMemberBankDetails(memberId, bonusInfo)
            .subscribe(function (res) {
            if (res) {
                _this.memberBonusInfo = res;
                _this.preloadMemberBonusInfo = _this.memberBonusInfo;
                _this.bonusInfoBankCode = res.bankCode;
                _this.isCreditAssessmentEnabled = res.creditAssessmentEnabled;
                _this.isDirectDebitEnabled = res.directDebitEnabled;
                _this.isSingleDebitEnabled = res.singleDebitEnabled;
                if (_this.showSingleAndDirectDebitMenu && _this.memberBonusInfo && _this.memberBonusInfo.accountNumber) {
                    if (_this.bonusInfoAgreements && _this.bonusInfoAgreements.length > 0) {
                        _this.saveIBANAcknowledgement();
                    }
                }
                if (_this.editSingleAndDirectDebitPayment) {
                    _this._commonService.createNotification("", "Single and Direct debit information updated successfully", NotificationType.SUCCESS);
                    _this.closeSingleAndDirectDebitModal();
                }
                else {
                    _this._commonService.createNotification("", "Bonus information updated successfully", NotificationType.SUCCESS);
                    _this.closeBonusInformationModal();
                }
                _this.disableBonusButton = true;
            }
        }, function (error) {
            if (_this.editSingleAndDirectDebitPayment) {
                _this._commonService.createNotification("", "Single and Direct debit information update failed, Please try again", NotificationType.ERROR);
            }
            else {
                _this._commonService.createNotification("", "Bonus information update failed, Please try again", NotificationType.ERROR);
            }
            _this.disableBonusButton = true;
        });
    };
    FBOProfileComponent.prototype.updateMemberBankDetails = function (memberId, bonusInfo) {
        var _this = this;
        this._customerService.updateMemberBankDetails(memberId, bonusInfo)
            .subscribe(function (res) {
            if (res) {
                _this.memberBonusInfo = res;
                _this.preloadMemberBonusInfo = _this.memberBonusInfo;
                _this.bonusInfoBankCode = res.bankCode;
                _this.isCreditAssessmentEnabled = res.creditAssessmentEnabled;
                _this.isDirectDebitEnabled = res.directDebitEnabled;
                _this.isSingleDebitEnabled = res.singleDebitEnabled;
                if (_this.showSingleAndDirectDebitMenu && _this.memberBonusInfo && _this.memberBonusInfo.accountNumber) {
                    if (_this.bonusInfoAgreements && _this.bonusInfoAgreements.length > 0) {
                        _this.saveIBANAcknowledgement();
                    }
                }
                if (_this.editSingleAndDirectDebitPayment) {
                    _this._commonService.createNotification("", "Single and Direct debit information updated successfully", NotificationType.SUCCESS);
                    _this.closeSingleAndDirectDebitModal();
                }
                else {
                    _this._commonService.createNotification("", "Bonus information updated successfully", NotificationType.SUCCESS);
                    _this.closeBonusInformationModal();
                }
            }
            _this.disableBonusButton = true;
        }, function (error) {
            if (_this.editSingleAndDirectDebitPayment) {
                _this._commonService.createNotification("", "Single and Direct debit information update failed, Please try again", NotificationType.ERROR);
            }
            else {
                _this._commonService.createNotification("", "Bonus information update failed, Please try again", NotificationType.ERROR);
            }
            _this.disableBonusButton = true;
        });
    };
    FBOProfileComponent.prototype.updateBonusInformation = function (isNewAdded) {
        this.disableBonusButton = false;
        if (this.isDeleteBonusInfo) {
            this.deletedBonuInformation(this.fboProfileDetail.memberId);
        }
        else {
            if (this.showSingleAndDirectDebitMenu) {
                if (this.editSingleAndDirectDebitPayment) {
                    if (this.memberBonusInfo) {
                        this.memberBonusInfo.creditAssessmentEnabled = this.isCreditAssessmentEnabled;
                        this.memberBonusInfo.singleDebitEnabled = this.isSingleDebitEnabled;
                        this.memberBonusInfo.directDebitEnabled = this.isDirectDebitEnabled;
                        this.saveBonusInformation(this.fboProfileDetail.memberId, this.memberBonusInfo, isNewAdded);
                    }
                    else {
                        var bonusInfo = {
                            singleDebitEnabled: this.isSingleDebitEnabled,
                            directDebitEnabled: this.isDirectDebitEnabled,
                            creditAssessmentEnabled: this.isCreditAssessmentEnabled
                        };
                        this.saveBonusInformation(this.fboProfileDetail.memberId, bonusInfo, isNewAdded);
                    }
                }
                else {
                    this.displayIBANAckError = this.validateTandC();
                    if (!this.displayIBANAckError) {
                        if (!this.bonusInfoChanged && this.memberBonusInfo) {
                            this.saveBonusInformation(this.fboProfileDetail.memberId, this.memberBonusInfo, isNewAdded);
                        }
                        else {
                            this._personalMessageService.setSubmitBonusInfoForm(true);
                        }
                    }
                }
            }
            else {
                this._personalMessageService.setSubmitBonusInfoForm(true);
            }
        }
    };
    FBOProfileComponent.prototype.getBonusInfo = function (bonusInformation) {
        this.liveBonusinformation = bonusInformation;
        if (this.showSingleAndDirectDebitMenu) {
            this.displayIBANAckError = this.validateTandC();
            if (!this.displayIBANAckError && bonusInformation != undefined) {
                this.saveBonusInformation(this.fboProfileDetail.memberId, this.liveBonusinformation);
            }
        }
        else {
            if (bonusInformation && JSON.stringify(bonusInformation) !== "{}") {
                if (this.liveBonusinformation && this.bonusInfoFormValidated) {
                    this.saveBonusInformation(this.fboProfileDetail.memberId, this.liveBonusinformation);
                }
            }
        }
    };
    FBOProfileComponent.prototype.validateTandC = function () {
        var bonusInformation;
        var accountNumber = '';
        this._messageService.accountNumber.subscribe(function (accountNumber) { return bonusInformation = accountNumber ? accountNumber : ''; });
        if (bonusInformation) {
            accountNumber = bonusInformation;
        }
        if (accountNumber !== '') {
            var agreementList = this.bonusInfoAgreements.filter(function (agreement) { return agreement.isSelected === false; });
            this.displayIBANAckError = (agreementList && agreementList.length === 0) ? false : true;
        }
        else {
            this.displayIBANAckError = false;
        }
        return this.displayIBANAckError;
    };
    FBOProfileComponent.prototype.getBonusInfoOnInputChange = function (bonusInfoFormValidated) {
        var _this = this;
        this.bonusInfoFormValidated = bonusInfoFormValidated;
        this.bonusInfoChanged = true;
        var IBANNumber;
        this._messageService.accountNumber.subscribe(function (accountNumber) {
            IBANNumber = accountNumber ? accountNumber : '';
            _this.disableBonusInfoChecks = IBANNumber ? false : true;
            if (IBANNumber) {
                _this.displayIBANAckError = false;
            }
        });
    };
    FBOProfileComponent.prototype.openSingleAndDirectDebitModal = function () {
        this.getMemberBonusInfo();
        this.isCreditAssessmentEnabled = this.memberBonusInfo ? this.memberBonusInfo.creditAssessmentEnabled : false;
        this.isSingleDebitEnabled = this.memberBonusInfo ? this.memberBonusInfo.singleDebitEnabled : false;
        this.isDirectDebitEnabled = this.memberBonusInfo ? this.memberBonusInfo.directDebitEnabled : false;
        this.singleAndDirectDebitPaymentModal.open();
        this.editSingleAndDirectDebitPayment = true;
    };
    FBOProfileComponent.prototype.closeSingleAndDirectDebitModal = function () {
        this.editSingleAndDirectDebitPayment = false;
        this.singleAndDirectDebitPaymentModal.close();
    };
    /**
     *Edit Echeck payment form
     * @memberof FBOProfileComponent
     */
    FBOProfileComponent.prototype.editEcheck = function (eCheck) {
        if (eCheck) {
            this.editEcheckInfo = eCheck;
            this.isEditEcheck = true;
            this.addNewAchCard = true;
            this.achPaymentPopup.open();
        }
    };
    FBOProfileComponent.prototype.ngOnDestroy = function () {
        if (this.customSelectSubscription) {
            this.customSelectSubscription.unsubscribe();
        }
        if (this.validBonusInfoSubscription) {
            this.validBonusInfoSubscription.unsubscribe();
        }
        if (this.validIbanInfoSubscription) {
            this.validIbanInfoSubscription.unsubscribe();
        }
    };
    /**
     * Get store level permissions
     */
    FBOProfileComponent.prototype.getStoreLevelPermissions = function () {
        this.businessEditEntityPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[15] + ']'), AccessLevel.Store, this.homeStoreId);
        this.businessViewEntityPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[16] + ']'), AccessLevel.Store, this.homeStoreId);
    };
    /**
    * @description onChange Enable Credit Assessment
    * @param event
    */
    FBOProfileComponent.prototype.onCreditAssessmentChange = function (event) {
        this.isCreditAssessmentEnabled = event.target.checked;
        if (!this.isCreditAssessmentEnabled) {
            this.isDirectDebitEnabled = false;
            this.isSingleDebitEnabled = false;
        }
    };
    /**
     * @description onChange Enable Direct Debit payment
     * @param event
     */
    FBOProfileComponent.prototype.onDirectDebitChange = function (event) {
        this.isDirectDebitEnabled = event.target.checked;
    };
    /**
     * @description onChange Enable Single Debit payment
     * @param event
     */
    FBOProfileComponent.prototype.onSingleDebitChange = function (event) {
        this.isSingleDebitEnabled = event.target.checked;
    };
    /**
     * get terms and conditions for bonus information of BLX markets
     */
    FBOProfileComponent.prototype.fetchTermsConditionDocument = function () {
        var _this = this;
        var accountLevelId;
        if (this.fboProfileDetail && this.fboProfileDetail.memberRankLevels && this.fboProfileDetail.memberRankLevels.length > 0) {
            this.fboProfileDetail.memberRankLevels.forEach(function (x) {
                accountLevelId = x.accountLevelId ? x.accountLevelId : null;
            });
        }
        this._documentService.getDocuments(Portal.Csp, accountLevelId, DisplaySectionId.Member_Info, this.fboProfileDetail.homeCountryCode, this.languagecode)
            .subscribe(function (response) {
            if (response && response.length > 0 && response[0].body && response[0].body.length > 0) {
                _this.bonusInfoAgreements = response[0].body;
                _this.bonusInfoAgreements.forEach(function (agreement) {
                    return agreement.isSelected = _this.memberBonusInfo && _this.memberBonusInfo.accountNumber ? true : false;
                });
            }
            else {
                _this.bonusInfoAgreements = [];
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to fetch Agreement Details');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    FBOProfileComponent.prototype.selectedAgreements = function (agreement) {
        var agreementObj = this.bonusInfoAgreements.find(function (agreement) { return agreement.documentLibraryId === agreement.documentLibraryId; });
        if (agreementObj) {
            agreementObj.isSelected = !agreementObj.isSelected;
            if (agreementObj.isSelected) {
                this.displayIBANAckError = false;
            }
        }
    };
    FBOProfileComponent.prototype.saveIBANAcknowledgement = function () {
        this._documentService.updateAcknowledgedDocuments(this.bonusInfoAgreements[0], this.fboProfileDetail.memberTypeId, this.fboProfileDetail.memberId).subscribe();
    };
    FBOProfileComponent.prototype.getCountryDisableStatus = function (governmentIdentification) {
        if (this.isEditGovId) {
            return null;
        }
        else {
            var countries = ['BEL', 'LUX', 'NLD'];
            if (governmentIdentification && governmentIdentification.id && governmentIdentification.country) {
                var index = countries.findIndex(function (el) { return el && el == governmentIdentification.country; });
                if (index > -1) {
                    return true;
                }
            }
            return null;
        }
    };
    /**
     * @description To get email siganture for operating countries
     * @returns void
    */
    FBOProfileComponent.prototype.getEmailSignature = function () {
        var _this = this;
        this._customerservice.getEmailSignatures().subscribe(function (res) {
            if (res && res.length > 0) {
                _this.emailSignatureResponse = res;
            }
            else {
                _this.emailSignatureResponse = [];
            }
        }, function (error) {
            _this.emailSignatureResponse = [];
        });
    };
    FBOProfileComponent.prototype.openRetailSubscriptionModal = function () {
        if (this.languages.length === 0) {
            this.getChargeBeeLanguages();
        }
        this.getChargeBeeConfiguration();
        if (this.memberRetailSubscriptionDetail && this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel && this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id) {
            this.getRetailSubscriptionsById(this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id);
        }
        if (this.memberRetailSubscriptionId && this.memberRetailSubscriptionDetail) {
            this.getRetailSubscriptionPlan(this.memberRetailSubscriptionDetail.appPlanMapperId);
        }
        else {
            if (this.fboProfileDetail && this.fboProfileDetail.retailSubscriptionModel && this.fboProfileDetail.retailSubscriptionModel.chargeBeePlanId) {
                this.getRetailSubscriptionPlan(this.fboProfileDetail.retailSubscriptionModel.chargeBeePlanId);
            }
            else {
                this.prepareRetailSubscriptionForm();
                this.buildRetailSubscritionForm();
            }
        }
    };
    FBOProfileComponent.prototype.openCancelRenewalModal = function () {
        this.cancelRenewalPopup.open();
    };
    FBOProfileComponent.prototype.openCancelSubscriptionModal = function () {
        this.cancelSubscriptionPopup.open();
    };
    FBOProfileComponent.prototype.closeCancelRenewalSubscriptionModal = function () {
        this.cancelRenewalPopup.close();
    };
    FBOProfileComponent.prototype.closeCancelSubscriptionModal = function () {
        this.cancelSubscriptionPopup.close();
    };
    FBOProfileComponent.prototype.closePopUpforRetailSubscription = function () {
        this.retailSubscriptionPopup.close();
    };
    FBOProfileComponent.prototype.resubscription = function () {
        this.isResubscribe = true;
        this.isRetailSubscriptionLogin = false;
        this.prepareRetailSubscriptionForm();
        this.buildRetailSubscritionForm();
    };
    FBOProfileComponent.prototype.onSubmitRetailForm = function (isValidForm) {
        var _this = this;
        this.isRetailFormSubmitted = true;
        if (isValidForm) {
            if (this.memberRetailSubscriptionId > 0 && this.isResubscribe === false) {
                var memberRetailProgramSubscriptionModel_1 = this.prepareUpdateRetailSubscriptionModel();
                if (memberRetailProgramSubscriptionModel_1) {
                    this._retailSubscriptionService.updateRetailSubscription(memberRetailProgramSubscriptionModel_1).subscribe(function (response) {
                        if (response && response.isSuccess) {
                            _this.retailSubscriptionPopup.close();
                            if (_this.memberRetailSubscriptionDetail && _this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel) {
                                _this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.emailAddress = response.emailAddress;
                                _this.retailSubscriptionLanguageId = response.retailLanguagesConfigID;
                            }
                            var notification = _this._translatePipe.get('customer-service.Subscription updated successfully');
                            _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                        }
                        else {
                            if (response && response.validations && response.validations.length) {
                                var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].message);
                                if (response.validations[0].name.toLowerCase() == Constants.NOT_EXIST.toLowerCase()) {
                                    addedNotification = _this._translatePipe.get('errorcodes.Shared Retail subscription details are not available for distributor {{distributorID}}', { distributorID: memberRetailProgramSubscriptionModel_1 && memberRetailProgramSubscriptionModel_1.distributorId ? memberRetailProgramSubscriptionModel_1.distributorId : '' });
                                }
                                if (response.validations[0].name.toLowerCase() == Constants.CHARGEBEE_ERROR.toLowerCase()) {
                                    addedNotification = _this._translatePipe.get('errorcodes.Shared Retail subscription details are not updated in chargeebee for retail subscription with id {{retail_subscrp_id}}', { retail_subscrp_id: memberRetailProgramSubscriptionModel_1 && memberRetailProgramSubscriptionModel_1.id ? memberRetailProgramSubscriptionModel_1.id : '' });
                                }
                                _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                            }
                        }
                    }, function () {
                        var addedNotification = _this._translatePipe.get('errorcodes.Error occurred while updating the record');
                        _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                    });
                }
            }
            else {
                var memberRetailSubscriptionDetail_1 = this.prepareRetailSubscriptionDetailModel();
                memberRetailSubscriptionDetail_1 = __assign({}, memberRetailSubscriptionDetail_1, { supplier: this.getSupplierDetails() });
                this._retailSubscriptionService.createRetailSubscription(memberRetailSubscriptionDetail_1).subscribe(function (response) {
                    if (response && response.isSuccess) {
                        _this.memberRetailSubscriptionId = response.id;
                        _this.isRetailSubscriptionLogin = true;
                        _this.retailSubscriptionPopup.close();
                        if (_this.memberRetailSubscriptionDetail && _this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel) {
                            _this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id = response.memberRetailProgramSubscriptionModel.id;
                            _this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.emailAddress = response.memberRetailProgramSubscriptionModel.emailAddress;
                            _this.retailSubscriptionLanguageId = response.memberRetailProgramSubscriptionModel.retailLanguagesConfigID;
                            _this.memberRetailSubscriptionDetail.subscriptionStatus = response.subscriptionStatus;
                            if (_this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id) {
                                _this.getRetailSubscriptionsById(_this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id);
                            }
                        }
                        if (_this.isResubscribe) {
                            var notification = _this._translatePipe.get('customer-service.Subscription renewal initiated successfully Renewal email has been sent');
                            _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                        }
                        else {
                            var notification = _this._translatePipe.get('customer-service.Subscription initiated successfully Email with payment and terms conditions links were sent');
                            _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                        }
                        _this.isResubscribe = false;
                    }
                    else {
                        if (response && response.validations && response.validations.length) {
                            var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].message);
                            if (response.validations[0].name.toLowerCase() == Constants.ALREADY_IN_USE.toLowerCase()) {
                                addedNotification = _this._translatePipe.get('errorcodes.Member already subscribed to shared retail subscription program with plan {{plancode}}', { plancode: memberRetailSubscriptionDetail_1 && memberRetailSubscriptionDetail_1.planCode ? memberRetailSubscriptionDetail_1.planCode : '' });
                            }
                            _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                        }
                    }
                }, function () {
                    var addedNotification = _this._translatePipe.get('errorcodes.Error occurred while saving the record');
                    _this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                });
            }
            this.retailSubscriptionPopup.close();
        }
    };
    FBOProfileComponent.prototype.getSupplierDetails = function () {
        var supplierDetails = " ";
        if (this.chargeBeePlan && this.chargeBeePlan.supplier) {
            if (this.chargeBeePlan.supplier.name) {
                supplierDetails = this.chargeBeePlan.supplier.name;
            }
            if (this.chargeBeePlan.supplier.addressLine1) {
                supplierDetails = supplierDetails + ', ' + this.chargeBeePlan.supplier.addressLine1;
            }
            if (this.chargeBeePlan.supplier.addressLine2) {
                supplierDetails = supplierDetails + ',' + this.chargeBeePlan.supplier.addressLine2;
            }
            if (this.chargeBeePlan.supplier.zipcode) {
                supplierDetails = supplierDetails + ', ' + this.chargeBeePlan.supplier.zipcode;
            }
            if (this.chargeBeePlan.supplier.stateCode) {
                supplierDetails = supplierDetails + this.chargeBeePlan.supplier.stateCode;
            }
            if (this.chargeBeePlan.supplier.city) {
                supplierDetails = supplierDetails + ', ' + this.chargeBeePlan.supplier.city;
            }
            if (this.chargeBeePlan.supplier.country) {
                supplierDetails = supplierDetails + ', ' + this.chargeBeePlan.supplier.country;
            }
            if (this.chargeBeePlan.supplier.vatNumber) {
                supplierDetails = supplierDetails + ',' + Constants.VAT_NUMBER + this.chargeBeePlan.supplier.vatNumber;
            }
            if (this.chargeBeePlan.supplier.commerceNo) {
                supplierDetails = supplierDetails + ' ,' + Constants.COMMERCE_NUMBER + this.chargeBeePlan.supplier.commerceNo;
            }
        }
        return supplierDetails;
    };
    FBOProfileComponent.prototype.getRetailSubscriptionPlan = function (planId) {
        var _this = this;
        this._retailSubscriptionService.getRetailSubscriptionPlan(planId).subscribe(function (subscriptionPlan) {
            if (subscriptionPlan) {
                _this.chargeBeePlan = subscriptionPlan;
                _this.prepareRetailSubscriptionForm();
                _this.buildRetailSubscritionForm();
            }
            else {
                _this.prepareRetailSubscriptionForm();
                _this.buildRetailSubscritionForm();
            }
        }, function (error) {
            if (error) {
                _this.prepareRetailSubscriptionForm();
                _this.buildRetailSubscritionForm();
            }
        });
    };
    FBOProfileComponent.prototype.getRetailSubscriptionsById = function (id) {
        var _this = this;
        this._retailSubscriptionService.getRetailSubscriptionsById(id).subscribe(function (memberRetailSubscriptionDetails) {
            if (memberRetailSubscriptionDetails) {
                _this.memberRetailSubscriptionDetails = memberRetailSubscriptionDetails;
                _this.showBillingHistoryLink = _this.memberRetailSubscriptionDetails.some(function (memberRetailSubscriptionDetail) {
                    return memberRetailSubscriptionDetail.paymentCaptured;
                });
                _this.showSubscriptionHistoryLink = _this.memberRetailSubscriptionDetails.some(function (memberRetailSubscriptionDetail) {
                    return (memberRetailSubscriptionDetail.subscriptionStatus === _this.subscriptionStatusEnum.Active || memberRetailSubscriptionDetail.subscriptionStatus === _this.subscriptionStatusEnum.Cancelled);
                });
            }
        });
    };
    FBOProfileComponent.prototype.getChargeBeeLanguages = function () {
        var _this = this;
        this._retailSubscriptionService.getChargeBeeLanguages().subscribe(function (languages) {
            if (languages) {
                _this.languages = languages;
            }
        });
    };
    FBOProfileComponent.prototype.setChargeBeeDetails = function () {
        this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.retailLanguageLocale = this.getLanguage(this.retailSubscriptionLanguageId);
        this.retailSubscriptionForm.controls['language'].patchValue(this.configId);
        if (this.chargeBeePlan && this.chargeBeePlan.price) {
            var subscriptionFee = this.currenyFormatValue(this.chargeBeePlan.price);
            this.retailSubscriptionForm.controls['annualSubscriptionFee'].patchValue(this.prepareChargebeePlanPrice());
        }
        this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.firstName = this.fboProfileDetail ? this.fboProfileDetail.firstName : '';
        this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.lastName = this.fboProfileDetail ? this.fboProfileDetail.lastName : '';
    };
    FBOProfileComponent.prototype.prepareRetailSubscriptionDetailModel = function () {
        var memberRetailSubscriptionDetail = {
            memberRetailProgramSubscriptionModel: {
                id: null,
                firstName: this.retailSubscriptionForm.value.firstName,
                lastName: this.retailSubscriptionForm.value.lastName,
                distributorId: this.retailSubscriptionForm.value.fboId,
                memberId: this.fboProfileDetail ? this.fboProfileDetail.memberId : null,
                emailAddress: this.retailSubscriptionForm.value.email,
                retailLanguagesConfigID: this.retailSubscriptionForm.value.language,
                retailLanguageLocale: this.getLanguage(this.retailSubscriptionForm.value.language),
                periodsPurchased: 1,
                enrollmentCreatedDate: "",
                enrollmentModifiedDate: "",
                createdDate: "",
                createdBy: 1,
                updatedDate: "",
                updatedBy: "",
                rowStatus: 1
            },
            storeId: this.storeInfo ? this.storeInfo.id : null,
            appPlanMapperId: this.chargeBeePlan ? this.chargeBeePlan.id : '',
            planCode: this.chargeBeePlan ? this.chargeBeePlan.code + '-' + this.chargeBeePlan.name.replace(/\s/g, '-') : '',
            operatingCompanyId: this.memberRetailSubscriptionDetail ? this.memberRetailSubscriptionDetail.operatingCompanyId : null,
            isVatAvailable: this.retailSubscriptionForm.value.taxId ? true : false,
            subscriptionStatus: 157,
            subscriptionId: "",
            subscriptionStartDate: "",
            subscriptionEndDate: "",
            paymentCaptured: false,
            tandCAccepted: false,
            createdDate: "",
            createdBy: 1,
            updatedDate: "",
            updatedBy: "",
            rowStatus: 1,
            businessEntityId: this.retailSubscriptionForm.get('businessEntityId').value ? this.retailSubscriptionForm.get('businessEntityId').value : null,
            addressDetailId: this.retailSubscriptionForm.get('addressId').value ? this.retailSubscriptionForm.get('addressId').value : null,
            vatId: this.retailSubscriptionForm.get('taxId').value ? this.retailSubscriptionForm.get('taxId').value : null
        };
        return memberRetailSubscriptionDetail;
    };
    FBOProfileComponent.prototype.prepareUpdateRetailSubscriptionModel = function () {
        if (this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel) { }
        var memberRetailProgramSubscriptionModel = {
            id: this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id,
            firstName: this.retailSubscriptionForm.value.firstName,
            lastName: this.retailSubscriptionForm.value.lastName,
            distributorId: this.retailSubscriptionForm.value.fboId,
            memberId: this.fboProfileDetail ? this.fboProfileDetail.memberId : null,
            emailAddress: this.retailSubscriptionForm.value.email,
            retailLanguagesConfigID: this.retailSubscriptionForm.value.language,
            retailLanguageLocale: this.getLanguage(this.retailSubscriptionForm.value.language),
            periodsPurchased: 1,
            enrollmentCreatedDate: "",
            enrollmentModifiedDate: "",
            createdDate: "",
            createdBy: 1,
            updatedDate: "",
            updatedBy: "",
            rowStatus: 1,
            businessEntityId: this.retailSubscriptionForm.get('businessEntityId').value ? this.retailSubscriptionForm.get('businessEntityId').value : null,
            addressDetailId: this.retailSubscriptionForm.get('addressId').value ? this.retailSubscriptionForm.get('addressId').value : null,
            vatId: this.retailSubscriptionForm.get('taxId').value ? this.retailSubscriptionForm.get('taxId').value : null
        };
        return memberRetailProgramSubscriptionModel;
    };
    FBOProfileComponent.prototype.prepareRetailSubscriptionForm = function () {
        if (!this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel) {
            this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel = new MemberRetailProgramSubscriptionModel();
            this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.firstName = this.fboProfileDetail ? this.fboProfileDetail.firstName : '';
            this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.lastName = this.fboProfileDetail ? this.fboProfileDetail.lastName : '';
            this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.distributorId = this.fboProfileDetail ? this.fboProfileDetail.fboId : '';
            this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.emailAddress = this.fboProfileDetail ? this.fboProfileDetail.email : '';
            this.memberRetailSubscriptionDetail.storeId = this.storeInfo ? this.storeInfo.id : null;
            this.memberRetailSubscriptionDetail.appPlanMapperId = this.chargeBeePlan ? this.chargeBeePlan.id : '';
            this.memberRetailSubscriptionDetail.planCode = this.chargeBeePlan ? this.chargeBeePlan.code : '';
            this.memberRetailSubscriptionDetail.operatingCompanyId = this.storeInfo ? this.storeInfo.businessEntityId : null;
            this.memberRetailSubscriptionDetail.subscriptionStatus = 157;
        }
    };
    FBOProfileComponent.prototype.getRetailSubscriptionDetail = function (id) {
        var _this = this;
        this._retailSubscriptionService.getRetailSubscriptionBasedOnId(id).subscribe(function (detail) {
            if (detail && detail.isSuccess) {
                if (detail && detail.validations && detail.validations.length && (detail.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                    var addedNotification = _this._translatePipe.get('errorcodes.' + detail.validations[0].message);
                    _this.isSubscriptionCreatedInChargebee = detail.isSuccess;
                    _this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                }
                _this.memberRetailSubscriptionDetail = detail;
                _this.retailSubscriptionLanguageId = detail.memberRetailProgramSubscriptionModel.retailLanguagesConfigID;
            }
        });
    };
    FBOProfileComponent.prototype.resendSignupEmail = function (distributorId) {
        var _this = this;
        this._retailSubscriptionService.resendSignupEmail(distributorId).subscribe(function (response) {
            if (response && response.isSuccess) {
                var notification = _this._translatePipe.get('customer-service.Sign up email has been resent');
                _this.addConfirmationMessage(RetailSubscriptionMessages.successMessage, notification.value);
            }
            else {
                if (response && response.validations && response.validations.length && (response.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                    var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].message);
                    _this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                }
                else {
                    _this.resendSignupErrMessage();
                }
            }
        }, function () {
            _this.resendSignupErrMessage();
        });
    };
    FBOProfileComponent.prototype.resendSignupErrMessage = function () {
        var addedNotification = this._translatePipe.get('errorcodes.Error occurred while resending the signup email for distributor id {{distributorId}}', {
            distributorId: this.fboProfileDetail ? this.fboProfileDetail.distributorId : ""
        });
        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
    };
    FBOProfileComponent.prototype.sendAcceptTermsEmail = function (distributorId) {
        var _this = this;
        if (this.memberRetailSubscriptionDetail && (this.memberRetailSubscriptionDetail.subscriptionStatus != this.subscriptionStatusEnum.Cancelled)) {
            this._retailSubscriptionService.resendTermsAndConditionsEmail(distributorId).subscribe(function (response) {
                if (response && response.isSuccess) {
                    var notification = _this._translatePipe.get('customer-service.Accept terms email has been sent');
                    _this.addConfirmationMessage(RetailSubscriptionMessages.successMessage, notification.value);
                }
                else {
                    if (response && response.validations && response.validations.length && response.validations.length && (response.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                        var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].message);
                        _this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                    }
                    else {
                        _this.sendAcceptTermsErrMessage();
                    }
                }
            }, function () {
                _this.sendAcceptTermsErrMessage();
            });
        }
    };
    FBOProfileComponent.prototype.sendAcceptTermsErrMessage = function () {
        var addedNotification = this._translatePipe.get('errorcodes.Error occurred while resending the terms and conditions for distributor id {{distributorId}}', {
            distributorId: this.fboProfileDetail ? this.fboProfileDetail.distributorId : ""
        });
        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
    };
    FBOProfileComponent.prototype.sendChangePaymentLinkEmail = function (distributorId) {
        var _this = this;
        if (this.memberRetailSubscriptionDetail && (this.memberRetailSubscriptionDetail.subscriptionStatus != this.subscriptionStatusEnum.Cancelled)) {
            this._retailSubscriptionService.sendPaymentChangeLinkEmail(distributorId).subscribe(function (response) {
                if (response && response.isSuccess) {
                    var notification = _this._translatePipe.get('customer-service.Change payment email has been sent');
                    _this.addConfirmationMessage(RetailSubscriptionMessages.successMessage, notification.value);
                }
                else {
                    if (response && response.validations && response.validations.length && (response.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                        var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].message);
                        _this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                    }
                    else {
                        _this.sendChangePaymentLinkErrMessage();
                    }
                }
            }, function () {
                _this.sendChangePaymentLinkErrMessage();
            });
        }
    };
    FBOProfileComponent.prototype.sendChangePaymentLinkErrMessage = function () {
        var addedNotification = this._translatePipe.get('errorcodes.Error occurred while sending payment change link for distributor id {{distributorId}}', {
            distributorId: this.fboProfileDetail ? this.fboProfileDetail.distributorId : ""
        });
        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
    };
    FBOProfileComponent.prototype.cancelRenewalSubscription = function (distributorId) {
        var _this = this;
        this.cancelRenewalPopup.close();
        var updatedBy;
        var userId = localStorage.getItem('appadmin.UserId');
        if (userId) {
            updatedBy = +userId;
        }
        this._retailSubscriptionService.cancelRenewalRetailSubscription(distributorId, updatedBy).subscribe(function (response) {
            if (response.isSuccess) {
                var notification = _this._translatePipe.get('customer-service.Subscription renewal has been cancelled');
                _this.addConfirmationMessage(RetailSubscriptionMessages.successMessage, notification.value);
            }
            else {
                if (response && response.validations && response.validations.length && (response.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                    var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].message);
                    _this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                }
                else {
                    _this.cancelRenewalSubscriptionErrMessage();
                }
            }
        }, function () {
            _this.cancelRenewalSubscriptionErrMessage();
        });
    };
    FBOProfileComponent.prototype.cancelRenewalSubscriptionErrMessage = function () {
        var addedNotification = this._translatePipe.get('errorcodes.Error occurred while cancelling subscription renewal for distributor id {{distributorId}}', {
            distributorId: this.fboProfileDetail ? this.fboProfileDetail.distributorId : ""
        });
        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
    };
    FBOProfileComponent.prototype.cancelSubscription = function (distributorId) {
        var _this = this;
        this.cancelSubscriptionPopup.close();
        var updatedBy;
        if (localStorage.getItem('appadmin.UserId')) {
            updatedBy = +(localStorage.getItem('appadmin.UserId'));
        }
        this._retailSubscriptionService.cancelRetailSubscription(distributorId, updatedBy).subscribe(function (response) {
            if (response.isSuccess) {
                var notification = _this._translatePipe.get('customer-service.Subscription has been cancelled');
                _this.addConfirmationMessage(RetailSubscriptionMessages.successMessage, notification.value);
                _this.retailSubscriptionForm.controls['subscriptionStatus'].patchValue(SubscriptionStatusEnum[_this.subscriptionStatusEnum.Cancelled]);
                _this.memberRetailSubscriptionDetail.subscriptionStatus = _this.subscriptionStatusEnum.Cancelled;
                _this.showSubscriptionHistoryLink = false;
            }
            else {
                if (response && response.validations && response.validations.length && (response.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                    var addedNotification = _this._translatePipe.get('errorcodes.' + response.validations[0].message);
                    _this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                }
                else {
                    _this.cancelSubscriptionErrMessage();
                }
            }
        }, function () {
            _this.cancelSubscriptionErrMessage();
        });
    };
    FBOProfileComponent.prototype.cancelSubscriptionErrMessage = function () {
        var addedNotification = this._translatePipe.get('errorcodes.Error occurred while cancelling the subscription for distributor id {{distributorId}}', {
            distributorId: this.fboProfileDetail ? this.fboProfileDetail.distributorId : ""
        });
        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
    };
    FBOProfileComponent.prototype.getVatId = function () {
        var _this = this;
        if (!this.memberGovernmentIdentifiations && !this.memberGovernmentIdentifiations.length && this.fboProfileDetail && this.fboProfileDetail.memberId) {
            this.getMembergovernmentIdentificationsInfo(this.fboProfileDetail.memberId);
        }
        if (this.memberGovernmentIdentifiations.length && this.fboProfileDetail.homeCountryId) {
            var memberGovernmentIdentifiation = this.memberGovernmentIdentifiations.find(function (x) { return x.governmentIdentificationType === 'VAT ID' && x.countryID === _this.fboProfileDetail.homeCountryId; });
            if (memberGovernmentIdentifiation && memberGovernmentIdentifiation.value) {
                this.vatId = memberGovernmentIdentifiation.value;
            }
        }
        else {
            if (this.fboBusinessEntity.incomeTaxID) {
                this.vatId = this.fboBusinessEntity.incomeTaxID;
            }
        }
        return this.vatId || null;
    };
    FBOProfileComponent.prototype.getLanguage = function (languageId) {
        var _this = this;
        if (languageId) {
            var language = this.languages ? this.languages.find(function (x) { return x.id === languageId; }) : '';
            if (language && language.languageCulture) {
                this.configId = language.id;
                return this.languageLocale = language.languageCulture;
            }
        }
        else if (this.languagecode) {
            var language = this.languages ? this.languages.find(function (x) { return x.languageCulture.toUpperCase() === _this.languagecode.toUpperCase(); }) : '';
            if (language && language.id) {
                this.configId = language.id;
                return this.languageLocale = language.languageCulture;
            }
            else {
                this.configId = '';
            }
        }
    };
    FBOProfileComponent.prototype.getCountryById = function (countryId) {
        if (countryId && this.countries && this.countries.length) {
            var countryInfo = this.countries.find(function (country) { return country.countryId === countryId; });
            return countryInfo && countryInfo.name ? countryInfo.name : '';
        }
    };
    FBOProfileComponent.prototype.addConfirmationMessage = function (className, message) {
        var _this = this;
        if (className && message) {
            this.showConfirmationMessage = true;
            this.confirmationClass = className;
            this.confirmationMessage = message;
            $('.retail-subscription .modal.in').animate({ scrollTop: 0, scrollLeft: 0 }, 'slow');
            if (this.isSubscriptionCreatedInChargebee != null && !this.isSubscriptionCreatedInChargebee) {
                setTimeout(function () {
                    _this.showConfirmationMessage = false;
                    _this.confirmationClass = null;
                    _this.confirmationMessage = null;
                }, 10000);
            }
        }
    };
    FBOProfileComponent.prototype.getChargeBeeConfiguration = function () {
        var src = 'https://js.chargebee.com/v2/chargebee.js';
        var script = document.createElement('script');
        if (script) {
            script.setAttribute('src', src);
            document.head.appendChild(script);
        }
        script.onload = function () {
            Chargebee.init({
                site: environment.chargebeeSiteName,
                publishableKey: environment.chargebeePublishableKey
            });
        };
    };
    FBOProfileComponent.prototype.openBillingHistory = function () {
        var _this = this;
        this._cacheService.set(CacheKey.IsRefreshed, true);
        var customerId = this.fboProfileDetail.fboId;
        return this._retailSubscriptionService.createChargeBeeSession(customerId).subscribe(function (res) {
            if (res) {
                _this.openChageBeePopUp(res);
            }
            else {
                _this._commonService.createNotification('', res.validations[0].message, NotificationType.ERROR);
            }
        }, function (error) {
            _this._commonService.createNotification('', error.validations[0].message, NotificationType.ERROR);
        });
    };
    FBOProfileComponent.prototype.openChageBeePopUp = function (response) {
        var chargebeeInstance = Chargebee.getInstance();
        chargebeeInstance.setPortalSession(response);
        var cbPortal = chargebeeInstance.createChargebeePortal();
        cbPortal.openSection({
            sectionType: Chargebee.getPortalSections().BILLING_HISTORY
        });
    };
    FBOProfileComponent.prototype.openViewSubscriptionHistory = function () {
        var _this = this;
        if (this.showSubscriptionHistoryLink && this.memberRetailSubscriptionDetail && this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel
            && this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id) {
            this.retailSubscriptionHistoryResponse = [];
            this.loadRetailSubscriptionHistory = [];
            var retailSubscriptionId = +this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id;
            this._retailSubscriptionService.getRetailSubscriptionHistory(retailSubscriptionId).subscribe(function (response) {
                if (response.isSuccess && !!response.subscriptionHistoryModelList.length) {
                    _this.retailSubscriptionHistoryResponse = response.subscriptionHistoryModelList.slice();
                    _this.loadMore();
                    _this.viewSubscriptionHistoryPopup.open();
                }
                else {
                    if (!response.isSuccess && !!response.validations.length) {
                        var addedNotification = _this._translatePipe.get('errorcodes.Error occurred while retrieving subscription history');
                        _this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                    }
                }
            }, function (error) {
                var addedNotification = error && error.validations && !!error.validations.length ? _this._translatePipe.get('errorcodes.' + error.validations[0].message) : _this._translatePipe.get('errorcodes.Error occurred while retrieving subscription history');
                _this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value ? addedNotification.value : RetailSubscriptionMessages.Error_while_retriving_data_from_Retail_Subscription_History);
            });
        }
    };
    FBOProfileComponent.prototype.closeViewSubscriptionHistory = function () {
        this.viewSubscriptionHistoryPopup.close();
    };
    FBOProfileComponent.prototype.loadMore = function () {
        if (!!this.retailSubscriptionHistoryResponse.length && (this.loadRetailSubscriptionHistory.length != this.retailSubscriptionHistoryResponse.length)) {
            var res = [];
            for (var i = this.loadRetailSubscriptionHistory.length; i < (this.loadRetailSubscriptionHistory.length + this.skipCount); i++) {
                if (!this.retailSubscriptionHistoryResponse[i])
                    break;
                res.push(this.retailSubscriptionHistoryResponse[i]);
            }
            this.loadRetailSubscriptionHistory = this.loadRetailSubscriptionHistory.concat(res);
            this.navigateToSubscriptionMessages((this.loadRetailSubscriptionHistory.length - 1).toString());
        }
    };
    FBOProfileComponent.prototype.navigateToSubscriptionMessages = function (idName) {
        setTimeout(function () {
            var el = document.getElementById(idName);
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 500);
    };
    Object.defineProperty(FBOProfileComponent.prototype, "currenyFormatValue", {
        /**
         * To Get Currency Value for the price
         */
        get: function () {
            var _this = this;
            return function (value) {
                if (_this.storeInfo) {
                    value = _this._currencyPipe.getCurrencyFormat(_this.storeInfo, _this.storeInfo.currencyFormatCode, value);
                    return value;
                }
                return value;
            };
        },
        enumerable: true,
        configurable: true
    });
    FBOProfileComponent.prototype.showAccountRestrictionPopup = function () {
        var _this = this;
        var fboId = this.fboProfileDetail ? this.fboProfileDetail.fboId : null;
        this._retailSubscriptionService.getAccountStatus(fboId).subscribe(function (response) {
            if (response && response.status === AccountRestrictionStatus.RESTRICTED) {
                _this.isAccountChecked = true;
            }
            else {
                _this.isAccountChecked = false;
            }
        });
        this.accountRestrictionModal.open();
    };
    FBOProfileComponent.prototype.submitAccountRestrictionPopup = function (event) {
        var _this = this;
        if (event === 'Checked') {
            this.accountStatus = AccountRestrictionStatus.RESTRICTED;
        }
        else {
            this.accountStatus = AccountRestrictionStatus.UN_RESTRICTED;
        }
        var accountRestrictionData = {
            distributorID: this.fboProfileDetail ? this.fboProfileDetail.fboId : null,
            status: this.accountStatus,
            createdBy: this.userId,
            updatedBy: this.userId,
            rowStatusID: 1
        };
        this._retailSubscriptionService.accountRestriction(accountRestrictionData).subscribe(function (response) {
            _this._commonService.createNotification('', 'Account has been Updated Successfully', NotificationType.SUCCESS);
            _this.cancelAccountRestrictionPopup();
        });
    };
    FBOProfileComponent.prototype.cancelAccountRestrictionPopup = function () {
        this.accountRestrictionModal.close();
    };
    FBOProfileComponent.prototype.isFpcUser = function () {
        if (this.memberType && (this.memberType.toLowerCase() == MemberType.PREFERREDCUSTOMER.toLowerCase() || this.memberType.toLowerCase() == MemberType.FPC.toLowerCase() || this.memberType.toLowerCase() === MemberType.PREFERRED_CUSTOMER.toLowerCase())) {
            this.isPrefferedCustomer = true;
        }
    };
    FBOProfileComponent.prototype.openBondedWarehouseProjectModal = function () {
        this.bondedWarehouseProjectModal.open();
        this.bwpDisableMessage = true;
        this.checkVatIdAndBusinessEntityIdExist();
        this.bondedWarehouseProjectSelected = this.prevBondedWarehouseProjectSelected;
    };
    FBOProfileComponent.prototype.submitBondedWarehouseProject = function () {
        var _this = this;
        if (this.bondedWarehouseProjectSelected !== this.prevBondedWarehouseProjectSelected) {
            if (this.storeInfo && this.storeInfo.bwpEnabled) {
                var memberMedaDataModel = [];
                memberMedaDataModel.push({
                    id: null,
                    memberId: this.fboProfileDetail.memberId,
                    customKey: MemberMetaDataEnum.BWPENABLED,
                    customValue: this.bondedWarehouseProjectSelected ? BondedWarehouseProjectValue.SELECTED : BondedWarehouseProjectValue.UN_SELECTED,
                    keyValueDescription: null
                });
                this._enrollService.updateBondedWarehouseProject(this.fboProfileDetail.memberId, memberMedaDataModel).subscribe(function (response) {
                    if (response && response.isSuccess) {
                        if (_this.bwpDisableMessage) {
                            _this._commonService.createNotification('', 'Bonded Warehouse Project Updated Successfully', NotificationType.SUCCESS);
                        }
                        _this.closeBWPModal();
                        _this.prevBondedWarehouseProjectSelected = _this.bondedWarehouseProjectSelected;
                    }
                    else {
                        _this._commonService.createNotification('', 'Updated Failed', NotificationType.ERROR);
                        _this.closeBWPModal();
                    }
                });
            }
        }
    };
    FBOProfileComponent.prototype.closeBWPModal = function () {
        this.bondedWarehouseProjectModal.close();
    };
    FBOProfileComponent.prototype.checkVatIdAndBusinessEntityIdExist = function () {
        var _this = this;
        if (((this.fboBusinessEntity && this.fboBusinessEntity.status === RowStatus.Active) && (this.fboBusinessEntity.countryCodeId === this.fboProfileDetail.homeCountryId) ||
            (this.memberGovernmentIdentifiations && this.memberGovernmentIdentifiations.find(function (element) { return (element.countryID === _this.fboProfileDetail.homeCountryId); })))) {
            this.disableBondedWarehouseProject = true;
            this.prevBondedWarehouseProjectSelected = false;
            this.bwpDisableMessage = false;
        }
        else {
            this.disableBondedWarehouseProject = false;
        }
    };
    FBOProfileComponent.prototype.checkBondedWarehouseProject = function (governmentIdForm, isValid) {
        var _this = this;
        if (this.vatIdBWP) {
            var governmentIdentificationForm = this.updateGovIDForm.get('govermentIdentification');
            var country = governmentIdentificationForm.value.find(function (elements) { return elements.country == _this.homeCountry; });
            if ((!this.disableBondedWarehouseProject && this.prevBondedWarehouseProjectSelected) && country) {
                this.bwpConfirmationModal.open();
            }
            else {
                this.checkGovernmentIdValue(governmentIdForm, isValid);
            }
        }
        else if (this.businessEntityBWP) {
            if (!this.disableBondedWarehouseProject && this.prevBondedWarehouseProjectSelected && ((this.businessEntityForm.value.countryCodeId === this.homeCountryId)) && this.businessEntityForm.value.status === RowStatus.Active.toString()) {
                this.bwpConfirmationModal.open();
            }
            else {
                this.checkBusinessEntitySubmit();
            }
        }
    };
    FBOProfileComponent.prototype.submitBWPConformation = function () {
        if (this.vatIdBWP) {
            this.checkGovernmentIdValue(this.updateGovIDForm.value, this.updateGovIDForm.valid);
            this.bwpConfirmationModal.close();
        }
        else if (this.businessEntityBWP) {
            this.checkBusinessEntitySubmit();
            this.bwpConfirmationModal.close();
        }
    };
    FBOProfileComponent.prototype.cancelBWPConformation = function () {
        this.bwpConfirmationModal.close();
    };
    FBOProfileComponent.prototype.checkMemberHomeCountryTitanEnabledcountry = function (homeCountry) {
        if (this.titanEnabledCountries && this.titanEnabledCountries.find(function (country) { return country.isocodeThree == homeCountry; })) {
            this.updateAccessToTitanCounty = true;
        }
        else {
            this.updateAccessToTitanCounty = !(this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC || this.fboProfileDetail.memberTypeId === this.memberTypeEnum.DISTRIBUTOR);
        }
    };
    FBOProfileComponent.prototype.populateTransliterateObj = function () {
        var languageCode = this._commonService.getMemberPrefferedLanguage(this.fboProfileDetail, this.storeInfo);
        return __assign({}, this._commonService.mapTransliterateProperties(this.storeInfo, languageCode));
    };
    FBOProfileComponent.prototype.getMembergovernmentIdentificationsInfo = function (memberId) {
        var _this = this;
        if (memberId) {
            this._customerservice.getMembergovernment_identifications(this.fboProfileDetail.memberId).subscribe(function (response) {
                if (response && response.memberGovernmentIdentificationModel) {
                    _this.memberGovernmentIdentifiations = response.memberGovernmentIdentificationModel;
                }
                else {
                    _this.memberGovernmentIdentifiations = [];
                }
            });
        }
    };
    FBOProfileComponent.prototype.getMemberBusinessEntityInfo = function (memberId, countryCode, prefferedLanguageId) {
        var _this = this;
        this._customerService.getMemberbusinessEntity(memberId, countryCode, prefferedLanguageId).subscribe(function (res) {
            if (res) {
                if (res.startDate) {
                    res.startDate = moment(res.startDate, 'DD-MM-YYYY').format('DD-MMM-YYYY');
                }
                _this.fboBusinessEntity = res;
            }
            return res;
        });
    };
    FBOProfileComponent.prototype.downloadImageFromUrl = function (url) {
        var _this = this;
        var hostname = new URL(url).hostname;
        if (hostname !== CommonConstant.AS400ProfileImageURL) {
            var path = new URL(url).pathname.slice(1);
            var s3Path = path.slice(0, path.lastIndexOf("/") + 1);
            var fileName = url.substring(url.lastIndexOf('/') + 1);
            var folderName_1 = s3Path + fileName;
            var cdnURL_1 = JSON.parse(this._cacheService.get(CacheKey.CDNurlForProfileImage)) != null ? new Map(JSON.parse(this._cacheService.get(CacheKey.CDNurlForProfileImage))) : new Map();
            var isProfileImageAvailable = this.checkValidityForSignedURL(cdnURL_1, this.fboid);
            if (isProfileImageAvailable === true) {
                this.profileImage = new Map(JSON.parse(this._cacheService.get(CacheKey.CDNurlForProfileImage))).get(this.fboid).toString();
            }
            else {
                this._customerService.generateProfileImageSignedCDNURL(folderName_1)
                    .subscribe(function (response) {
                    if (response.isSuccess === true && response.validations.length === 0 && response.data != null) {
                        _this.profileImage = response.data[folderName_1];
                        cdnURL_1.set(_this.fboid, _this.profileImage);
                        _this._cacheService.set(CacheKey.CDNurlForProfileImage, JSON.stringify(Array.from(cdnURL_1.entries())));
                    }
                    else {
                        _this.profileImage = _this.getStaticImageUrl();
                        var notificationMessage = 'Could not load profile picture, Please try after some time';
                        _this._commonService.createNotification('', notificationMessage, NotificationType.ERROR);
                    }
                }, function (error) {
                    _this.profileImage = _this.getStaticImageUrl();
                    var notificationMessage = 'Could not load profile picture, Please try after some time';
                    _this._commonService.createNotification('', notificationMessage, NotificationType.ERROR);
                });
            }
        }
    };
    FBOProfileComponent.prototype.checkValidityForSignedURL = function (cdnURL, folderName) {
        var result = false;
        if (cdnURL != null && cdnURL.has(folderName) === true) {
            var expirytimeFromParam = new URL(cdnURL.get(folderName)).searchParams.get("Expires");
            var expiryTime = new Date(expirytimeFromParam * 1000);
            result = (expiryTime.getTime() > new Date().getTime());
        }
        return result;
    };
    FBOProfileComponent.prototype.createUserDetailsInFlp360Realm = function () {
        var _this = this;
        this._customerService.createUserInFlp360Realm(this.fboid).subscribe(function (response) {
            if (response && response.isSuccess) {
                _this.isUserCreatedInKeycloak = true;
            }
        }, function (error) {
        });
    };
    return FBOProfileComponent;
}());
export { FBOProfileComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/fboprofile.component.ts.pre-build-optimizer.js